module.exports = {
	"ca": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Parapent)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Afegeix nou..."
		},
		"Airspace": {
			"toggle menu": "Espai aeri"
		},
		"All": {
			"map menu humidity": "Tot"
		},
		"B. layer": {
			"map menu updrafts": "Capa límit"
		},
		"B. Layer": {
			"map menu wind": "Capa Límit"
		},
		"Boundary layer": {
			"map menu wind": "Capa límit"
		},
		"Boundary Layer": {
			"map menu updrafts": "Capa Límit",
			"layer legend A": "Capa de límit",
			"layer legend B": "Capa de límit"
		},
		"Ceiling": {
			"map menu updrafts": "Sostre",
			"layer legend B": "Sostre"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Sostre de capa límit"
		},
		"Change password": {
			"settings menu": "Canvia la contrasenya"
		},
		"Clouds": {
			"map menu humidity": "Núvols"
		},
		"Color blind": {
			"settings menu": "Daltònic"
		},
		"debug": {
			"settings menu": "depura"
		},
		"Delete": {
			"favorites menu": "Esborra"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Característiques experimentals"
		},
		"Favorites": {
			"menu title": "Favorits"
		},
		"Ground": {
			"map menu wind": "Terra",
			"map menu temperature": "Terra"
		},
		"Help us translate!": {
			"settings menu": "Ajuda'ns a traduir!"
		},
		"High": {
			"map menu humidity": "Alt"
		},
		"Humidity": {
			"map menu humidity": "Humitat"
		},
		"Interpolation": {
			"toggle menu": "Interpolació"
		},
		"Language": {
			"settings menu": "Idioma"
		},
		"Login": {
			"login menu": "Iniciar sessió"
		},
		"Logout": {
			"settings menu": "Tancar sessió"
		},
		"Low": {
			"map menu humidity": "Baix"
		},
		"Medium": {
			"map menu humidity": "Mitjà"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapent"
		},
		"Move to top": {
			"favorites menu": "Mou a la part superior"
		},
		"News": {
			"news menu": "Notícies"
		},
		"News!": {
			"news menu": "Notícies!"
		},
		"No data for this place": {
			"windgram view": "No hi ha dades per a aquest lloc"
		},
		"Open": {
			"favorites menu": "Obre"
		},
		"Pressure": {
			"map menu wind": "Pressió",
			"layer legend A": "Pressió"
		},
		"Rain": {
			"map menu humidity": "Pluja"
		},
		"Rename": {
			"favorites menu": "Reanomena"
		},
		"Reset all settings": {
			"settings menu": "Reinicia totes les configuracions"
		},
		"Sea level": {
			"map menu wind": "Nivell del mar"
		},
		"Set as homepage": {
			"favorites menu": "Estableix com a pàgina d'inici"
		},
		"Settings": {
			"settings menu": "Configuració"
		},
		"Shearing": {
			"map menu updrafts": "Cisallament",
			"layer legend B": "Cisallament"
		},
		"Sounding": {
			"windgram tab": "Sondeig"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Tèrmiques",
			"layer legend A": "Tèrmiques"
		},
		"Thickness": {
			"map menu updrafts": "Gruix",
			"layer legend B": "Gruix"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendències"
		},
		"Velocity": {
			"map menu updrafts": "Velocitat",
			"layer legend B": "Velocitat"
		},
		"Vertical motion": {
			"map menu updrafts": "Moviment vertical",
			"": "Moviment vertical"
		},
		"Wind": {
			"map menu wind": "Vent",
			"layer legend A": "Vent"
		},
		"Wind Shear": {
			"map menu wind": "Vent de cisalla",
			"layer legend A": "Vent de cisalla"
		},
		"Windgram": {
			"windgram tab": "Diagrama de vent"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "Senyora"
		},
		"dimensionless": {
			"layer unit": "adimensional"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superfície"
		},
		"Ceiling of BL": {
			"layer legend B": "Sostre de la CL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Coberta de núvols"
		},
		"Low altitude": {
			"layer legend B": "Baixa altitud"
		},
		"High altitude": {
			"layer legend B": "Alta altitud"
		},
		"Medium altitude": {
			"layer legend B": "Altitud mitjana"
		},
		"All altitudes": {
			"layer legend B": "Totes les altituds"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Moviment vertical"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitacions"
		},
		"1 hour": {
			"layer legend B": "1 hora"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Nivell del mar mitjà"
		},
		"Enter a name": {
			"new favorite prompt": "Introdueix un nom"
		},
		"Enter the new name": {
			"new favorite prompt": "Introdueix el nom nou"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Sobreescriu el favorit \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Esborrar el favorit \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Esteu segur que voleu reiniciar-ho tot?\nTOTES LES VOSTRES CONFIGURACIONS I FAVORITS ES PERDRAN PER SEMPRE!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Previsions meteorològiques pel vol lliure | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ajuda / Contacte / Sobre"
		},
		"Install now": {
			"version check": "Instal·la ara"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Previsions meteorològiques pel vol lliure"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente necessita una actualització"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente és ara mòbil!"
		},
		"Mobile app": "App mòbil",
		"No internet connexion": "No hi ha connexió a internet",
		"Community": "Comunitat",
		"Day selection": "Selecció del dia",
		"knots": "nusos",
		"mph": "mph",
		"Radiation": "Radiació",
		"Sun": "Sol",
		"Update": "Actualització",
		"Wind unit": "Unitat de vent",
		"An error has occured. Please try again.": {
			"popup": "S'ha produït un error. Siusplau torna-ho a provar."
		},
		"Click here to renew.": {
			"login popup": "Feu clic aquí per renovar."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Feu clic a l'enllaç dins del correu electrònic per canviar la vostra contrasenya."
		},
		"Close": {
			"popup": "Tanca",
			"general": "Tanca"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Els correus electrònics no són iguals o no són vàlids"
		},
		"Error! Bad login or password": {
			"login popup": "Error! Inici de sessió o contrasenya incorrectes"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Error! El vostre accés ha caducat el %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Si ets col·laborador, rebràs un correu electrònic."
		},
		"OK": {
			"popup": "D'acord",
			"general": "D'acord"
		},
		"One last step...": {
			"password popup": "Un últim pas..."
		},
		"Passwords must be the same": {
			"password popup": "Les contrasenyes han de ser les mateixes"
		},
		"Please log-in": {
			"login popup": "Si us plau inicieu sessió"
		},
		"Private device − stay connected": {
			"login popup": "Dispositiu privat: mantingueu-vos connectat"
		},
		"Read more…": {
			"contribute popup": "Llegeix més…"
		},
		"Reset your password": {
			"password popup": "Restablir la contrasenya"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Alguns proveïdors com Orange, GMX i Hotmail de vegades bloquegen els nostres correus electrònics. Si no rebeu res, poseu-vos en contacte amb support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Benvingut!"
		},
		"Same as device": {
			"timezone menu": "Igual que el dispositiu"
		},
		"Timezone": {
			"settings menu": "Fus horari"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiplicador"
		},
		"Points": {
			"xc planner": "Punts"
		},
		"Duration": {
			"xc planner": "Durada"
		},
		"Speed": {
			"xc planner": "Velocitat"
		},
		"Close flight": {
			"xc planner": "Vol tancat"
		},
		"Share": {
			"xc planner": "Compartir"
		},
		"Download": {
			"xc planner": "descarregar",
			"general": "descarregar"
		},
		"Preferences": {
			"xc planner": "Preferències"
		},
		"Reset": {
			"xc planner": "Restableix",
			"general": "Restableix"
		},
		"About": {
			"xc planner": "Sobre"
		},
		"Exit Fullscreen": {
			"toggle menu": "Sortir de pantalla completa"
		},
		"Fullscreen": {
			"toggle menu": "Pantalla completa"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner és una característica experimental.\nNomés està disponible des d'un ordinador, a meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancel · lar"
		},
		"Yes": {
			"general": "Sí"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Desa"
		},
		"Continue": {
			"general": "Continua"
		},
		"Original version": {
			"xc planner": "Versió original"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Molt piratejat per treballar a Meteo-Parapente, amb autorització de Tom. Gràcies!"
		},
		"League": {
			"xc planner": "Lliga"
		},
		"Distance units": {
			"xc planner": "Unitats de distància"
		},
		"Altitude units": {
			"xc planner": "Unitats d'altitud"
		},
		"Coordinates format": {
			"xc planner": "Format de coordenades"
		},
		"Turnpoint details": {
			"xc planner": "Detalls del punt d'inflexió"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nom de la ruta"
		},
		"Waypoint prefix": {
			"xc planner": "Prefix de waypoint"
		},
		"Lien": {
			"xc planner": "Enllaç"
		},
		"Paste link in email or IM": {
			"xc planner": "Enganxeu l'enllaç al correu electrònic o missatgeria instantània"
		},
		"Static image": {
			"xc planner": "Imatge estàtica"
		},
		"Open with XCTrack": {
			"xc planner": "Obriu amb XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Comparteix amb LocToMe: defineix com a ruta predeterminada"
		},
		"Go to": {
			"general": "Anar a"
		},
		"Error! Please try again later": {
			"update modal": "Error! Siusplau, intenta-ho més tard"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Premeu Restableix per restablir la ruta permanentment, premeu Cancel·la per mantenir la ruta."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Aquí teniu el vostre codi d'accés. Si us plau, guardeu-lo amb seguretat."
		},
		"Password:": {
			"contribute popup": "Contrasenya:"
		},
		"Thank you!": {
			"contribute popup": "Gràcies!"
		},
		"Username:": {
			"contribute popup": "Nom d'usuari:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesos Estàndard － %{currency} %{pricing}/mes"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesos Estudiant － %{currency} %{pricing}/mes"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesos de suport － %{currency} %{pricing}/mes"
		},
		"Tour of Europe": {
			"tab": "Volta per Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Gaudeix de les millors previsions cada dia. Meteo-Parapente pot existir gràcies a tu!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Aconsegueix entrada gratuïta a entrenaments meteorològics locals i trobades d'usuaris."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Uneix-te al club de col·laboradors de Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Trobeu-me un cop al mes per parlar de noves funcions i millores."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente pot existir gràcies a tu!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "El meu objectiu és oferir una eina de qualitat accessible a tots els pilots."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Donar suport al desenvolupament d'una eina de qualitat accessible a tots els pilots."
		},
		"and to the": {
			"startup terms": "i al"
		},
		"By using this application, you agree to the": {
			"startup terms": "En utilitzar aquesta aplicació, accepteu el"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Si el problema persisteix, poseu-vos en contacte amb support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente no utilitza cookies de seguiment"
		},
		"privacy policy": {
			"startup terms": "política de privacitat"
		},
		"terms of use": {
			"startup": "condicions d'ús"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "No es pot arribar als servidors de Meteo-Parapente. Comproveu la vostra connexió."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dies a la setmana estan reservats als socis"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Ja ets membre? Feu clic per restablir la vostra contrasenya"
		},
		"Become a member": {
			"contribute menu": "Fes-te soci",
			"popup": "Fes-te soci"
		},
		"Click here to learn the details": {
			"contest": "Feu clic aquí per conèixer els detalls"
		},
		"I am already a member": {
			"popup": "Ja en sóc soci"
		},
		"Learn more": {
			"contest": "Aprèn més"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente celebra el seu 10è aniversari."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Encara no ets membre? Feu clic per obtenir un codi d'accés"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "En aquesta ocasió, organitzem un concurs excepcional"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Es sortejarà un guanyador d'entre tots aquells que hagin adquirit o renovat una subscripció entre el setembre passat i el proper 30 de març."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Per guanyar: L'ALA DE PARAPENT DE LA TEVA Elecció!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Per veure %{ date }, inicieu sessió o feu-vos-hi membre."
		},
		"Win a paraglider!": {
			"contribute menu": "Guanya un parapent!"
		}
	},
	"cs": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Paragliding)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Přidat nový ..."
		},
		"Airspace": {
			"toggle menu": "Letové prostory"
		},
		"All": {
			"map menu humidity": "Vše"
		},
		"B. layer": {
			"map menu updrafts": "Mezní vrstva"
		},
		"B. Layer": {
			"map menu wind": "Mezní vrstva"
		},
		"Boundary layer": {
			"map menu wind": "Mezní vrstva"
		},
		"Boundary Layer": {
			"map menu updrafts": "Mezní vrstva",
			"layer legend A": "Mezní vrstva",
			"layer legend B": "Mezní vrstva"
		},
		"Ceiling": {
			"map menu updrafts": "Strop",
			"layer legend B": "Strop"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Strop vrstvy b."
		},
		"Change password": {
			"settings menu": "Změna hesla"
		},
		"Clouds": {
			"map menu humidity": "Oblačnost"
		},
		"Color blind": {
			"settings menu": "Vysoký kontrast"
		},
		"debug": {
			"settings menu": "ladit"
		},
		"Delete": {
			"favorites menu": "Smazat"
		},
		"experimental": {
			"settings menu": "experimentální"
		},
		"Experimental features": {
			"settings menu": "Experimentální funkce"
		},
		"Favorites": {
			"menu title": "Oblíbené"
		},
		"Ground": {
			"map menu wind": "Přízemní",
			"map menu temperature": "Přízemní"
		},
		"Help us translate!": {
			"settings menu": "Pomožte nám s překladem"
		},
		"High": {
			"map menu humidity": "Vysoká"
		},
		"Humidity": {
			"map menu humidity": "Vlhkost"
		},
		"Interpolation": {
			"toggle menu": "Interpolace"
		},
		"Language": {
			"settings menu": "Jazyk"
		},
		"Login": {
			"login menu": "Přihlášení"
		},
		"Logout": {
			"settings menu": "Odhlášení"
		},
		"Low": {
			"map menu humidity": "Nízká"
		},
		"Medium": {
			"map menu humidity": "Střední"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Posunout nahoru"
		},
		"News": {
			"news menu": "Novinky"
		},
		"News!": {
			"news menu": "Novinky!"
		},
		"No data for this place": {
			"windgram view": "Nejsou data pro tuto lokalitu"
		},
		"Open": {
			"favorites menu": "Otevřít"
		},
		"Pressure": {
			"map menu wind": "Tlak",
			"layer legend A": "Tlak"
		},
		"Rain": {
			"map menu humidity": "Srážky"
		},
		"Rename": {
			"favorites menu": "Přejmenovat"
		},
		"Reset all settings": {
			"settings menu": "Výchozí nastavení"
		},
		"Sea level": {
			"map menu wind": "Úrověň moře"
		},
		"Set as homepage": {
			"favorites menu": "Nastavit jako domovskou stránku"
		},
		"Settings": {
			"settings menu": "Nastavení"
		},
		"Shearing": {
			"map menu updrafts": "Stříhání",
			"layer legend B": "Stříhání"
		},
		"Sounding": {
			"windgram tab": "Výstup"
		},
		"Temperature": {
			"map menu temperature": "Teplota",
			"layer legend A": "Teplota"
		},
		"Thermals": {
			"map menu updrafts": "Stoupání",
			"layer legend A": "Termika"
		},
		"Thickness": {
			"map menu updrafts": "Tloušťka",
			"layer legend B": "Tloušťka"
		},
		"Updrafts": {
			"map menu updrafts": "Termika"
		},
		"Velocity": {
			"map menu updrafts": "Rychlost",
			"layer legend B": "Rychlost"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertikální pohyb",
			"": "Vertikální pohyb"
		},
		"Wind": {
			"map menu wind": "Vítr",
			"layer legend A": "Vítr"
		},
		"Wind Shear": {
			"map menu wind": "Střih větru",
			"layer legend A": "Střih větru"
		},
		"Windgram": {
			"windgram tab": "Vítr"
		},
		"m MSL": {
			"layer unit": "m nad mořem"
		},
		"m AGL": {
			"layer unit": "m nad zemí"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "bezrozměrný"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Povrch"
		},
		"Ceiling of BL": {
			"layer legend B": "Strop BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Oblačnost"
		},
		"Low altitude": {
			"layer legend B": "Nizká"
		},
		"High altitude": {
			"layer legend B": "Vysoká"
		},
		"Medium altitude": {
			"layer legend B": "Střední"
		},
		"All altitudes": {
			"layer legend B": "Vše"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m nad zemí"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikální pohyb"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Srážky"
		},
		"1 hour": {
			"layer legend B": "1 hodina"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Střední hladina moře"
		},
		"Enter a name": {
			"new favorite prompt": "Název"
		},
		"Enter the new name": {
			"new favorite prompt": "Nový název"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Přepsat oblíbenou položku \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Smazat oblíbenou položku \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Jsi si jistý, že chceš vše resetovat?\nVŠECHNA TVÁ NASTAVENÍ A OBLÍBENÉ BUDOU NA VŽDY SMAZÁNY!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Předpověď počasí pro volné létání | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Nápověda / Kontakt / O Aplikaci"
		},
		"Install now": {
			"version check": "Instalovat"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Předpověď počasí pro volné létání"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente vyžaduje aktualizaci."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente je již mobilní!\nPředpověď počasí speciálně navržená pro létání a paragliding.\n"
		},
		"Mobile app": "Mobilní aplikace",
		"No internet connexion": "Není připojení k internetu",
		"Community": "Společenství",
		"Day selection": "Výběr dne",
		"knots": "uzly",
		"mph": "mph",
		"Radiation": "Radiace",
		"Sun": "Sun",
		"Update": "Aktualizace",
		"Wind unit": "Větrná jednotka",
		"An error has occured. Please try again.": {
			"popup": "Došlo k chybě. Zkuste to prosím znovu."
		},
		"Click here to renew.": {
			"login popup": "Pro obnovení klikněte zde."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kliknutím na odkaz v e-mailu si můžete změnit heslo."
		},
		"Close": {
			"popup": "Zavřít",
			"general": "Zavřít"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-maily nejsou stejné nebo neplatné"
		},
		"Error! Bad login or password": {
			"login popup": "Chyba! Špatné přihlašovací jméno nebo heslo"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Chyba! Váš přístup vypršel dne %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Pokud jste přispěvatelem, obdržíte e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Poslední krok..."
		},
		"Passwords must be the same": {
			"password popup": "Hesla musí být stejná"
		},
		"Please log-in": {
			"login popup": "Přihlaste se prosím"
		},
		"Private device − stay connected": {
			"login popup": "Soukromé zařízení - zůstaňte ve spojení"
		},
		"Read more…": {
			"contribute popup": "Více informací..."
		},
		"Reset your password": {
			"password popup": "Obnovení hesla"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Někteří poskytovatelé, například Orange, GMX a Hotmail, někdy naše e-maily blokují. Pokud vám nic nepřijde, kontaktujte prosím support@meteo&#x2011;parapente.com."
		},
		"Welcome!": {
			"login popup": "Vítejte!"
		},
		"Same as device": {
			"timezone menu": "Stejné jako zařízení"
		},
		"Timezone": {
			"settings menu": "Časové pásmo"
		},
		"XC Planner": {
			"toggle menu": "Plánovač XC"
		},
		"Multiplier": {
			"xc planner": "Multiplikátor"
		},
		"Points": {
			"xc planner": "Body"
		},
		"Duration": {
			"xc planner": "Doba trvání"
		},
		"Speed": {
			"xc planner": "Rychlost"
		},
		"Close flight": {
			"xc planner": "Blízký let"
		},
		"Share": {
			"xc planner": "Sdílet"
		},
		"Download": {
			"xc planner": "Stáhnout",
			"general": "Stáhnout"
		},
		"Preferences": {
			"xc planner": "Předvolby"
		},
		"Reset": {
			"xc planner": "Obnovení",
			"general": "Obnovení"
		},
		"About": {
			"xc planner": "O stránkách"
		},
		"Exit Fullscreen": {
			"toggle menu": "Ukončení zobrazení na celou obrazovku"
		},
		"Fullscreen": {
			"toggle menu": "Celá obrazovka"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Plánovač XC je experimentální funkce.\nJe dostupná pouze z počítače na webu meteo-parapente.com."
		},
		"Cancel": {
			"general": "Zrušit"
		},
		"Yes": {
			"general": "Ano"
		},
		"No": {
			"general": "Ne"
		},
		"Save": {
			"general": "Uložit"
		},
		"Continue": {
			"general": "Pokračovat"
		},
		"Original version": {
			"xc planner": "Původní verze"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "S autorizací od Toma silně hacknuto pro práci v Meteo-Parapente. Děkujeme!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Jednotky vzdálenosti"
		},
		"Altitude units": {
			"xc planner": "Jednotky nadmořské výšky"
		},
		"Coordinates format": {
			"xc planner": "Formát souřadnic"
		},
		"Turnpoint details": {
			"xc planner": "Podrobnosti o bodu obratu"
		},
		"Format": {
			"xc planner": "Formát"
		},
		"Route name": {
			"xc planner": "Název trasy"
		},
		"Waypoint prefix": {
			"xc planner": "Předpona bodu cesty"
		},
		"Lien": {
			"xc planner": "Odkaz"
		},
		"Paste link in email or IM": {
			"xc planner": "Vložte odkaz do e-mailu nebo IM"
		},
		"Static image": {
			"xc planner": "Statický obrázek"
		},
		"Open with XCTrack": {
			"xc planner": "Otevřít pomocí XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Sdílet s LocToMe: nastavit jako výchozí trasu"
		},
		"Go to": {
			"general": "Přejít na"
		},
		"Error! Please try again later": {
			"update modal": "Chyba! Zkuste to prosím později"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Stisknutím tlačítka Obnovit trasu trvale resetujete, stisknutím tlačítka Zrušit trasu zachováte."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Zde je váš přístupový kód. Uschovejte si ho prosím."
		},
		"Password:": {
			"contribute popup": "Heslo:"
		},
		"Thank you!": {
			"contribute popup": "Děkujeme!"
		},
		"Username:": {
			"contribute popup": "Uživatelské jméno:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 měsíců Standard - %{currency} %{pricing} / měsíc"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 měsíců Student - %{currency} %{pricing} / měsíc"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 měsíců Příznivec - %{currency} %{pricing} / měsíc"
		},
		"Tour of Europe": {
			"tab": "Cestování po Evropě"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Užijte si nejlepší předpovědi každý den. Meteo-Parapente může existovat díky vám!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Získejte volný vstup na místní školení o počasí a setkání uživatelů."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Připojte se ke klubu přispěvatelů Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Jednou měsíčně se se mnou sejdete a probereme nové funkce a vylepšení."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente může existovat díky vám!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mým cílem je poskytnout kvalitní nástroj dostupný všem pilotům."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Podporovat vývoj kvalitního nástroje, který bude dostupný všem pilotům."
		},
		"and to the": {
			"startup terms": "a na"
		},
		"By using this application, you agree to the": {
			"startup terms": "Používáním této aplikace souhlasíte s"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Pokud problém přetrvává, kontaktujte support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente nepoužívá sledovací soubory cookie"
		},
		"privacy policy": {
			"startup terms": "zásady ochrany osobních údajů"
		},
		"terms of use": {
			"startup": "podmínky používání"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nelze se spojit se servery Meteo-Parapente. Zkontrolujte prosím své připojení."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dny v týdnu jsou vyhrazeny pro členy"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Jste již členem? Klikněte pro obnovení hesla"
		},
		"Become a member": {
			"contribute menu": "Staňte se členem",
			"popup": "Staňte se členem"
		},
		"Click here to learn the details": {
			"contest": "Kliknutím sem se dozvíte podrobnosti"
		},
		"I am already a member": {
			"popup": "Jsem již členem"
		},
		"Learn more": {
			"contest": "Zjistěte více"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente slaví 10. výročí."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Ještě nejste členem? Kliknutím získáte přístupový kód"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Při této příležitosti pořádáme výjimečnou soutěž."
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Ze všech, kteří si v období od loňského září do 30. března příštího roku zakoupili nebo obnovili předplatné, bude vylosován jeden výherce."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "K výhře: PARAGLIDISTICKÉ KŘÍDLO DLE VLASTNÍHO VÝBĚRU!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Chcete-li zobrazit %{ date }, přihlaste se nebo se staňte členem."
		},
		"Win a paraglider!": {
			"contribute menu": "Vyhrajte paragliding!"
		}
	},
	"de": {
		"(Kitesurf)": {
			"search result": "(Kitesurfen)"
		},
		"(Paragliding)": {
			"search result": "(Gleitschirmfliegen)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Hinzufügen"
		},
		"Airspace": {
			"toggle menu": "Luftraum\n"
		},
		"All": {
			"map menu humidity": "Alle\n"
		},
		"B. layer": {
			"map menu updrafts": "G.-schicht"
		},
		"B. Layer": {
			"map menu wind": "G.-schicht"
		},
		"Boundary layer": {
			"map menu wind": "Grenzschicht"
		},
		"Boundary Layer": {
			"map menu updrafts": "Grenzschicht",
			"layer legend A": "Grenzschicht",
			"layer legend B": "Grenzschicht"
		},
		"Ceiling": {
			"map menu updrafts": "Basishöhe",
			"layer legend B": "Decke"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Höhe der G.-schicht"
		},
		"Change password": {
			"settings menu": "Passwort ändern"
		},
		"Clouds": {
			"map menu humidity": "Wolken"
		},
		"Color blind": {
			"settings menu": "Kontrastmodus"
		},
		"debug": {
			"settings menu": "Debug"
		},
		"Delete": {
			"favorites menu": "Löschen\n"
		},
		"experimental": {
			"settings menu": "Experimentell"
		},
		"Experimental features": {
			"settings menu": "Betafunktionen"
		},
		"Favorites": {
			"menu title": "Favoriten"
		},
		"Ground": {
			"map menu wind": "Boden",
			"map menu temperature": "Boden\n"
		},
		"Help us translate!": {
			"settings menu": "Übersetze für uns!"
		},
		"High": {
			"map menu humidity": "Hoch"
		},
		"Humidity": {
			"map menu humidity": "Luftfeuchtigkeit"
		},
		"Interpolation": {
			"toggle menu": "Glätten"
		},
		"Language": {
			"settings menu": "Sprache"
		},
		"Login": {
			"login menu": "Anmelden"
		},
		"Logout": {
			"settings menu": "Abmelden"
		},
		"Low": {
			"map menu humidity": "Niedrig"
		},
		"Medium": {
			"map menu humidity": "Mittel"
		},
		"Meteo Parapente": {
			"menu title": "Gleitschirmwetter"
		},
		"Move to top": {
			"favorites menu": "Nach oben schieben"
		},
		"News": {
			"news menu": "Neuigkeiten"
		},
		"News!": {
			"news menu": "Neuigkeiten!"
		},
		"No data for this place": {
			"windgram view": "Keine Daten für diesen Ort"
		},
		"Open": {
			"favorites menu": "Öffnen"
		},
		"Pressure": {
			"map menu wind": "Luftdruck",
			"layer legend A": "Luftdruck"
		},
		"Rain": {
			"map menu humidity": "Regen"
		},
		"Rename": {
			"favorites menu": "Umbenennen"
		},
		"Reset all settings": {
			"settings menu": "Alle Einstellungen zurücksetzen"
		},
		"Sea level": {
			"map menu wind": "Meereshöhe"
		},
		"Set as homepage": {
			"favorites menu": "Homepage eintragen"
		},
		"Settings": {
			"settings menu": "Einstellungen"
		},
		"Shearing": {
			"map menu updrafts": "Scherung",
			"layer legend B": "Scherung"
		},
		"Sounding": {
			"windgram tab": "Temps"
		},
		"Temperature": {
			"map menu temperature": "Temperatur",
			"layer legend A": "Temperatur"
		},
		"Thermals": {
			"map menu updrafts": "Thermik",
			"layer legend A": "Thermik"
		},
		"Thickness": {
			"map menu updrafts": "Dicke",
			"layer legend B": "Dicke"
		},
		"Updrafts": {
			"map menu updrafts": "Aufwinde"
		},
		"Velocity": {
			"map menu updrafts": "Steigwerte",
			"layer legend B": "Geschwindigkeit"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertikalbewegung",
			"": "Vertikalbewegung"
		},
		"Wind": {
			"map menu wind": "Wind",
			"layer legend A": "Wind"
		},
		"Wind Shear": {
			"map menu wind": "Windscherung",
			"layer legend A": "Windscherung"
		},
		"Windgram": {
			"windgram tab": "Winddiagramm"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Modell"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Keine Dimension"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Oberfläche"
		},
		"Ceiling of BL": {
			"layer legend B": "Obere Grenzschicht"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Wolkendecke"
		},
		"Low altitude": {
			"layer legend B": "Untere Schicht"
		},
		"High altitude": {
			"layer legend B": "Hohe Schicht"
		},
		"Medium altitude": {
			"layer legend B": "Mittlere Schicht"
		},
		"All altitudes": {
			"layer legend B": "Alle Höhen"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikale Bewegung"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Niederschläge"
		},
		"1 hour": {
			"layer legend B": "1 Stunde"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Normalnull"
		},
		"Enter a name": {
			"new favorite prompt": "Gib einen Namen ein"
		},
		"Enter the new name": {
			"new favorite prompt": "Gib einen neuen Namen ein"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Überschreibe Favorit \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Lösche Favorit \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Bist du sicher, dass du alles zurücksetzen willst?\nALL DEINE EINSTELLUNGEN UND FAVORITEN WERDEN UNWIDERRUFLICH GELÖSCHT!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Gleitsegelwettervorhersage | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Hilfe / Kontakt / Über"
		},
		"Install now": {
			"version check": "Jetzt installieren"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Gleitschirmwetter Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Gleitschirm Wetter Vorhersagen"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Gleitschirmwetter benötigt ein Update"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Gleitschirmwetter ist jetzt mobil verfügbar!\nWetter Vorhersagen speziell für Gleitschirmpiloten"
		},
		"Mobile app": "mobile App",
		"No internet connexion": "Keine Internetverbindung",
		"Community": "Gemeinschaft",
		"Day selection": "Tag",
		"knots": "knoten",
		"mph": "mph",
		"Radiation": "Strahlung",
		"Sun": "Sonnenschein",
		"Update": "Update",
		"Wind unit": "Geschwindigkeitsmaß",
		"An error has occured. Please try again.": {
			"popup": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
		},
		"Click here to renew.": {
			"login popup": "Klicken Sie hier, um zu verlängern."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Klicken Sie auf den Link in der E-Mail, um Ihr Passwort zu ändern."
		},
		"Close": {
			"popup": "Schließen",
			"general": "Schließen"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-Mails sind nicht gleich oder ungültig"
		},
		"Error! Bad login or password": {
			"login popup": "Fehler! Falsches Login oder Passwort"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Fehler! Ihr Zugang ist am %{ expirationDate } abgelaufen."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Wenn Sie ein Beitragszahler sind, erhalten Sie eine E-Mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Ein letzter Schritt..."
		},
		"Passwords must be the same": {
			"password popup": "Die Passwörter müssen identisch sein"
		},
		"Please log-in": {
			"login popup": "Bitte loggen Sie sich ein"
		},
		"Private device − stay connected": {
			"login popup": "Privates Gerät - in Verbindung bleiben"
		},
		"Read more…": {
			"contribute popup": "Lesen Sie mehr..."
		},
		"Reset your password": {
			"password popup": "Setzen Sie Ihr Passwort zurück"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Einige Anbieter wie Orange, GMX und Hotmail blockieren manchmal unsere E-Mails. Wenn Sie nichts erhalten, kontaktieren Sie bitte support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Willkommen!"
		},
		"Same as device": {
			"timezone menu": "Gleiches wie Gerät"
		},
		"Timezone": {
			"settings menu": "Zeitzone"
		},
		"XC Planner": {
			"toggle menu": "XC-Planer"
		},
		"Multiplier": {
			"xc planner": "Multiplikator"
		},
		"Points": {
			"xc planner": "Punkte"
		},
		"Duration": {
			"xc planner": "Dauer"
		},
		"Speed": {
			"xc planner": "Geschwindigkeit"
		},
		"Close flight": {
			"xc planner": "Flug beenden"
		},
		"Share": {
			"xc planner": "Teilen"
		},
		"Download": {
			"xc planner": "Herunterladen",
			"general": "herunterladen"
		},
		"Preferences": {
			"xc planner": "Voreinstellungen"
		},
		"Reset": {
			"xc planner": "Zurücksetzen",
			"general": "Zurücksetzen"
		},
		"About": {
			"xc planner": "Über"
		},
		"Exit Fullscreen": {
			"toggle menu": "Vollbild beenden"
		},
		"Fullscreen": {
			"toggle menu": "Vollbild"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner ist eine experimentelle Funktion. Sie ist nur von einem Computer aus verfügbar, auf meteo-parapente.com"
		},
		"Cancel": {
			"general": "Abbrechen"
		},
		"Yes": {
			"general": "Ja"
		},
		"No": {
			"general": "Nein"
		},
		"Save": {
			"general": "Speichern"
		},
		"Continue": {
			"general": "Weiter"
		},
		"Original version": {
			"xc planner": "Ursprüngliche Version"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Stark gehackt, um in Meteo-Parapente zu funktionieren, mit Genehmigung von Tom. Vielen Dank dafür!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Einheiten der Entfernung"
		},
		"Altitude units": {
			"xc planner": "Höheneinheiten"
		},
		"Coordinates format": {
			"xc planner": "Koordinaten-Format"
		},
		"Turnpoint details": {
			"xc planner": "Details zum Wendepunkt"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Name der Route"
		},
		"Waypoint prefix": {
			"xc planner": "Wegpunkt-Präfix"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Link in E-Mail oder IM einfügen"
		},
		"Static image": {
			"xc planner": "Statisches Bild"
		},
		"Open with XCTrack": {
			"xc planner": "Mit XCTrack öffnen"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Freigeben mit LocToMe: als Standardroute festlegen"
		},
		"Go to": {
			"general": "Weiter zu"
		},
		"Error! Please try again later": {
			"update modal": "Fehler! Bitte versuchen Sie es später noch einmal"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Drücken Sie Reset, um Ihre Route dauerhaft zurückzusetzen, drücken Sie Cancel, um Ihre Route zu behalten."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Hier ist Ihr Zugangscode. Bitte bewahren Sie ihn sicher auf."
		},
		"Password:": {
			"contribute popup": "Das Passwort:"
		},
		"Thank you!": {
			"contribute popup": "Dankeschön"
		},
		"Username:": {
			"contribute popup": "Benutzername:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 Monate Standard - %{currency} %{pricing} / Monat"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 Monate Student - %{currency} %{pricing} / Monat"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 Monate Supporter - %{currency} %{pricing} / Monat"
		},
		"Tour of Europe": {
			"tab": "Tour durch Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Genießen Sie jeden Tag die besten Vorhersagen. Meteo-Parapente kann nur dank Ihnen existieren!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Erhalten Sie freien Eintritt zu lokalen Wettertrainings und Nutzertreffen."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Werden Sie Mitglied im Club der Meteo-Parapente-Mitarbeiter"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Treffen Sie mich einmal im Monat, um neue Funktionen und Verbesserungen zu besprechen."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente kann nur dank Ihnen existieren!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mein Ziel ist es, ein qualitativ hochwertiges Programm für alle Piloten bereitzustellen."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Unterstützen Sie die Entwicklung eines Qualitätswerkzeugs, das für jeden Piloten zugänglich ist."
		},
		"and to the": {
			"startup terms": "und zum"
		},
		"By using this application, you agree to the": {
			"startup terms": "Durch die Nutzung dieser Anwendung erklären Sie sich mit den"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Wenn das Problem weiterhin besteht, wenden Sie sich an support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente verwendet keine Spionage-Cookies"
		},
		"privacy policy": {
			"startup terms": "Datenschutzbestimmungen"
		},
		"terms of use": {
			"startup": "Allgemeine Nutzungsbedingungen"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Die Server von Meteo-Parapente können nicht erreicht werden. Bitte überprüfen Sie Ihre Verbindung."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 Tage pro Woche sind für Mitglieder reserviert"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Sie sind bereits Mitglied? Klicken Sie, um Ihr Passwort zurückzusetzen"
		},
		"Become a member": {
			"contribute menu": "Mitglied werden",
			"popup": "Mitglied werden"
		},
		"Click here to learn the details": {
			"contest": "Klicken Sie hier, um die Details zu erfahren"
		},
		"I am already a member": {
			"popup": "Ich bin bereits Mitglied"
		},
		"Learn more": {
			"contest": "Mehr erfahren"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente feiert sein 10-jähriges Bestehen."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Noch kein Mitglied? Klicken Sie hier, um einen Zugangscode zu erhalten"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Aus diesem Anlass veranstalten wir einen außergewöhnlichen Wettbewerb"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Unter allen, die zwischen September letzten Jahres und dem 30. März nächsten Jahres ein Abonnement erworben oder verlängert haben, wird ein Gewinner ausgelost."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Zu gewinnen gibt es: DEN GLEITSCHIRMSCHIRM IHRER WAHL!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Um %{ date } zu sehen, melden Sie sich bitte an oder werden Sie Mitglied."
		},
		"Win a paraglider!": {
			"contribute menu": "Gewinnen Sie einen Gleitschirm!"
		}
	},
	"el": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "Αλεξίπτωτο πλαγιάς "
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Προσθήκη νέου"
		},
		"Airspace": {
			"toggle menu": "Ελεγχόμενος εναέριος χώρος "
		},
		"All": {
			"map menu humidity": "Όλα"
		},
		"B. layer": {
			"map menu updrafts": "Ο. στρώμα "
		},
		"B. Layer": {
			"map menu wind": "Ο. στρώμα␣ "
		},
		"Boundary layer": {
			"map menu wind": "Οριακό στρώμα "
		},
		"Boundary Layer": {
			"map menu updrafts": "Οριακό στρώμα ",
			"layer legend A": "Οριακό Στρώμα \n",
			"layer legend B": "Οριακό Στρώμα "
		},
		"Ceiling": {
			"map menu updrafts": "Οροφή ",
			"layer legend B": "Οροφή "
		},
		"Ceiling of b. layer": {
			"map menu wind": "Οροφή οριακού στρώματος "
		},
		"Change password": {
			"settings menu": "Αλλαγή password "
		},
		"Clouds": {
			"map menu humidity": "Σύννεφα "
		},
		"Color blind": {
			"settings menu": "Αχρωματοψία "
		},
		"debug": {
			"settings menu": "Αποσφαλμάτωση "
		},
		"Delete": {
			"favorites menu": "Διαγραφή "
		},
		"experimental": {
			"settings menu": "Πειραματικό "
		},
		"Experimental features": {
			"settings menu": "Πειραματικά χαρακτηριστικά "
		},
		"Ground": {
			"map menu wind": "Έδαφος ",
			"map menu temperature": "Έδαφος"
		},
		"Help us translate!": {
			"settings menu": " Βοηθήστε μας στη μετάφραση "
		},
		"High": {
			"map menu humidity": "Υψηλά"
		},
		"Humidity": {
			"map menu humidity": "Υγρασία "
		},
		"Interpolation": {
			"toggle menu": "Παρεμβολή "
		},
		"Language": {
			"settings menu": "Γλώσσα "
		},
		"Login": {
			"login menu": "Είσοδος "
		},
		"Logout": {
			"settings menu": "Έξοδος "
		},
		"Low": {
			"map menu humidity": "Χαμηλά"
		},
		"Medium": {
			"map menu humidity": "Μεσαία "
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Μετακίνηση στην κορυφή "
		},
		"News": {
			"news menu": "Νέα "
		},
		"News!": {
			"news menu": "Νέα!"
		},
		"No data for this place": {
			"windgram view": " Δεν υπάρχουν δεδομένα για αυτό το μέρος "
		},
		"Open": {
			"favorites menu": "Ανοικτό "
		},
		"Pressure": {
			"map menu wind": "Πίεση ",
			"layer legend A": "Πίεση "
		},
		"Rain": {
			"map menu humidity": "Βροχή "
		},
		"Rename": {
			"favorites menu": "Μετονομασία"
		},
		"Reset all settings": {
			"settings menu": "Επαναφορά όλων των ρυθμίσεων "
		},
		"Sea level": {
			"map menu wind": "Επίπεδο θάλασσας "
		},
		"Set as homepage": {
			"favorites menu": "Ορίστε ως αρχική σελίδα "
		},
		"Settings": {
			"settings menu": "Ρυθμίσεις "
		},
		"Shearing": {
			"map menu updrafts": "Διάτμηση ",
			"layer legend B": "Διάτμηση "
		},
		"Sounding": {
			"windgram tab": "Ραδιοβόληση"
		},
		"Temperature": {
			"map menu temperature": "Θερμοκρασία ",
			"layer legend A": "Θερμοκρασία "
		},
		"Thermals": {
			"map menu updrafts": "Θερμικά ",
			"layer legend A": "Θερμικά "
		},
		"Thickness": {
			"map menu updrafts": "Πάχος ",
			"layer legend B": "Πάχος "
		},
		"Updrafts": {
			"map menu updrafts": "Ανοδικά "
		},
		"Velocity": {
			"map menu updrafts": "Ταχύτητα  ",
			"layer legend B": "Ταχύτητα "
		},
		"Vertical motion": {
			"map menu updrafts": "Κάθετη κίνηση ",
			"": "Κάθετη κίνηση "
		},
		"Wind": {
			"map menu wind": "Άνεμος ",
			"layer legend A": "Άνεμος "
		},
		"Wind Shear": {
			"map menu wind": "Διάτμηση ανέμου ",
			"layer legend A": "Διάτμηση Ανέμου "
		},
		"Windgram": {
			"windgram tab": "Γράφημα ανέμου \n"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Τοπογραφία "
		},
		"Model": {
			"layer legend B": "Μοντέλο "
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Χωρίς διαστάσεις "
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Επιφάνεια "
		},
		"Ceiling of BL": {
			"layer legend B": "Οροφή Ο.Σ."
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Νεφοκάλυψη "
		},
		"Low altitude": {
			"layer legend B": "Χαμηλό ύψος "
		},
		"High altitude": {
			"layer legend B": "Υψηλό ύψος "
		},
		"Medium altitude": {
			"layer legend B": "Μεσαίο ύψος "
		},
		"All altitudes": {
			"layer legend B": "Όλα τα ύψη "
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Κάθετη Κίνηση "
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Βροχοπτώσεις "
		},
		"1 hour": {
			"layer legend B": "1 ώρα "
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Απόλυτο επίπεδο θαλάσσης "
		},
		"Enter a name": {
			"new favorite prompt": "Προσθέστε ένα όνομα "
		},
		"Enter the new name": {
			"new favorite prompt": "Προσθέστε ένα νέο όνομα "
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Επικάλυψη  αγαπημένου  \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Διαγραφή αγαπημένου  \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Εισαι βέβαιος ότι θες να επαναφέρεις όλες τις ρυθμίσεις?\nΟΛΕΣ ΣΟΥ ΟΙ ΡΥΘΜΊΣΕΙΣ ΚΑΙ ΤΑ ΑΓΑΠΗΜΈΝΑ ΘΑ ΔΙΑΓΡΑΦΟΥΝ ΓΙΑ ΠΆΝΤΑ! "
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Πρόγνωση καιρού ανεμοπορίας"
		},
		"Help / Contact / About": {
			"menu": "Βοήθεια/  Επικοινωνία/ Περί "
		},
		"Install now": {
			"version check": "Εγκατάσταση τώρα"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Πρόγνωση καιρού ανεμοπορίας "
		},
		"Meteo-Parapente requires an update.": {
			"version check": " χρειάζεται μία αναβάθμιση. "
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Το Meteo-Parapente είναι τώρα εύχρηστο !\nΠρόγνωση καιρού ανεμοπορίας ειδικά σχεδιασμένη για πτήση και Παρα5 "
		},
		"Mobile app": "Εφαρμογή κινητού ",
		"No internet connexion": "Δεν υπάρχει σύνδεση internet",
		"Community": "Κοινότητα ",
		"Day selection": "Επιλογή ημέρας ",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Ακτινοβολία ",
		"Sun": "Ήλιος ",
		"Update": "Αναβάθμιση ",
		"Wind unit": "Μονάδες ανέμου ",
		"An error has occured. Please try again.": {
			"popup": "Παρουσιάστηκε ένα σφάλμα. Παρακαλώ δοκιμάστε πάλι.\n"
		},
		"Click here to renew.": {
			"login popup": "Κλίκαρε εδώ για ανανέωση "
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Κλικάρετε στο link μέσα στο email για να αλλάξεις το password."
		},
		"Close": {
			"popup": "Κλείσιμο ",
			"general": "Κλείσιμο "
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Τα email δεν είναι ίδια ή δεν ισχύουν "
		},
		"Error! Bad login or password": {
			"login popup": "Σφάλμα! Λαθος κατά την είσοδο ή στο password"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Σφάλμα! Η πρόσβαση σας έχει λήξει την  %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Εάν είσαι χορηγός, θα λάβεις ένα email."
		},
		"OK": {
			"popup": "Οκ",
			"general": "Οκ"
		},
		"One last step...": {
			"password popup": "Ένα τελευταίο βήμα..."
		},
		"Passwords must be the same": {
			"password popup": "Τα password πρέπει να είναι τα ίδια "
		},
		"Please log-in": {
			"login popup": "Παρακαλώ συνδεθείτε "
		},
		"Private device − stay connected": {
			"login popup": "Ιδιωτική  συσκευή- παραμείνετε συνδεδεμένος "
		},
		"Read more…": {
			"contribute popup": "Διαβάστε περισσότερα..."
		},
		"Reset your password": {
			"password popup": "Επαναφέρετε  το password σας"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Μερικοί πάροχοι όπως Orange, GMX και Hotmail μερικές φορές μπλοκάρουν  τα e-mail  μας.\nΕάν δεν λάβετε κάτι επικοινωνήστε \nsupport@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Καλώς ήλθατε! "
		},
		"Same as device": {
			"timezone menu": "Ίδιο με την συσκευή "
		},
		"Timezone": {
			"settings menu": "Ζώνη ώρας "
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Πολλαπλασιαστής "
		},
		"Points": {
			"xc planner": "Πόντοι "
		},
		"Duration": {
			"xc planner": "Διάρκεια "
		},
		"Speed": {
			"xc planner": "Ταχύτητα "
		},
		"Close flight": {
			"xc planner": "Κλείσε την πτήση "
		},
		"Share": {
			"xc planner": "Μοιράσου "
		},
		"Download": {
			"xc planner": "Κατέβασε ",
			"general": "Κατέβασε "
		},
		"Preferences": {
			"xc planner": "Προτιμήσεις "
		},
		"Reset": {
			"xc planner": "Επαναφορά ",
			"general": "Επαναφορά "
		},
		"About": {
			"xc planner": "Περί "
		},
		"Exit Fullscreen": {
			"toggle menu": "Έξοδος από πλήρη οθόνη "
		},
		"Fullscreen": {
			"toggle menu": "Πλήρης οθόνη "
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Το XC Planner είναι μία πειραματική λειτουργία. Είναι διαθέσιμη από pc μέσω meteo-parapente.com"
		},
		"Cancel": {
			"general": "Ακυρωση6"
		},
		"Yes": {
			"general": "Ναί"
		},
		"No": {
			"general": "Οχι"
		},
		"Save": {
			"general": "Αποθήκευση "
		},
		"Continue": {
			"general": "Συνέχεια "
		},
		"Original version": {
			"xc planner": "Επίσημη έκδοση "
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Ζόρικα  χακευμένο για να δουλεύει στο\n  Meteo-Parapente,με την άδεια του Tom.Ευχαριστ"
		},
		"League": {
			"xc planner": "Πρωτάθλημα "
		},
		"Distance units": {
			"xc planner": "Μονάδες απόστασης "
		},
		"Altitude units": {
			"xc planner": "Μονάδες υψομέτρου "
		},
		"Coordinates format": {
			"xc planner": "Μορφή συντεταγμένων "
		},
		"Turnpoint details": {
			"xc planner": "Λεπτομέρειες πυλώνων "
		},
		"Format": {
			"xc planner": "Μορφή "
		},
		"Route name": {
			"xc planner": "Όνομα διαδρομής "
		},
		"Waypoint prefix": {
			"xc planner": "Πρόθεμα πυλώνων "
		},
		"Lien": {
			"xc planner": "Σύνδεσμος "
		},
		"Paste link in email or IM": {
			"xc planner": "Αντιγράψτε το link σε e mail ή messenger "
		},
		"Static image": {
			"xc planner": "Στατική εικόνα "
		},
		"Open with XCTrack": {
			"xc planner": "Άνοιγμα με XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Μοιράσου με LocToMe:όρισε ως προκαθορισμένη διαδρομή"
		},
		"Go to": {
			"general": "Πήγαινε σε"
		},
		"Error! Please try again later": {
			"update modal": "Σφάλμα!  Παρακαλώ δοκιμάστε πάλι αργότερα "
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Πατήστε Επαναφορά για να επαναφέρετε την διαδρομή σας μόνιμα, πατήστε Ακύρωση για να κρατήσετε την διαδρομή .\n"
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Εδώ είναι ο κωδικός σας.Παρακαλώ κρατήστε τον ασφαλή. "
		},
		"Password:": {
			"contribute popup": "Password:"
		},
		"Thank you!": {
			"contribute popup": "Ευχαριστούμε! "
		},
		"Username:": {
			"contribute popup": "Username:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12μηνες βασικό － %{currency} %{pricing} / μήνα "
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 μήνες  Σπουδαστής － %{currency} %{pricing} /  μήνα "
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 μηνός υποστηρικτής-  Supporter － %{currency} %{pricing} /μήνα "
		},
		"Tour of Europe": {
			"tab": "Γύρος της Ευρώπης "
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Απολαύστε τις καλύτερες προβλέψεις κάθε μέρα. Το Meteo-Parapente μπορεί να υπάρχει χάρη σε εσάς!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Αποκτήστε δωρεάν είσοδο σε τοπικές προπονήσεις καιρού και συναντήσεις χρηστών."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Εγγραφείτε στο κλαμπ των συνεργατών του Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Συναντήστε με μία φορά το μήνα για να συζητήσουμε νέα χαρακτηριστικά και βελτιώσεις."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Η Meteo-Parapente μπορεί να υπάρξει χάρη σε εσάς!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Στόχος μου είναι να παρέχω ένα ποιοτικό εργαλείο προσβάσιμο σε κάθε πιλότο."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Υποστήριξη της ανάπτυξης ενός ποιοτικού εργαλείου προσβάσιμου σε κάθε πιλότο."
		},
		"and to the": {
			"startup terms": "και στο"
		},
		"By using this application, you agree to the": {
			"startup terms": "Με τη χρήση αυτής της εφαρμογής, συμφωνείτε με"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Εάν το πρόβλημα εξακολουθεί να υφίσταται, επικοινωνήστε με το support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Η Meteo-Parapente δεν χρησιμοποιεί cookies παρακολούθησης"
		},
		"privacy policy": {
			"startup terms": "πολιτική απορρήτου"
		},
		"terms of use": {
			"startup": "όροι χρήσης"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Αδυναμία πρόσβασης στους διακομιστές Meteo-Parapente. Ελέγξτε τη σύνδεσή σας."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 ημέρες την εβδομάδα προορίζονται για τα μέλη"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Είστε ήδη μέλος; Κάντε κλικ για να επαναφέρετε τον κωδικό πρόσβασής σας"
		},
		"Become a member": {
			"contribute menu": "Γίνετε μέλος",
			"popup": "Γίνετε μέλος"
		},
		"Click here to learn the details": {
			"contest": "Κάντε κλικ εδώ για να μάθετε τις λεπτομέρειες"
		},
		"I am already a member": {
			"popup": "Είμαι ήδη μέλος"
		},
		"Learn more": {
			"contest": "Μάθετε περισσότερα"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Η Meteo-Parapente γιορτάζει τη 10η επέτειό της."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Δεν είστε ακόμα μέλος; Κάντε κλικ για να λάβετε έναν κωδικό πρόσβασης"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Με την ευκαιρία αυτή, διοργανώνουμε έναν εξαιρετικό διαγωνισμό"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Ένας νικητής θα κληρωθεί μεταξύ όλων όσοι αγόρασαν ή ανανέωσαν τη συνδρομή τους από τον περασμένο Σεπτέμβριο έως τις 30 Μαρτίου του επόμενου έτους."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Για να κερδηθεί: ΤΗΝ ΠΤΈΡΥΓΑ ΑΛΕΞΊΠΤΩΤΟΥ ΠΛΑΓΙΆΣ ΤΗΣ ΕΠΙΛΟΓΉΣ ΣΑΣ!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Για να δείτε %{ date }, συνδεθείτε ή γίνετε μέλος."
		},
		"Win a paraglider!": {
			"contribute menu": "Κερδίστε ένα αλεξίπτωτο πλαγιάς!"
		}
	},
	"en": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Paragliding)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Add new…"
		},
		"Airspace": {
			"toggle menu": "Airspace"
		},
		"All": {
			"map menu humidity": "All"
		},
		"B. layer": {
			"map menu updrafts": "B. layer"
		},
		"B. Layer": {
			"map menu wind": "B. Layer"
		},
		"Boundary layer": {
			"map menu wind": "Boundary layer"
		},
		"Boundary Layer": {
			"map menu updrafts": "Boundary Layer",
			"layer legend A": "Boundary Layer",
			"layer legend B": "Boundary Layer"
		},
		"Ceiling": {
			"map menu updrafts": "Ceiling",
			"layer legend B": "Ceiling"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Ceiling of b. layer"
		},
		"Change password": {
			"settings menu": "Change password"
		},
		"Clouds": {
			"map menu humidity": "Clouds"
		},
		"Color blind": {
			"settings menu": "Color blind"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Delete"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Experimental features"
		},
		"Favorites": {
			"menu title": "Favorites"
		},
		"Ground": {
			"map menu wind": "Ground",
			"map menu temperature": "Ground"
		},
		"Help us translate!": {
			"settings menu": "Help us translate!"
		},
		"High": {
			"map menu humidity": "High"
		},
		"Humidity": {
			"map menu humidity": "Humidity"
		},
		"Interpolation": {
			"toggle menu": "Interpolation"
		},
		"Language": {
			"settings menu": "Language"
		},
		"Login": {
			"login menu": "Login"
		},
		"Logout": {
			"settings menu": "Logout"
		},
		"Low": {
			"map menu humidity": "Low"
		},
		"Medium": {
			"map menu humidity": "Medium"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Move to top"
		},
		"News": {
			"news menu": "News"
		},
		"News!": {
			"news menu": "News!"
		},
		"No data for this place": {
			"windgram view": "No data for this place"
		},
		"Open": {
			"favorites menu": "Open"
		},
		"Pressure": {
			"map menu wind": "Pressure",
			"layer legend A": "Pressure"
		},
		"Rain": {
			"map menu humidity": "Rain"
		},
		"Rename": {
			"favorites menu": "Rename"
		},
		"Reset all settings": {
			"settings menu": "Reset all settings"
		},
		"Sea level": {
			"map menu wind": "Sea level"
		},
		"Set as homepage": {
			"favorites menu": "Set as homepage"
		},
		"Settings": {
			"settings menu": "Settings"
		},
		"Shearing": {
			"map menu updrafts": "Shearing",
			"layer legend B": "Shearing"
		},
		"Sounding": {
			"windgram tab": "Sounding"
		},
		"Temperature": {
			"map menu temperature": "Temperature",
			"layer legend A": "Temperature"
		},
		"Thermals": {
			"map menu updrafts": "Thermals",
			"layer legend A": "Thermals"
		},
		"Thickness": {
			"map menu updrafts": "Thickness",
			"layer legend B": "Thickness"
		},
		"Updrafts": {
			"map menu updrafts": "Updrafts"
		},
		"Velocity": {
			"map menu updrafts": "Velocity",
			"layer legend B": "Velocity"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertical motion",
			"": "Vertical motion"
		},
		"Wind": {
			"map menu wind": "Wind",
			"layer legend A": "Wind"
		},
		"Wind Shear": {
			"map menu wind": "Wind Shear",
			"layer legend A": "Wind Shear"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topography"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimensionless"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Surface"
		},
		"Ceiling of BL": {
			"layer legend B": "Ceiling of BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Cloud cover"
		},
		"Low altitude": {
			"layer legend B": "Low altitude"
		},
		"High altitude": {
			"layer legend B": "High altitude"
		},
		"Medium altitude": {
			"layer legend B": "Medium altitude"
		},
		"All altitudes": {
			"layer legend B": "All altitudes"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Vertical Motion"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitations"
		},
		"1 hour": {
			"layer legend B": "1 hour"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Mean Sea Level"
		},
		"Enter a name": {
			"new favorite prompt": "Enter a name"
		},
		"Enter the new name": {
			"new favorite prompt": "Enter the new name"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Overwrite favorite \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Delete favorite \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Soaring weather forecasts | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Help / Contact / About"
		},
		"Install now": {
			"version check": "Install now"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Soaring Weather Forecasts"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente requires an update."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding."
		},
		"Mobile app": "Mobile app",
		"No internet connexion": "No internet connexion",
		"Community": "Community",
		"Day selection": "Day selection",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Radiation",
		"Sun": "Sun",
		"Update": "Update",
		"Wind unit": "Wind unit",
		"An error has occured. Please try again.": {
			"popup": "An error has occured. Please try again."
		},
		"Click here to renew.": {
			"login popup": "Click here to renew."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Click on the link inside the email to change your password."
		},
		"Close": {
			"popup": "Close",
			"general": "Close"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Emails are not the same or invalid"
		},
		"Error! Bad login or password": {
			"login popup": "Error! Bad login or password"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Error! Your access has expired on %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "If you are a contributor, you will receive an email."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "One last step..."
		},
		"Passwords must be the same": {
			"password popup": "Passwords must be the same"
		},
		"Please log-in": {
			"login popup": "Please log-in"
		},
		"Private device − stay connected": {
			"login popup": "Private device − stay connected"
		},
		"Read more…": {
			"contribute popup": "Read more…"
		},
		"Reset your password": {
			"password popup": "Reset your password"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Welcome!"
		},
		"Same as device": {
			"timezone menu": "Same as device"
		},
		"Timezone": {
			"settings menu": "Timezone"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiplier"
		},
		"Points": {
			"xc planner": "Points"
		},
		"Duration": {
			"xc planner": "Duration"
		},
		"Speed": {
			"xc planner": "Speed"
		},
		"Close flight": {
			"xc planner": "Close flight"
		},
		"Share": {
			"xc planner": "Share"
		},
		"Download": {
			"xc planner": "Download",
			"general": "Download"
		},
		"Preferences": {
			"xc planner": "Preferences"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "About"
		},
		"Exit Fullscreen": {
			"toggle menu": "Exit Fullscreen"
		},
		"Fullscreen": {
			"toggle menu": "Fullscreen"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancel"
		},
		"Yes": {
			"general": "Yes"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Save"
		},
		"Continue": {
			"general": "Continue"
		},
		"Original version": {
			"xc planner": "Original version"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!"
		},
		"League": {
			"xc planner": "League"
		},
		"Distance units": {
			"xc planner": "Distance units"
		},
		"Altitude units": {
			"xc planner": "Altitude units"
		},
		"Coordinates format": {
			"xc planner": "Coordinates format"
		},
		"Turnpoint details": {
			"xc planner": "Turnpoint details"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Route name"
		},
		"Waypoint prefix": {
			"xc planner": "Waypoint prefix"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Paste link in email or IM"
		},
		"Static image": {
			"xc planner": "Static image"
		},
		"Open with XCTrack": {
			"xc planner": "Open with XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Share with LocToMe: set as default route"
		},
		"Go to": {
			"general": "Go to"
		},
		"Error! Please try again later": {
			"update modal": "Error! Please try again later"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Press Reset to reset your route permanently, press Cancel to keep you route."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Here is your access code. Please keep it safely."
		},
		"Password:": {
			"contribute popup": "Password:"
		},
		"Thank you!": {
			"contribute popup": "Thank you!"
		},
		"Username:": {
			"contribute popup": "Username:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 months Standard － %{currency} %{pricing} / month"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 months Student － %{currency} %{pricing} / month"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 months Supporter － %{currency} %{pricing} / month"
		},
		"Tour of Europe": {
			"tab": "Tour of Europe"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Get free entry to local weather trainings and users meetups."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Join Meteo-Parapente contributors club"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Meet me once a month to discuss new features and improvements."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente can exist thanks to you!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "My goal is to provide a quality tool accessible to every pilots."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Support the development of a quality tool accessible to every pilots."
		},
		"and to the": {
			"startup terms": "and to the"
		},
		"By using this application, you agree to the": {
			"startup terms": "By using this application, you agree to the"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "If the problem persists, contact support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente doesn't use tracking cookies"
		},
		"privacy policy": {
			"startup terms": "privacy policy"
		},
		"terms of use": {
			"startup": "terms of use"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Unable to reach Meteo-Parapente servers. Please check your connection."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 days a week are reserved to members"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Already a member? Click to reset your password"
		},
		"Become a member": {
			"contribute menu": "Become a member",
			"popup": "Become a member"
		},
		"Click here to learn the details": {
			"contest": "Click here to learn the details"
		},
		"I am already a member": {
			"popup": "I am already a member"
		},
		"Learn more": {
			"contest": "Learn more"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente celebrates its 10th anniversary."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Not a member yet? Click to get an access code"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "On this occasion, we are organizing an exceptional contest"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "To see %{ date }, please login or become a member."
		},
		"Win a paraglider!": {
			"contribute menu": "Win a paraglider!"
		}
	},
	"es": {
		"(Kitesurf)": {
			"search result": "Kite Surf"
		},
		"(Paragliding)": {
			"search result": "Parapente"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Añadir nuevo..."
		},
		"Airspace": {
			"toggle menu": "Espacio aéreo"
		},
		"All": {
			"map menu humidity": "todo"
		},
		"B. layer": {
			"map menu updrafts": "Capa lím."
		},
		"B. Layer": {
			"map menu wind": "Capa lím."
		},
		"Boundary layer": {
			"map menu wind": "Capa límite"
		},
		"Boundary Layer": {
			"map menu updrafts": "Capa límite",
			"layer legend A": "Capa límite",
			"layer legend B": "Capa límite"
		},
		"Ceiling": {
			"map menu updrafts": "Techo",
			"layer legend B": "Techo"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Techo de la capa lím."
		},
		"Change password": {
			"settings menu": "Cambiar contraseña"
		},
		"Clouds": {
			"map menu humidity": "Nubes"
		},
		"Color blind": {
			"settings menu": "Daltónico"
		},
		"debug": {
			"settings menu": "depurar"
		},
		"Delete": {
			"favorites menu": "Suprimir"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Funciones experimentales"
		},
		"Favorites": {
			"menu title": "Favoritos"
		},
		"Ground": {
			"map menu wind": "Suelo",
			"map menu temperature": "Suelo"
		},
		"Help us translate!": {
			"settings menu": "Ayúdanos a traducir!"
		},
		"High": {
			"map menu humidity": "Alto"
		},
		"Humidity": {
			"map menu humidity": "Humedad"
		},
		"Interpolation": {
			"toggle menu": "Interpolación"
		},
		"Language": {
			"settings menu": "Idioma"
		},
		"Login": {
			"login menu": "Iniciar sesión"
		},
		"Logout": {
			"settings menu": "Cerrar sesión"
		},
		"Low": {
			"map menu humidity": "Bajo"
		},
		"Medium": {
			"map menu humidity": "Medio"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "mover arriba"
		},
		"News": {
			"news menu": "Noticias"
		},
		"News!": {
			"news menu": "¡Noticias!"
		},
		"No data for this place": {
			"windgram view": "No hay datos para este lugar"
		},
		"Open": {
			"favorites menu": "Abrir"
		},
		"Pressure": {
			"map menu wind": "Presión",
			"layer legend A": "Presión"
		},
		"Rain": {
			"map menu humidity": "Lluvia"
		},
		"Rename": {
			"favorites menu": "Renombrar"
		},
		"Reset all settings": {
			"settings menu": "Restablecer ajustes"
		},
		"Sea level": {
			"map menu wind": "Nivel del mar"
		},
		"Set as homepage": {
			"favorites menu": "Establecer como página de inicio"
		},
		"Settings": {
			"settings menu": "Ajustes"
		},
		"Shearing": {
			"map menu updrafts": "Cizallamiento",
			"layer legend B": "Cizallamiento"
		},
		"Sounding": {
			"windgram tab": "Sondeo"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termicas",
			"layer legend A": "Termicas"
		},
		"Thickness": {
			"map menu updrafts": "Espesor",
			"layer legend B": "Espesor"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendencias"
		},
		"Velocity": {
			"map menu updrafts": "Velocidad",
			"layer legend B": "Velocidad"
		},
		"Vertical motion": {
			"map menu updrafts": "Movimiento vertical",
			"": "Movimiento vertical"
		},
		"Wind": {
			"map menu wind": "Viento",
			"layer legend A": "Viento"
		},
		"Wind Shear": {
			"map menu wind": "Cizalladura",
			"layer legend A": "Cizalladura"
		},
		"Windgram": {
			"windgram tab": "Diagrama de viento"
		},
		"m MSL": {
			"layer unit": "m MLS"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografía"
		},
		"Model": {
			"layer legend B": "Modelo"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Sin dimensiones"
		},
		"km/h": {
			"layer unit": "Km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superficie"
		},
		"Ceiling of BL": {
			"layer legend B": "Techo de C.L."
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Nubosidad"
		},
		"Low altitude": {
			"layer legend B": "baja"
		},
		"High altitude": {
			"layer legend B": "alta"
		},
		"Medium altitude": {
			"layer legend B": "media"
		},
		"All altitudes": {
			"layer legend B": "Total"
		},
		"°C": {
			"layer unit": "ºC"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Movimiento Vertical"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitaciones"
		},
		"1 hour": {
			"layer legend B": "1 hora"
		},
		"hPa": {
			"layer unit": "hpa"
		},
		"Mean Sea Level": {
			"layer legend B": "Nivel medio del mar"
		},
		"Enter a name": {
			"new favorite prompt": "Introduce nombre"
		},
		"Enter the new name": {
			"new favorite prompt": "Introduce nuevo nombre"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Sobrescribir favorito \"% {name}\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Eliminar favorito \"% {name}\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "¿Seguro que quieres restablecer todo?\n¡TODOS TUS AJUSTES Y FAVORITOS SE PERDERAN PARA SIEMPRE!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Pronóstico meteorológico para el vuelo | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ayuda / Contacto / A cerca de"
		},
		"Install now": {
			"version check": "Instala ahora"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "RASP Meteo-Parapente Europa"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Prediccion Meteorológica para Vuelo"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente necesita actualizarse."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "¡Meteo-Parapente ahora es móvil!\nPredicción Meteorológica especialmente diseñada para vuelo y parapente."
		},
		"Mobile app": "Aplicación móvil.",
		"No internet connexion": "Sin conexión a internet",
		"Community": "Comunidad",
		"Day selection": "Selección de días",
		"knots": "nudos",
		"mph": "mph",
		"Radiation": "Radiación",
		"Sun": "Sol",
		"Update": "Actualización",
		"Wind unit": "Unidad de viento",
		"An error has occured. Please try again.": {
			"popup": "Se ha producido un error. Por favor, inténtelo de nuevo."
		},
		"Click here to renew.": {
			"login popup": "Haga clic aquí para renovar."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Haga clic en el enlace del correo electrónico para cambiar su contraseña."
		},
		"Close": {
			"popup": "Cerrar",
			"general": "Cerrar"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Los correos electrónicos no son iguales o no son válidos"
		},
		"Error! Bad login or password": {
			"login popup": "¡Error! Nombre de usuario o contraseña incorrecta"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Error. Su acceso ha expirado en %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Si eres un colaborador, recibirás un correo electrónico."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Un último paso..."
		},
		"Passwords must be the same": {
			"password popup": "Las contraseñas deben ser las mismas"
		},
		"Please log-in": {
			"login popup": "Por favor, conéctese"
		},
		"Private device − stay connected": {
			"login popup": "Dispositivo privado: mantente conectado"
		},
		"Read more…": {
			"contribute popup": "Leer más..."
		},
		"Reset your password": {
			"password popup": "Restablecer la contraseña"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Algunos proveedores como Orange, GMX y Hotmail a veces bloquean nuestros correos electrónicos. Si no recibe nada, póngase en contacto con support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bienvenido."
		},
		"Same as device": {
			"timezone menu": "Igual que el dispositivo"
		},
		"Timezone": {
			"settings menu": "Zona horaria"
		},
		"XC Planner": {
			"toggle menu": "Planificador XC"
		},
		"Multiplier": {
			"xc planner": "Multiplicador"
		},
		"Points": {
			"xc planner": "Puntos"
		},
		"Duration": {
			"xc planner": "Duración"
		},
		"Speed": {
			"xc planner": "Velocidad"
		},
		"Close flight": {
			"xc planner": "Vuelo cercano"
		},
		"Share": {
			"xc planner": "Compartir"
		},
		"Download": {
			"xc planner": "Descargar",
			"general": "Descargar"
		},
		"Preferences": {
			"xc planner": "Preferencias"
		},
		"Reset": {
			"xc planner": "Reiniciar",
			"general": "Reiniciar"
		},
		"About": {
			"xc planner": "Acerca de"
		},
		"Exit Fullscreen": {
			"toggle menu": "Salir de la pantalla completa"
		},
		"Fullscreen": {
			"toggle menu": "Pantalla completa"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner es una función experimental.\nSólo está disponible desde un ordenador, en meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancelar"
		},
		"Yes": {
			"general": "Sí"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Guardar"
		},
		"Continue": {
			"general": "Continuar"
		},
		"Original version": {
			"xc planner": "Versión original"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Muy hackeado para trabajar en Meteo-Parapente, con autorización de Tom. Gracias."
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Unidades de distancia"
		},
		"Altitude units": {
			"xc planner": "Unidades de altitud"
		},
		"Coordinates format": {
			"xc planner": "Formato de las coordenadas"
		},
		"Turnpoint details": {
			"xc planner": "Detalles del punto de giro"
		},
		"Format": {
			"xc planner": "Formato"
		},
		"Route name": {
			"xc planner": "Nombre de la ruta"
		},
		"Waypoint prefix": {
			"xc planner": "Prefijo de la baliza"
		},
		"Lien": {
			"xc planner": "Enlace"
		},
		"Paste link in email or IM": {
			"xc planner": "Pegar el enlace en el correo electrónico o en la mensajería instantánea"
		},
		"Static image": {
			"xc planner": "Imagen estática"
		},
		"Open with XCTrack": {
			"xc planner": "Abrir con XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Compartir con LocToMe: establecer como ruta por defecto"
		},
		"Go to": {
			"general": "Ir a"
		},
		"Error! Please try again later": {
			"update modal": "¡Error! Por favor, inténtelo de nuevo más tarde"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Pulse Reiniciar para restablecer su ruta de forma permanente, pulse Cancelar para mantener su ruta."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Aquí tiene su código de acceso. Por favor, guárdelo de forma segura."
		},
		"Password:": {
			"contribute popup": "Contraseña:"
		},
		"Thank you!": {
			"contribute popup": "Gracias."
		},
		"Username:": {
			"contribute popup": "Nombre de usuario:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Estándar - %{currency} %{pricing} / mes"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Estudiante - %{currency} %{pricing} / mes"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Supporter - %{currency} %{pricing} / mes"
		},
		"Tour of Europe": {
			"tab": "Vuelta a Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Disfruta de las mejores previsiones cada día. ¡Meteo-Parapente puede existir gracias a ti!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Consigue una entrada gratuita a las formaciones meteorológicas locales y a los encuentros de usuarios."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Únase al club de colaboradores de Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Reúnete conmigo una vez al mes para hablar de las nuevas características y mejoras."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "¡Meteo-Parapente puede existir gracias a ti!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mi objetivo es ofrecer una herramienta de calidad accesible a todos los pilotos."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Apoyar el desarrollo de una herramienta de calidad accesible a todos los pilotos."
		},
		"and to the": {
			"startup terms": "y la"
		},
		"By using this application, you agree to the": {
			"startup terms": "Al utilizar esta aplicación, usted acepta las"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Si el problema persiste, póngase en contacto con support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente no utiliza cookies espía"
		},
		"privacy policy": {
			"startup terms": "política de privacidad"
		},
		"terms of use": {
			"startup": "condiciones generales de uso"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "No se puede acceder a los servidores de Meteo-Parapente. Por favor, compruebe su conexión."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 días a la semana están reservados a los socios"
		},
		"Already a member? Click to reset your password": {
			"login popup": "¿Ya es miembro? Haga clic para restablecer su contraseña"
		},
		"Become a member": {
			"contribute menu": "Hazte socio",
			"popup": "Hazte socio"
		},
		"Click here to learn the details": {
			"contest": "Haga clic aquí para conocer los detalles"
		},
		"I am already a member": {
			"popup": "Ya soy miembro"
		},
		"Learn more": {
			"contest": "Más información"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente celebra su décimo aniversario."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "¿Aún no es miembro? Haga clic para obtener un código de acceso"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "En esta ocasión, organizamos un concurso excepcional"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Se sorteará un ganador entre todos los que hayan adquirido o renovado una suscripción entre el pasado mes de septiembre y el próximo 30 de marzo."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Para ganar: ¡¡EL ALA DE PARAPENTE DE SU ELECCIÓN!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Para ver %{ date }, inicie sesión o hágase miembro."
		},
		"Win a paraglider!": {
			"contribute menu": "¡Gana un parapente!"
		}
	},
	"eu": {
		"(Kitesurf)": {
			"search result": "(Kitesurfa)"
		},
		"(Paragliding)": {
			"search result": "(Parapentea)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Gehitu berria"
		},
		"Airspace": {
			"toggle menu": "Aire eremua"
		},
		"All": {
			"map menu humidity": "Denak"
		},
		"B. layer": {
			"map menu updrafts": "O. Geruza"
		},
		"B. Layer": {
			"map menu wind": "O. Geruza"
		},
		"Boundary layer": {
			"map menu wind": "Geruzaren muga"
		},
		"Boundary Layer": {
			"map menu updrafts": "Geruzaren Muga",
			"layer legend A": "Geruza muga",
			"layer legend B": "Geruza limitea"
		},
		"Ceiling": {
			"map menu updrafts": "Sabaia",
			"layer legend B": "Sabaia"
		},
		"Ceiling of b. layer": {
			"map menu wind": "O. Geruzaren sabaia"
		},
		"Change password": {
			"settings menu": "Aldatu pasahitza"
		},
		"Clouds": {
			"map menu humidity": "Hodeiak"
		},
		"Color blind": {
			"settings menu": "Kolore ikusgaitza"
		},
		"debug": {
			"settings menu": "arazketa"
		},
		"Delete": {
			"favorites menu": "Ezabatu"
		},
		"experimental": {
			"settings menu": "esperimentala"
		},
		"Experimental features": {
			"settings menu": "Ezaugarri esperimentalak"
		},
		"Favorites": {
			"menu title": "Gogokoak"
		},
		"Ground": {
			"map menu wind": "Lurra",
			"map menu temperature": "Lurra"
		},
		"Help us translate!": {
			"settings menu": "Lagundu iezaguzu itzultzen!"
		},
		"High": {
			"map menu humidity": "Altua"
		},
		"Humidity": {
			"map menu humidity": "Hezetasuna"
		},
		"Interpolation": {
			"toggle menu": "Interpolatzea"
		},
		"Language": {
			"settings menu": "Hizkuntza"
		},
		"Login": {
			"login menu": "Sartu"
		},
		"Logout": {
			"settings menu": "Irten"
		},
		"Low": {
			"map menu humidity": "Bajua"
		},
		"Medium": {
			"map menu humidity": "Erdia"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Mugitu gora"
		},
		"News": {
			"news menu": "Berriak"
		},
		"News!": {
			"news menu": "Berriak!"
		},
		"No data for this place": {
			"windgram view": "Ez dago daturik toki honentzat"
		},
		"Open": {
			"favorites menu": "Ireki"
		},
		"Pressure": {
			"map menu wind": "Presioa",
			"layer legend A": "Presioa"
		},
		"Rain": {
			"map menu humidity": "Euria"
		},
		"Rename": {
			"favorites menu": "Berrizendatu"
		},
		"Reset all settings": {
			"settings menu": "Berregin parametro guztiak"
		},
		"Sea level": {
			"map menu wind": "Itsas maila"
		},
		"Set as homepage": {
			"favorites menu": "Hasierako orri egin"
		},
		"Settings": {
			"settings menu": "Ezarpenak"
		},
		"Shearing": {
			"map menu updrafts": "Zizailadura",
			"layer legend B": "zizaila"
		},
		"Sounding": {
			"windgram tab": "Zundaketa"
		},
		"Temperature": {
			"map menu temperature": "Tenperatura",
			"layer legend A": "Tenperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termikak",
			"layer legend A": "Termikak"
		},
		"Thickness": {
			"map menu updrafts": "Lodiera",
			"layer legend B": "Lodiera"
		},
		"Updrafts": {
			"map menu updrafts": "Goranzkoak"
		},
		"Velocity": {
			"map menu updrafts": "Abiadura",
			"layer legend B": "Abiadura"
		},
		"Vertical motion": {
			"map menu updrafts": "Mugimendu bertikala",
			"": "Mugimendu bertikala"
		},
		"Wind": {
			"map menu wind": "Haizea",
			"layer legend A": "Haizea"
		},
		"Wind Shear": {
			"map menu wind": "Haizearen zizailadura",
			"layer legend A": "Haizearen zizailadura"
		},
		"Windgram": {
			"windgram tab": "Gradientea"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Modeloa"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimentsiogabe"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Gainazala"
		},
		"Ceiling of BL": {
			"layer legend B": "BL-ren zizailadura"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Hodei estalkia"
		},
		"Low altitude": {
			"layer legend B": "Altuera baxua"
		},
		"High altitude": {
			"layer legend B": "Altuera gorena"
		},
		"Medium altitude": {
			"layer legend B": "Erdi maila"
		},
		"All altitudes": {
			"layer legend B": "Altuera guztiak"
		},
		"°C": {
			"layer unit": "ºC"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Mugimendu bertikala"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Prezipitazioak"
		},
		"1 hour": {
			"layer legend B": "Ordu 1"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Itsas maila"
		},
		"Enter a name": {
			"new favorite prompt": "Sartu izena"
		},
		"Enter the new name": {
			"new favorite prompt": "Izen berria sartu"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Berridatzi gogokoena \"%{ izena }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Ezabatu gogokoena \"%{ izena }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Ziur zaude dena berrabiarazi nahi duzula?\nMODIFIKAZIO ETA GOGOKO GUZTIAK BETIKO EZABATUKO DIRA!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Soaring Weather Forecasts - Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Laguntza / Kontaktua / Gutaz"
		},
		"Install now": {
			"version check": "Instalatu orain"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente RASP Europa"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Soaring Weather Forecasts"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapentek eguneratzea eskatzen du"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente orain mugikor bertsioan!\nEspreski zuzendua aire kirol eta parapenterako."
		},
		"Mobile app": "Mugikorrentzat app-a",
		"No internet connexion": "Internet konexiorik ez",
		"Community": "Komunitatea",
		"Day selection": "Eguna aukeratu",
		"knots": "korapiloak",
		"mph": "mph",
		"Radiation": "Irradiazioa",
		"Sun": "Eguzkia",
		"Update": "Eguneratu",
		"Wind unit": "Haize unitatea",
		"An error has occured. Please try again.": {
			"popup": "Errorea gertatu da. Arren, saiatu berriro."
		},
		"Click here to renew.": {
			"login popup": "Hemen klikatu berritzeko."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Email barneko loturan egizu klik pasahitza aldatzeko."
		},
		"Close": {
			"popup": "Itxi",
			"general": "Itxi"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Email baliogabea edo ez dira berdinak"
		},
		"Error! Bad login or password": {
			"login popup": "Errorea! erabiltzaile edo pasahitz okerrak"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Errorea! Zure sarbidea %{ expirationDate }n iraungi da."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Kolaboratzailea bazara, email bat jasoko duzu."
		},
		"OK": {
			"popup": "Ok",
			"general": "Ok"
		},
		"One last step...": {
			"password popup": "Azken pausua..."
		},
		"Passwords must be the same": {
			"password popup": "Pasahitzak berdina izan behar du"
		},
		"Please log-in": {
			"login popup": "Mesedez, hasi saioa"
		},
		"Private device − stay connected": {
			"login popup": "Gailu pribatua - konektatuta mantendu"
		},
		"Read more…": {
			"contribute popup": "Gehiago irakurri..."
		},
		"Reset your password": {
			"password popup": "Berrezarri pasahitza"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Zenbait hornitzailek, hala nola Orangek, GMXek eta Hotmail-ek, blokeatu egiten dituzte batzuetan gure mezu elektronikoak. Ezer jasotzen ez baduzu, jarri harremanetan support@the&#x2011;parapente.com-ekin"
		},
		"Welcome!": {
			"login popup": "Ongi etorri!"
		},
		"Same as device": {
			"timezone menu": "Gailuko bera"
		},
		"Timezone": {
			"settings menu": "Ordu zona"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Biderkatzailea"
		},
		"Points": {
			"xc planner": "Puntuak"
		},
		"Duration": {
			"xc planner": "Iraupena"
		},
		"Speed": {
			"xc planner": "Abiadura"
		},
		"Close flight": {
			"xc planner": "Hegaldia itxi"
		},
		"Share": {
			"xc planner": "Partekatu"
		},
		"Download": {
			"xc planner": "Jaitsi",
			"general": "Jaitsi"
		},
		"Preferences": {
			"xc planner": "Hobespenak"
		},
		"Reset": {
			"xc planner": "Berrezarri",
			"general": "Berrezarri"
		},
		"About": {
			"xc planner": "Honi buruz"
		},
		"Exit Fullscreen": {
			"toggle menu": "Pantaila osotik atera"
		},
		"Fullscreen": {
			"toggle menu": "Pantaila osoa"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner ezaugarri esperimentala da.\nOrdenagailu batetik bakarrik erabil daiteke, meteo-parapente.com-en"
		},
		"Cancel": {
			"general": "Ezeztatu"
		},
		"Yes": {
			"general": "Bai"
		},
		"No": {
			"general": "Ez"
		},
		"Save": {
			"general": "Gorde"
		},
		"Continue": {
			"general": "Jarraitu"
		},
		"Original version": {
			"xc planner": "Bertsio originala"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Meteo-parapentean lan egiteko hackeatze gogorra, Tom-en baimenarekin. Eskerrik asko!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Distantzia unitateak"
		},
		"Altitude units": {
			"xc planner": "Altuera-unitateak"
		},
		"Coordinates format": {
			"xc planner": "Koordenatuen formatua"
		},
		"Turnpoint details": {
			"xc planner": "Turnpoint-en xehetasunak"
		},
		"Format": {
			"xc planner": "Formatua"
		},
		"Route name": {
			"xc planner": "Ibilbidearen izena"
		},
		"Waypoint prefix": {
			"xc planner": "Waypoint aurrezenbakia"
		},
		"Lien": {
			"xc planner": "Lotura"
		},
		"Paste link in email or IM": {
			"xc planner": "Lotura emailean edota IMen itsatsi"
		},
		"Static image": {
			"xc planner": "Irudi estatikoa"
		},
		"Open with XCTrack": {
			"xc planner": "XCTrack-ekin ireki"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "LocToMe-rekin partekatu: ibilbide lehenetsi modura ezarri"
		},
		"Go to": {
			"general": "Hona joan"
		},
		"Error! Please try again later": {
			"update modal": "Errorea! Mesedez, berriro saitu beranduago."
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Sakatu Berrezarri zure ibilbidea modu iraunkorrean berrezartzeko, eta sakatu Baztertu ibilbidea mantentzeko."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Hemen da zure sarbide kodea. Mesedez, ongi gorde."
		},
		"Password:": {
			"contribute popup": "Pasahitza:"
		},
		"Thank you!": {
			"contribute popup": "Eskerrik asko!"
		},
		"Username:": {
			"contribute popup": "Erabiltzailea:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 hilabete Arrunta－ %{currency} %{pricing} / hileko"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 hilabete Ikaslea－ %{currency} %{pricing} / hileko"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 hilabete Laguntzailea－ %{currency} %{pricing} / hileko"
		},
		"Tour of Europe": {
			"tab": "Europako bira"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Gozatu iragarpen onenez egunero. Meteo-Parapentea zuri esker izan daiteke!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Tokiko entrenamendu meteorologikoetarako eta erabiltzaileen bileretarako sarrera doan lortu."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Meteo-Parapente kolaboratzaile klubarekin bat egin"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Hilean behin elkartu ezaugarri eta hobekuntza berriak eztabaidatzeko."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente zuri esker existitu daiteke!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Nire helburua  pilotu guztien eskura dagoen kalitatezko tresna bat eskaintzea da."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Pilotu guztientzat irisgarria den kalitateko tresna bat garatzen lagundu."
		},
		"and to the": {
			"startup terms": "eta"
		},
		"By using this application, you agree to the": {
			"startup terms": "Aplikazio hau erabiltzean, onartu egiten duzu"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Arazoak jarraituko balu, jarri harremanetan support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapentek ez ditu erregistro-cookieak erabiltzen"
		},
		"privacy policy": {
			"startup terms": "pribatutasun-politika"
		},
		"terms of use": {
			"startup": "erabilera baldintzak"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Ezin da Meteo-parapente zerbitzarietara iritsi. Mesedez, egiaztatu zure konexioa."
		},
		"2 days a week are reserved to members": {
			"private popup": "Astean 2 egun bazkideentzat gordeta daude"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Dagoeneko kide zara? Egin klik pasahitza berrezartzeko"
		},
		"Become a member": {
			"contribute menu": "Egin zaitez kide",
			"popup": "Egin zaitez kide"
		},
		"Click here to learn the details": {
			"contest": "Egin klik hemen xehetasunak ezagutzeko"
		},
		"I am already a member": {
			"popup": "Dagoeneko kide naiz"
		},
		"Learn more": {
			"contest": "Gehiago ikasi"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapentek bere 10. urteurrena ospatzen du."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Oraindik ez zara kide? Egin klik sarbide-kode bat lortzeko"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Oraingo honetan, aparteko lehiaketa bat antolatzen ari gara"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Irabazle bat zozketatuko da joan den irailetik datorren martxoaren 30era bitartean harpidetza erosi edo berritu zuten guztien artean."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Irabazi beharrekoa: ZUEK AUKERATUTAKO PARAPENTEA!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "%{ date } ikusteko, mesedez hasi saioa edo egin zaitez kide."
		},
		"Win a paraglider!": {
			"contribute menu": "Irabazi parapente bat!"
		}
	},
	"fr": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Parapente)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Nouveau…"
		},
		"Airspace": {
			"toggle menu": "Espaces aériens"
		},
		"All": {
			"map menu humidity": "Toutes alti"
		},
		"B. layer": {
			"map menu updrafts": "Couche Lim."
		},
		"B. Layer": {
			"map menu wind": "Couche Lim."
		},
		"Boundary layer": {
			"map menu wind": "Couche Limite"
		},
		"Boundary Layer": {
			"map menu updrafts": "Couche Limite",
			"layer legend A": "Couche Limite",
			"layer legend B": "Couche Limite"
		},
		"Ceiling": {
			"map menu updrafts": "Plafond",
			"layer legend B": "Plafond"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Plaf Couche Lim."
		},
		"Change password": {
			"settings menu": "Mot de passe"
		},
		"Clouds": {
			"map menu humidity": "Nuages"
		},
		"Color blind": {
			"settings menu": "Daltonien"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Supprimer"
		},
		"experimental": {
			"settings menu": "expérimental"
		},
		"Experimental features": {
			"settings menu": "Fonctions expérimentales"
		},
		"Favorites": {
			"menu title": "Favoris"
		},
		"Ground": {
			"map menu wind": "Sol",
			"map menu temperature": "2m Sol"
		},
		"Help us translate!": {
			"settings menu": "Aidez-nous à traduire !"
		},
		"High": {
			"map menu humidity": "Haute alti"
		},
		"Humidity": {
			"map menu humidity": "Humidité"
		},
		"Interpolation": {
			"toggle menu": "Interpolation"
		},
		"Language": {
			"settings menu": "Langue"
		},
		"Login": {
			"login menu": "Connexion"
		},
		"Logout": {
			"settings menu": "Déconnexion"
		},
		"Low": {
			"map menu humidity": "Basse alti"
		},
		"Medium": {
			"map menu humidity": "Moyenne alti"
		},
		"Meteo Parapente": {
			"menu title": "Météo Parapente"
		},
		"Move to top": {
			"favorites menu": "Placer en haut"
		},
		"News": {
			"news menu": "Actualités"
		},
		"News!": {
			"news menu": "Actualités !"
		},
		"No data for this place": {
			"windgram view": "Pas de données pour ce lieu"
		},
		"Open": {
			"favorites menu": "Ouvrir"
		},
		"Pressure": {
			"map menu wind": "Pression",
			"layer legend A": "Pression"
		},
		"Rain": {
			"map menu humidity": "Pluie"
		},
		"Rename": {
			"favorites menu": "Renommer"
		},
		"Reset all settings": {
			"settings menu": "Tout réinitialiser"
		},
		"Sea level": {
			"map menu wind": "Niveau Mer"
		},
		"Set as homepage": {
			"favorites menu": "En page d'accueil"
		},
		"Settings": {
			"settings menu": "Réglages"
		},
		"Shearing": {
			"map menu updrafts": "Cisaillement",
			"layer legend B": "Cisaillement"
		},
		"Sounding": {
			"windgram tab": "Émagramme"
		},
		"Temperature": {
			"map menu temperature": "Température",
			"layer legend A": "Température"
		},
		"Thermals": {
			"map menu updrafts": "Thermiques",
			"layer legend A": "Thermiques"
		},
		"Thickness": {
			"map menu updrafts": "Épaisseur",
			"layer legend B": "Épaisseur"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendances"
		},
		"Velocity": {
			"map menu updrafts": "Vitesse",
			"layer legend B": "Vitesse"
		},
		"Vertical motion": {
			"map menu updrafts": "Mouv. Verticaux",
			"": "Mouvements Verticaux"
		},
		"Wind": {
			"map menu wind": "Vent",
			"layer legend A": "Vent"
		},
		"Wind Shear": {
			"map menu wind": "Cisaillement",
			"layer legend A": "Cisaillement"
		},
		"Windgram": {
			"windgram tab": "Vent / Alti"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topographie"
		},
		"Model": {
			"layer legend B": "Modèle"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "sans dimension"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Sol"
		},
		"Ceiling of BL": {
			"layer legend B": "Plaf. C. Lim."
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Nuages"
		},
		"Low altitude": {
			"layer legend B": "Basse alti"
		},
		"High altitude": {
			"layer legend B": "Haute alti"
		},
		"Medium altitude": {
			"layer legend B": "Moyenne alti"
		},
		"All altitudes": {
			"layer legend B": "Toutes altis"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Mouv. Verticaux"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Précipitations"
		},
		"1 hour": {
			"layer legend B": "1 heure"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Niveau de la mer"
		},
		"Enter a name": {
			"new favorite prompt": "Entrez un nom"
		},
		"Enter the new name": {
			"new favorite prompt": "Entrez le nouveau nom"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Écraser le favori \"%{ name }\" ?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Supprimer le favori \"%{ name }\" ?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Voulez-vous vraiment remettre à zéro ?\nVOS RÉGLAGES ET VOS FAVORIS SERONT SUPPRIMÉS POUR TOUJOURS !"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Météo pour le Vol Libre et le Vol à Voile | Météo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Aide / Contact / Infos"
		},
		"Install now": {
			"version check": "Installer"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Météo-Parapente RASP Europe"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Météo pour le Vol Libre et le Vol à Voile"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Météo-Parapente a besoin d'être mis à jour"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Météo-Parapente devient mobile !\nDes prévisions conçues spécialement pour les activités aériennes et le parapente"
		},
		"Mobile app": "Application mobile",
		"No internet connexion": "Internet déconnecté",
		"Community": "Communauté",
		"Day selection": "Choix du jour",
		"knots": "Nœuds",
		"mph": "mph",
		"Radiation": "Radiation",
		"Sun": "Ensoleillement",
		"Update": "Mise à jour",
		"Wind unit": "Unité du vent",
		"An error has occured. Please try again.": {
			"popup": "Une erreur s'est produite. Réessayez."
		},
		"Click here to renew.": {
			"login popup": "Renouveler."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Pour changer votre mot de passe, cliquez sur le lien contenu dans l'email."
		},
		"Close": {
			"popup": "Fermer",
			"general": "Fermer"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Les adresses sont différentes ou invalides."
		},
		"Error! Bad login or password": {
			"login popup": "Adresse inconnue ou mauvais mot de passe"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Erreur ! Votre accès a expiré le %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Si votre adresse est connue, vous recevrez un email."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Dernière étape…"
		},
		"Passwords must be the same": {
			"password popup": "Les mots de passe doivent être identiques."
		},
		"Please log-in": {
			"login popup": "Connexion"
		},
		"Private device − stay connected": {
			"login popup": "Appareil privé - rester connecté"
		},
		"Read more…": {
			"contribute popup": "Plus d'infos…"
		},
		"Reset your password": {
			"password popup": "Nouveau mot de passe"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Certains fournisseurs tels que Orange, GMX ou Hotmail bloquent parfois nos emails automatiques. Si vous ne recevez rien, contactez support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bienvenue !"
		},
		"Same as device": {
			"timezone menu": "Comme mon appareil"
		},
		"Timezone": {
			"settings menu": "Fuseau horaire"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiple"
		},
		"Points": {
			"xc planner": "Points"
		},
		"Duration": {
			"xc planner": "Durée"
		},
		"Speed": {
			"xc planner": "Vitesse"
		},
		"Close flight": {
			"xc planner": "Boucler"
		},
		"Share": {
			"xc planner": "Partager"
		},
		"Download": {
			"xc planner": "Télécharger",
			"general": "Télécharger"
		},
		"Preferences": {
			"xc planner": "Réglages"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "À propos"
		},
		"Exit Fullscreen": {
			"toggle menu": "Réduire"
		},
		"Fullscreen": {
			"toggle menu": "Plein écran"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "La fonction XC Planner est expérimentale. Elle fonctionne uniquement avec un ordinateur, sur le site meteo-parapente.com"
		},
		"Cancel": {
			"general": "Annuler"
		},
		"Yes": {
			"general": "Oui"
		},
		"No": {
			"general": "Non"
		},
		"Save": {
			"general": "Enregistrer"
		},
		"Continue": {
			"general": "Continuer"
		},
		"Original version": {
			"xc planner": "Version originale"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Ici bien trafiquée pour pouvoir marcher dans Météo-Parapente, avec l'autorisation de Tom. Merci !"
		},
		"League": {
			"xc planner": "Ligue"
		},
		"Distance units": {
			"xc planner": "Unité de distance"
		},
		"Altitude units": {
			"xc planner": "Unité d'altitude"
		},
		"Coordinates format": {
			"xc planner": "Format des coordonnées"
		},
		"Turnpoint details": {
			"xc planner": "Balises"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nom de la trace"
		},
		"Waypoint prefix": {
			"xc planner": "Préfixe balise"
		},
		"Lien": {
			"xc planner": "Lien"
		},
		"Paste link in email or IM": {
			"xc planner": "Lien partageable"
		},
		"Static image": {
			"xc planner": "Image statique"
		},
		"Open with XCTrack": {
			"xc planner": "Ouvrir dans XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Définir route dans LocToMe"
		},
		"Go to": {
			"general": "Aller à"
		},
		"Error! Please try again later": {
			"update modal": "Erreur ! Ressayez plus tard."
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Cliquez Reset pour effacer définitivement le parcours, ou Annuler pour la garder."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Voici votre code d'accès. Gardez-le précieusement !"
		},
		"Password:": {
			"contribute popup": "Mot de passe:"
		},
		"Thank you!": {
			"contribute popup": "Merci !"
		},
		"Username:": {
			"contribute popup": "Identifiant :"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mois Standard － %{pricing}%{currency} / mois"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mois Étudiant － %{pricing}%{currency} / mois"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mois Soutien － %{pricing}%{currency} / mois"
		},
		"Tour of Europe": {
			"tab": "Tour d'Europe"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Profitez des meilleures prévisions chaque jour. Météo-Parapente existe grâce à vous."
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Participez gratuitement aux formations météo organisées dans les clubs"
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Rejoignez le club des contributeurs Météo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Rencontrez moi une fois par mois pour échanger nos idées et améliorer le site"
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Météo-Parapente existe grâce à vous !"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Je veux fournir un outil de qualité accessible à tous les pilotes."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Soutenez le développement d'un outil de qualité, accessible à tous les pilotes."
		},
		"and to the": {
			"startup terms": "et la"
		},
		"By using this application, you agree to the": {
			"startup terms": "En utilisant cette application, vous acceptez les"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Si le problème persiste, contactez support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente n'utilise pas de cookies espions"
		},
		"privacy policy": {
			"startup terms": "politique de confidentialité"
		},
		"terms of use": {
			"startup": "conditions générales d'utilisation"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Impossible de joindre les serveurs de Meteo-Parapente. Vérifiez votre connexion."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 jours par semaine sont réservés aux membres"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Vous êtes déjà membre ? Cliquez pour réinitialiser votre mot de passe"
		},
		"Become a member": {
			"contribute menu": "Devenir membre",
			"popup": "Devenir membre"
		},
		"Click here to learn the details": {
			"contest": "Cliquez ici pour en savoir plus"
		},
		"I am already a member": {
			"popup": "Je suis déjà membre"
		},
		"Learn more": {
			"contest": "En savoir plus"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente fête son 10e anniversaire."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Vous n'êtes pas encore membre ? Cliquez pour obtenir un code d'accès"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "À cette occasion, nous organisons un concours exceptionnel"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Un gagnant sera tiré au sort parmi tous ceux qui ont acheté ou renouvelé un abonnement entre septembre dernier et le 30 mars prochain."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "A gagner : L'AILE DE PARAPENTE DE VOTRE CHOIX ! !!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Pour voir %{ date }, veuillez vous connecter ou devenir membre."
		},
		"Win a paraglider!": {
			"contribute menu": "Gagnez un parapente !"
		}
	},
	"hu": {
		"(Kitesurf)": {
			"search result": "Kiteszörf"
		},
		"(Paragliding)": {
			"search result": "Siklóernyő"
		},
		"1h": {
			"map menu humidity": "1ó"
		},
		"Add new…": {
			"favorites menu": "Új hozzáadása..."
		},
		"Airspace": {
			"toggle menu": "Légtér"
		},
		"All": {
			"map menu humidity": "Összes"
		},
		"B. layer": {
			"map menu updrafts": "H. réteg"
		},
		"B. Layer": {
			"map menu wind": "H. réteg"
		},
		"Boundary layer": {
			"map menu wind": "Határ réteg"
		},
		"Boundary Layer": {
			"map menu updrafts": "Határ réteg",
			"layer legend A": "Határréteg",
			"layer legend B": "Határréteg"
		},
		"Ceiling": {
			"map menu updrafts": "Plafon",
			"layer legend B": "Plafon"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Határréteg teteje"
		},
		"Change password": {
			"settings menu": "Jelszóváltoztatás"
		},
		"Clouds": {
			"map menu humidity": "Felhők"
		},
		"Color blind": {
			"settings menu": "Színvak"
		},
		"debug": {
			"settings menu": "Hibajavítás"
		},
		"Delete": {
			"favorites menu": "Töröl"
		},
		"experimental": {
			"settings menu": "kísérleti"
		},
		"Experimental features": {
			"settings menu": "Kisérleti lehetőségek"
		},
		"Favorites": {
			"menu title": "Kedvencek"
		},
		"Ground": {
			"map menu wind": "Talaj",
			"map menu temperature": "Talaj"
		},
		"Help us translate!": {
			"settings menu": "Segíts a fordításban!"
		},
		"High": {
			"map menu humidity": "Magassági"
		},
		"Humidity": {
			"map menu humidity": "Páratartalom"
		},
		"Interpolation": {
			"toggle menu": "Interpoláció"
		},
		"Language": {
			"settings menu": "Nyelv"
		},
		"Login": {
			"login menu": "Bejelentkezés"
		},
		"Logout": {
			"settings menu": "Kijelentkezés"
		},
		"Low": {
			"map menu humidity": "Alacsony"
		},
		"Medium": {
			"map menu humidity": "Középszintű"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Ugorj a tetejére"
		},
		"News": {
			"news menu": "Hírek"
		},
		"News!": {
			"news menu": "Hírek!"
		},
		"No data for this place": {
			"windgram view": "Nincs adat ehhez a helyhez"
		},
		"Open": {
			"favorites menu": "Megnyit"
		},
		"Pressure": {
			"map menu wind": "Nyomás",
			"layer legend A": "Nyomás"
		},
		"Rain": {
			"map menu humidity": "Eső"
		},
		"Rename": {
			"favorites menu": "Átnevez"
		},
		"Reset all settings": {
			"settings menu": "Beállítások törlése"
		},
		"Sea level": {
			"map menu wind": "Tengerszint"
		},
		"Set as homepage": {
			"favorites menu": "Beállítás kezdőlapnak"
		},
		"Settings": {
			"settings menu": "Beállítások"
		},
		"Shearing": {
			"map menu updrafts": "Nyírás",
			"layer legend B": "Nyírás"
		},
		"Sounding": {
			"windgram tab": "Ballonos mérések"
		},
		"Temperature": {
			"map menu temperature": "Hőmérséklet",
			"layer legend A": "Hőmérséklet"
		},
		"Thermals": {
			"map menu updrafts": "Termikek",
			"layer legend A": "Termikek"
		},
		"Thickness": {
			"map menu updrafts": "Vastagság",
			"layer legend B": "Vastagság"
		},
		"Updrafts": {
			"map menu updrafts": "Feláramlás"
		},
		"Velocity": {
			"map menu updrafts": "Erősség",
			"layer legend B": "Erőssége"
		},
		"Vertical motion": {
			"map menu updrafts": "Vertikális mozgás",
			"": "Függőleges mozgás"
		},
		"Wind": {
			"map menu wind": "Szél",
			"layer legend A": "Szél"
		},
		"Wind Shear": {
			"map menu wind": "Szélnyírás",
			"layer legend A": "Szélnyírás"
		},
		"Windgram": {
			"windgram tab": "Szél diagram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topográfia"
		},
		"Model": {
			"layer legend B": "Modell"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimenziómentes"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Felszín"
		},
		"Ceiling of BL": {
			"layer legend B": "Határréteg teteje"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Felhőtakaró"
		},
		"Low altitude": {
			"layer legend B": "Alacsony szintű"
		},
		"High altitude": {
			"layer legend B": "Magas szintű"
		},
		"Medium altitude": {
			"layer legend B": "Középmagas szintű"
		},
		"All altitudes": {
			"layer legend B": "Összes magasság"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikális Mozgás"
		},
		"mm/h": {
			"layer unit": "mm/ó"
		},
		"Precipitations": {
			"layer legend A": "Csapadék"
		},
		"1 hour": {
			"layer legend B": "1 óra"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Közepes tengerszint"
		},
		"Enter a name": {
			"new favorite prompt": "Írjon be nevet"
		},
		"Enter the new name": {
			"new favorite prompt": "Írjon be egy új nevet"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Kedvenc felülírásra:"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Kedvenc törlése:"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Biztosan törölni szeretne mindent?\nMINDEN BEÁLLÍTÁSOD ÉS KEDVENCED ÖRÖKRE ELVESZIK!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Siklóernyős időjárás előrejelzés | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Segítség / Kontakt / Rólunk"
		},
		"Install now": {
			"version check": "Azonnali telepítés"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Európa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Siklóernyős Időjárás Előrejelzés"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapentének frissítésre van szüksége."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente már mobilon is!\nRepülésmeteorológiai időjárás előrejelzés speciálisan repüléshez és siklóernyőzéshez."
		},
		"Mobile app": "Mobil applikáció",
		"No internet connexion": "Nincs internet kapcsolat",
		"Community": "Közösség",
		"Day selection": "Nap kiválasztása",
		"knots": "csomók",
		"mph": "mph",
		"Radiation": "Sugárzás",
		"Sun": "Sun",
		"Update": "Frissítés",
		"Wind unit": "Szél egység",
		"An error has occured. Please try again.": {
			"popup": "Hiba történt. Kérjük, próbálja meg újra."
		},
		"Click here to renew.": {
			"login popup": "Kattintson ide a megújításhoz."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kattintson az e-mailben található linkre a jelszó megváltoztatásához."
		},
		"Close": {
			"popup": "Zárja be a",
			"general": "Zárja be a"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Az e-mailek nem azonosak vagy érvénytelenek"
		},
		"Error! Bad login or password": {
			"login popup": "Hiba! Rossz bejelentkezés vagy jelszó"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Hiba! Az Ön hozzáférése %{ expirationDate } lejárt."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Ha Ön hozzájárul, kapni fog egy e-mailt."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Egy utolsó lépés..."
		},
		"Passwords must be the same": {
			"password popup": "A jelszavaknak azonosnak kell lenniük"
		},
		"Please log-in": {
			"login popup": "Kérjük, jelentkezzen be"
		},
		"Private device − stay connected": {
			"login popup": "Privát eszköz - maradjon kapcsolatban"
		},
		"Read more…": {
			"contribute popup": "Bővebben..."
		},
		"Reset your password": {
			"password popup": "Jelszó visszaállítása"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Egyes szolgáltatók, például az Orange, a GMX és a Hotmail néha blokkolják az e-mailjeinket. Ha nem kap semmit, kérjük, lépjen kapcsolatba a support@meteo&#x2011;parapente.com címen."
		},
		"Welcome!": {
			"login popup": "Üdvözöljük!"
		},
		"Same as device": {
			"timezone menu": "Ugyanaz, mint a készülék"
		},
		"Timezone": {
			"settings menu": "Időzóna"
		},
		"XC Planner": {
			"toggle menu": "XC tervező"
		},
		"Multiplier": {
			"xc planner": "Multiplikátor"
		},
		"Points": {
			"xc planner": "Pontok"
		},
		"Duration": {
			"xc planner": "Időtartam"
		},
		"Speed": {
			"xc planner": "Sebesség"
		},
		"Close flight": {
			"xc planner": "Közeli repülés"
		},
		"Share": {
			"xc planner": "Megosztás"
		},
		"Download": {
			"xc planner": "Letöltés",
			"general": "Letöltés"
		},
		"Preferences": {
			"xc planner": "Preferenciák"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "A  oldalról"
		},
		"Exit Fullscreen": {
			"toggle menu": "Teljes képernyőből kilépés"
		},
		"Fullscreen": {
			"toggle menu": "Teljes képernyő"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Az XC Planner egy kísérleti funkció.\nCsak számítógépről érhető el a meteo-parapente.com oldalon."
		},
		"Cancel": {
			"general": "Törölje"
		},
		"Yes": {
			"general": "Igen"
		},
		"No": {
			"general": "Nem"
		},
		"Save": {
			"general": "Mentés"
		},
		"Continue": {
			"general": "Folytatás"
		},
		"Original version": {
			"xc planner": "Eredeti változat"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Erősen feltört, hogy a Meteo-Parapente-ben működjön, Tom engedélyével. Köszönöm!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Távolsági egységek"
		},
		"Altitude units": {
			"xc planner": "Magassági egységek"
		},
		"Coordinates format": {
			"xc planner": "Koordináták formátuma"
		},
		"Turnpoint details": {
			"xc planner": "Fordulópont részletek"
		},
		"Format": {
			"xc planner": "Formátum"
		},
		"Route name": {
			"xc planner": "Útvonal neve"
		},
		"Waypoint prefix": {
			"xc planner": "Útpont előtag"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Link beillesztése e-mailben vagy IM-ben"
		},
		"Static image": {
			"xc planner": "Statikus kép"
		},
		"Open with XCTrack": {
			"xc planner": "Megnyitás XCTrack segítségével"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Megosztás a LocToMe-vel: alapértelmezett útvonalként beállítva"
		},
		"Go to": {
			"general": "Menjen a"
		},
		"Error! Please try again later": {
			"update modal": "Hiba! Kérjük, próbálja meg később újra"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Nyomja meg a Reset gombot az útvonal végleges visszaállításához, nyomja meg a Cancel gombot az útvonal megtartásához."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Itt van a belépési kódja. Kérjük, tartsa biztonságban."
		},
		"Password:": {
			"contribute popup": "Jelszó:"
		},
		"Thank you!": {
			"contribute popup": "Köszönöm!"
		},
		"Username:": {
			"contribute popup": "Felhasználónév:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 hónap Standard - %{currency} %{pricing} / hónap"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 hónap Diák - %{currency} %{pricing} / hónap"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 hónap Támogató - %{currency} %{pricing} / hónap"
		},
		"Tour of Europe": {
			"tab": "Európai körút"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Élvezze a legjobb előrejelzéseket minden nap. A Meteo-Parapente Önnek köszönhetően létezhet!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Ingyenes belépés a helyi időjárási képzésekre és felhasználói találkozókra."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Csatlakozzon a Meteo-Parapente közreműködők klubjához"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Havonta egyszer találkozzunk, hogy megbeszéljük az új funkciókat és fejlesztéseket."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "A Meteo-Parapente önöknek köszönhetően létezhet!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Célom, hogy minden pilóta számára elérhető, minőségi eszközt biztosítsak."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Támogassa egy minden pilóta számára elérhető minőségi eszköz kifejlesztését."
		},
		"and to the": {
			"startup terms": "és a"
		},
		"By using this application, you agree to the": {
			"startup terms": "Az alkalmazás használatával Ön elfogadja a"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Ha a probléma továbbra is fennáll, forduljon a support@meteo-parapente.com címre."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "A Meteo-Parapente nem használ nyomkövető cookie-kat."
		},
		"privacy policy": {
			"startup terms": "adatvédelmi politika"
		},
		"terms of use": {
			"startup": "használati feltételek"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nem lehet elérni a Meteo-Parapente szervereit. Kérjük, ellenőrizze a kapcsolatát."
		},
		"2 days a week are reserved to members": {
			"private popup": "Heti 2 nap a tagok számára van fenntartva"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Már tag vagy? Kattintson a jelszó visszaállításához"
		},
		"Become a member": {
			"contribute menu": "Legyen tag",
			"popup": "Legyen tag"
		},
		"Click here to learn the details": {
			"contest": "Kattintson ide a részletekért"
		},
		"I am already a member": {
			"popup": "Már tag vagyok"
		},
		"Learn more": {
			"contest": "Tudjon meg többet"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "A Meteo-Parapente ünnepli fennállásának 10. évfordulóját."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Még nem vagy tag? Kattintson a belépési kódért"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Ebből az alkalomból rendkívüli versenyt szervezünk."
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Egy nyertest sorsolunk ki azok közül, akik tavaly szeptember és jövő március 30. között előfizetést vásároltak vagy újítottak meg."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Nyerni kell: A VÁLASZTOTT SIKLÓERNYŐS SZÁRNY!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "A %{ date } megtekintéséhez kérjük, jelentkezzen be vagy legyen tag."
		},
		"Win a paraglider!": {
			"contribute menu": "Nyerj egy siklóernyőt!"
		}
	},
	"it": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Parapendio"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Aggiungi nuovo..."
		},
		"Airspace": {
			"toggle menu": "Spazio aereo"
		},
		"All": {
			"map menu humidity": "Tutte"
		},
		"B. layer": {
			"map menu updrafts": "Strato Convettivo"
		},
		"B. Layer": {
			"map menu wind": "Strato convettivo"
		},
		"Boundary layer": {
			"map menu wind": "Strato convettivo"
		},
		"Boundary Layer": {
			"map menu updrafts": "Strato convettivo",
			"layer legend A": "Strato convettivo",
			"layer legend B": "Strato convettivo"
		},
		"Ceiling": {
			"map menu updrafts": "Quota max",
			"layer legend B": "Quota max"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Quota max strato convettivo"
		},
		"Change password": {
			"settings menu": "Cambio password"
		},
		"Clouds": {
			"map menu humidity": "Nubi"
		},
		"Color blind": {
			"settings menu": "Daltonici"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Cancella"
		},
		"experimental": {
			"settings menu": "Sperimentale"
		},
		"Experimental features": {
			"settings menu": "Funzioni in fase sperimentale"
		},
		"Favorites": {
			"menu title": "Preferiti"
		},
		"Ground": {
			"map menu wind": "in superficie",
			"map menu temperature": "in superficie"
		},
		"Help us translate!": {
			"settings menu": "Aiutaci a tradurre!"
		},
		"High": {
			"map menu humidity": "Alte"
		},
		"Humidity": {
			"map menu humidity": "Umidità"
		},
		"Interpolation": {
			"toggle menu": "Interpolazione"
		},
		"Language": {
			"settings menu": "Lingua"
		},
		"Login": {
			"login menu": "Entra"
		},
		"Logout": {
			"settings menu": "Esci"
		},
		"Low": {
			"map menu humidity": "Basse"
		},
		"Medium": {
			"map menu humidity": "Medie"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapendio"
		},
		"Move to top": {
			"favorites menu": "Vai in cima"
		},
		"News": {
			"news menu": "Avvisi"
		},
		"News!": {
			"news menu": "Avvisi!"
		},
		"No data for this place": {
			"windgram view": "Nessun dato per questa località"
		},
		"Open": {
			"favorites menu": "Apri"
		},
		"Pressure": {
			"map menu wind": "Pressione",
			"layer legend A": "Pressione"
		},
		"Rain": {
			"map menu humidity": "Pioggia"
		},
		"Rename": {
			"favorites menu": "Rinomina"
		},
		"Reset all settings": {
			"settings menu": "Ripristina tutto"
		},
		"Sea level": {
			"map menu wind": "Livello del mare"
		},
		"Set as homepage": {
			"favorites menu": "Configura come pagina iniziale"
		},
		"Settings": {
			"settings menu": "Preferenze"
		},
		"Shearing": {
			"map menu updrafts": "uniformi/rotte",
			"layer legend B": "uniformi/rotte"
		},
		"Sounding": {
			"windgram tab": "Curva di stato"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termiche",
			"layer legend A": "Termiche"
		},
		"Thickness": {
			"map menu updrafts": "Spessore",
			"layer legend B": "Spessore"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendenze"
		},
		"Velocity": {
			"map menu updrafts": "Velocità",
			"layer legend B": "Velocità"
		},
		"Vertical motion": {
			"map menu updrafts": "Moto verticale",
			"": "Movimento verticale"
		},
		"Wind": {
			"map menu wind": "Vento",
			"layer legend A": "Vento"
		},
		"Wind Shear": {
			"map menu wind": "Gradiente di vento",
			"layer legend A": "Gradiente di vento"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Modello"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "(senza unità di misura)"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superficie"
		},
		"Ceiling of BL": {
			"layer legend B": "Quota max strato convettivo"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Copertura nuvolosa"
		},
		"Low altitude": {
			"layer legend B": "Bassa quota"
		},
		"High altitude": {
			"layer legend B": "Alta quota"
		},
		"Medium altitude": {
			"layer legend B": "Quota media"
		},
		"All altitudes": {
			"layer legend B": "Tutte le quote"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Moto verticale"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitazioni"
		},
		"1 hour": {
			"layer legend B": "1 ora"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Livello del mare (medio)"
		},
		"Enter a name": {
			"new favorite prompt": "Inserisci un nome"
		},
		"Enter the new name": {
			"new favorite prompt": "Inserisci un nuovo nome"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Sovrascrivi preferiti \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Cancella preferiti \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Sei sicuro di voler ripristinare tutto?\nTUTTE LE TUE PREFERENZE E PERSONALIZZAZIONI NON SARANNO PIÙ RECUPERABILI!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Previsioni meteo per il volo | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Aiuto/Contatti/Riferimenti"
		},
		"Install now": {
			"version check": "Installa adesso"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Previsioni meteo di volo libero"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente deve essere aggiornato"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente è adesso disponibile per dispositivi mobili!\nPrevisioni meteo specifiche per il volo libero in parapendio"
		},
		"Mobile app": "App per dispositivi mobili",
		"No internet connexion": "Manca la connessione a internet",
		"Community": "Comunità",
		"Day selection": "Selezione del giorno",
		"knots": "nodi",
		"mph": "mph",
		"Radiation": "Radiazione",
		"Sun": "Sole",
		"Update": "Aggiornamento",
		"Wind unit": "Unità di vento",
		"An error has occured. Please try again.": {
			"popup": "Si è verificato un errore. Si prega di riprovare."
		},
		"Click here to renew.": {
			"login popup": "Clicca qui per rinnovare."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Clicca sul link all'interno dell'e-mail per cambiare la tua password."
		},
		"Close": {
			"popup": "Chiudi",
			"general": "Chiudere"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Le e-mail non sono uguali o non sono valide"
		},
		"Error! Bad login or password": {
			"login popup": "Errore! Accesso o password errati"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Errore! Il tuo accesso è scaduto il %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Se sei un collaboratore, riceverai un'e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Un ultimo passo..."
		},
		"Passwords must be the same": {
			"password popup": "Le password devono essere uguali"
		},
		"Please log-in": {
			"login popup": "Per favore, accedi"
		},
		"Private device − stay connected": {
			"login popup": "Dispositivo privato - resta connesso"
		},
		"Read more…": {
			"contribute popup": "Leggi di più..."
		},
		"Reset your password": {
			"password popup": "Ripristina la tua password"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Alcuni provider come Orange, GMX e Hotmail a volte bloccano le nostre e-mail. Se non ricevi nulla, contatta il supporto@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Benvenuti!"
		},
		"Same as device": {
			"timezone menu": "Uguale al dispositivo"
		},
		"Timezone": {
			"settings menu": "Fuso orario"
		},
		"XC Planner": {
			"toggle menu": "Pianificatore XC"
		},
		"Multiplier": {
			"xc planner": "Moltiplicatore"
		},
		"Points": {
			"xc planner": "Punti"
		},
		"Duration": {
			"xc planner": "Durata"
		},
		"Speed": {
			"xc planner": "Velocità"
		},
		"Close flight": {
			"xc planner": "Chiudere il volo"
		},
		"Share": {
			"xc planner": "Condividi"
		},
		"Download": {
			"xc planner": "Scaricare",
			"general": "Scaricare"
		},
		"Preferences": {
			"xc planner": "Preferenze"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "Informazioni su"
		},
		"Exit Fullscreen": {
			"toggle menu": "Esci dallo schermo intero"
		},
		"Fullscreen": {
			"toggle menu": "Schermo intero"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner è una funzione sperimentale.\nÈ disponibile solo da un computer, su meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancella"
		},
		"Yes": {
			"general": "Sì"
		},
		"No": {
			"general": "No"
		},
		"Save": {
			"general": "Salva"
		},
		"Continue": {
			"general": "Continua"
		},
		"Original version": {
			"xc planner": "Versione originale"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Pesantemente modificato per funzionare in Meteo-Parapente, con l'autorizzazione di Tom. Grazie!"
		},
		"League": {
			"xc planner": "Lega"
		},
		"Distance units": {
			"xc planner": "Unità di distanza"
		},
		"Altitude units": {
			"xc planner": "Unità di altitudine"
		},
		"Coordinates format": {
			"xc planner": "Formato delle coordinate"
		},
		"Turnpoint details": {
			"xc planner": "Dettagli del punto di svolta"
		},
		"Format": {
			"xc planner": "Formato"
		},
		"Route name": {
			"xc planner": "Nome del percorso"
		},
		"Waypoint prefix": {
			"xc planner": "Prefisso del waypoint"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Incolla il link nell'e-mail o nel messaggio istantaneo"
		},
		"Static image": {
			"xc planner": "Immagine statica"
		},
		"Open with XCTrack": {
			"xc planner": "Apri su XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Condividere con LocToMe: impostare come percorso predefinito"
		},
		"Go to": {
			"general": "Vai a"
		},
		"Error! Please try again later": {
			"update modal": "Errore! Si prega di riprovare più tardi"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Premi Reset per reimpostare il tuo percorso in modo permanente, premi Annulla per mantenere il tuo percorso."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Ecco il suo codice di accesso. Per favore, lo tenga al sicuro."
		},
		"Password:": {
			"contribute popup": "Password:"
		},
		"Thank you!": {
			"contribute popup": "Grazie!"
		},
		"Username:": {
			"contribute popup": "Nome utente:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesi Standard - %{currency} %{pricing} / mese"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesi Studente - %{currency} %{pricing} / mese"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesi Fornitore - %{currency} %{pricing} / mese"
		},
		"Tour of Europe": {
			"tab": "Giro d'Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Goditi le migliori previsioni ogni giorno. Meteo-Parapente può esistere grazie a te!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Ottieni l'ingresso gratuito ai corsi di formazione meteo locali e ai meetup degli utenti."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Iscriviti al club dei collaboratori di Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Incontriamoci una volta al mese per discutere di nuove caratteristiche e miglioramenti."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente può esistere grazie a voi!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Il mio obiettivo è quello di fornire uno strumento di qualità accessibile a tutti i piloti."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Sostenere lo sviluppo di uno strumento di qualità accessibile a tutti i piloti."
		},
		"and to the": {
			"startup terms": "e à la"
		},
		"By using this application, you agree to the": {
			"startup terms": "Utilizzando questa applicazione, accettate le"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Se il problema persiste, contattare support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente non utilizza cookie di tracciamento"
		},
		"privacy policy": {
			"startup terms": "politica sulla riservatezza"
		},
		"terms of use": {
			"startup": "condizioni generali d'uso"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Impossibile raggiungere i server di Meteo-Parapente. Per favore controlla la tua connessione."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 giorni alla settimana sono riservati ai membri"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Sei già membro? Clicca per reimpostare la tua password"
		},
		"Become a member": {
			"contribute menu": "Diventa un membro",
			"popup": "Diventa un membro"
		},
		"Click here to learn the details": {
			"contest": "Clicca qui per conoscere i dettagli"
		},
		"I am already a member": {
			"popup": "Sono già membro"
		},
		"Learn more": {
			"contest": "Per saperne di più"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente festeggia il suo 10° anniversario."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Non sei ancora membro? Clicca per ottenere un codice di accesso"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "In questa occasione, stiamo organizzando un concorso eccezionale"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Un vincitore sarà estratto tra tutti coloro che hanno acquistato o rinnovato un abbonamento tra lo scorso settembre e il prossimo 30 marzo."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Da vincere: L'ALA DA PARAPENDIO DI TUA SCELTA!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Per vedere %{ date }, effettua il login o diventa membro."
		},
		"Win a paraglider!": {
			"contribute menu": "Vinci un parapendio!"
		}
	},
	"nl": {
		"(Kitesurf)": {
			"search result": "(Kitesurf)"
		},
		"(Paragliding)": {
			"search result": "(Parapente)"
		},
		"1h": {
			"map menu humidity": "1u"
		},
		"Add new…": {
			"favorites menu": "Nieuw"
		},
		"Airspace": {
			"toggle menu": "Luchtruim"
		},
		"All": {
			"map menu humidity": "Alles"
		},
		"B. layer": {
			"map menu updrafts": "Grenslaag"
		},
		"B. Layer": {
			"map menu wind": "Grenslaag"
		},
		"Boundary layer": {
			"map menu wind": "Grenslaag"
		},
		"Boundary Layer": {
			"map menu updrafts": "Grenslaag",
			"layer legend A": "Grenslaag",
			"layer legend B": "Grenslaag"
		},
		"Ceiling": {
			"map menu updrafts": "hoogte",
			"layer legend B": "Plafond"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Hoogte van grenslaag"
		},
		"Change password": {
			"settings menu": "Paswoord wijzigen"
		},
		"Clouds": {
			"map menu humidity": "Wolken"
		},
		"Color blind": {
			"settings menu": "Kleurenblind"
		},
		"debug": {
			"settings menu": "debug"
		},
		"Delete": {
			"favorites menu": "Verwijderen"
		},
		"experimental": {
			"settings menu": "experimenteel"
		},
		"Experimental features": {
			"settings menu": "Experimentele functies"
		},
		"Favorites": {
			"menu title": "Favorieten"
		},
		"Ground": {
			"map menu wind": "Grond",
			"map menu temperature": "Grond"
		},
		"Help us translate!": {
			"settings menu": "Help ons vertalen"
		},
		"High": {
			"map menu humidity": "Hoog"
		},
		"Humidity": {
			"map menu humidity": "Vochtigheid"
		},
		"Interpolation": {
			"toggle menu": "Interpolatie"
		},
		"Language": {
			"settings menu": "Taal"
		},
		"Login": {
			"login menu": "Inloggen"
		},
		"Logout": {
			"settings menu": "Uitloggen"
		},
		"Low": {
			"map menu humidity": "Laag"
		},
		"Medium": {
			"map menu humidity": "Gemiddeld"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Naar boven"
		},
		"News": {
			"news menu": "Nieuws"
		},
		"News!": {
			"news menu": "Nieuws!"
		},
		"No data for this place": {
			"windgram view": "Geen data voor deze locatie"
		},
		"Open": {
			"favorites menu": "Open"
		},
		"Pressure": {
			"map menu wind": "Druk",
			"layer legend A": "(Lucht)Druk"
		},
		"Rain": {
			"map menu humidity": "Regen"
		},
		"Rename": {
			"favorites menu": "Hernoem"
		},
		"Reset all settings": {
			"settings menu": "Wis alle instellingen"
		},
		"Sea level": {
			"map menu wind": "Zeeniveau"
		},
		"Set as homepage": {
			"favorites menu": "Als startpagina instellen"
		},
		"Settings": {
			"settings menu": "Instellingen"
		},
		"Shearing": {
			"map menu updrafts": "Schering",
			"layer legend B": "Schering"
		},
		"Sounding": {
			"windgram tab": "Emagram"
		},
		"Temperature": {
			"map menu temperature": "Temperatuur",
			"layer legend A": "Temperatuur"
		},
		"Thermals": {
			"map menu updrafts": "Thermiek",
			"layer legend A": "Thermieken"
		},
		"Thickness": {
			"map menu updrafts": "Dikte",
			"layer legend B": "Dikte"
		},
		"Updrafts": {
			"map menu updrafts": "Stijgwinden"
		},
		"Velocity": {
			"map menu updrafts": "Snelheid",
			"layer legend B": "Snelheid"
		},
		"Vertical motion": {
			"map menu updrafts": "Verticale beweging",
			"": "Verticale beweging"
		},
		"Wind": {
			"map menu wind": "Wind",
			"layer legend A": "wind"
		},
		"Wind Shear": {
			"map menu wind": "Windschering",
			"layer legend A": "Windschering"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "dimensieloos"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "oppervlakte"
		},
		"Ceiling of BL": {
			"layer legend B": "Hoogte van GL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Wolkendek"
		},
		"Low altitude": {
			"layer legend B": "Lage hoogte"
		},
		"High altitude": {
			"layer legend B": "Grote hoogte"
		},
		"Medium altitude": {
			"layer legend B": "Gemiddelde hoogte"
		},
		"All altitudes": {
			"layer legend B": "Alle hoogtes"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Verticale beweging"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Neerslag"
		},
		"1 hour": {
			"layer legend B": "1 uur"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Zeeniveau"
		},
		"Enter a name": {
			"new favorite prompt": "Voer een naam in"
		},
		"Enter the new name": {
			"new favorite prompt": "Voer de nieuwe naam in"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Overschrijf favoriete \"%name\""
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Verwijder favoriete \"%name\""
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Bent u zeker dat u alles wil wissen?\nALLE INSTELLINGEN EN FAVORIETEN WORDEN DEFINITIEF GEWIST!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Zweefvlieg weersvoorspellingen | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Help / Contact / Over"
		},
		"Install now": {
			"version check": "Nu installeren"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europa RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Stijgende weersvoorspellingen"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente heeft een update nodig."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente is nu mobiel!\nWeervoorspellingen speciaal ontworpen voor vliegen en paragliding."
		},
		"Mobile app": "Mobiele app",
		"No internet connexion": "Geen internetverbinding",
		"Community": "Gemeenschap",
		"Day selection": "Dag selectie",
		"knots": "knopen",
		"mph": "mph",
		"Radiation": "Straling",
		"Sun": "Zon",
		"Update": "Update",
		"Wind unit": "Windvoorziening",
		"An error has occured. Please try again.": {
			"popup": "Er is een fout opgetreden. Gelieve opnieuw te proberen."
		},
		"Click here to renew.": {
			"login popup": "Klik hier om te vernieuwen."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Klik op de link in de e-mail om uw wachtwoord te wijzigen."
		},
		"Close": {
			"popup": "Sluiten",
			"general": "Sluiten"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-mails zijn niet hetzelfde of ongeldig"
		},
		"Error! Bad login or password": {
			"login popup": "Fout! Slechte login of wachtwoord"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Fout. Uw toegang is verlopen op %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Als u een contribuant bent, ontvangt u een e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Een laatste stap..."
		},
		"Passwords must be the same": {
			"password popup": "Wachtwoorden moeten hetzelfde zijn"
		},
		"Please log-in": {
			"login popup": "Log in"
		},
		"Private device − stay connected": {
			"login popup": "Privé apparaat - blijf verbonden"
		},
		"Read more…": {
			"contribute popup": "Lees meer..."
		},
		"Reset your password": {
			"password popup": "Reset uw wachtwoord"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Sommige providers zoals Orange, GMX en Hotmail blokkeren soms onze emails. Mocht u toch niets ontvangen, neem dan contact op met support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Welkom."
		},
		"Same as device": {
			"timezone menu": "Zelfde als apparaat"
		},
		"Timezone": {
			"settings menu": "Tijdzone"
		},
		"XC Planner": {
			"toggle menu": "XC-planner"
		},
		"Multiplier": {
			"xc planner": "Vermenigvuldiger"
		},
		"Points": {
			"xc planner": "Punten"
		},
		"Duration": {
			"xc planner": "Duur"
		},
		"Speed": {
			"xc planner": "Snelheid"
		},
		"Close flight": {
			"xc planner": "Vlucht sluiten"
		},
		"Share": {
			"xc planner": "Deel"
		},
		"Download": {
			"xc planner": "Download",
			"general": "Download"
		},
		"Preferences": {
			"xc planner": "Voorkeuren"
		},
		"Reset": {
			"xc planner": "Reset",
			"general": "Reset"
		},
		"About": {
			"xc planner": "Over"
		},
		"Exit Fullscreen": {
			"toggle menu": "Volledig scherm afsluiten"
		},
		"Fullscreen": {
			"toggle menu": "Volledig scherm"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner is een experimentele functie.\nHet is alleen beschikbaar vanaf een computer, op meteo-parapente.com"
		},
		"Cancel": {
			"general": "Annuleren"
		},
		"Yes": {
			"general": "Ja"
		},
		"No": {
			"general": "Geen"
		},
		"Save": {
			"general": "Save"
		},
		"Continue": {
			"general": "Ga door"
		},
		"Original version": {
			"xc planner": "Originele versie"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Zwaar gehackt om in Meteo-Parapente te werken, met toestemming van Tom. Dank je wel!"
		},
		"League": {
			"xc planner": "Competitie"
		},
		"Distance units": {
			"xc planner": "Afstandseenheden"
		},
		"Altitude units": {
			"xc planner": "Hoogte-eenheden"
		},
		"Coordinates format": {
			"xc planner": "Coordinaten formaat"
		},
		"Turnpoint details": {
			"xc planner": "Details keerpunt"
		},
		"Format": {
			"xc planner": "Formaat"
		},
		"Route name": {
			"xc planner": "Naam van de route"
		},
		"Waypoint prefix": {
			"xc planner": "Waypoint voorvoegsel"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Plak link in e-mail of IM"
		},
		"Static image": {
			"xc planner": "Statisch beeld"
		},
		"Open with XCTrack": {
			"xc planner": "Open met XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Delen met LocToMe: instellen als standaardroute"
		},
		"Go to": {
			"general": "Ga naar"
		},
		"Error! Please try again later": {
			"update modal": "Fout! Probeer later opnieuw"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Druk op Reset om uw route permanent te resetten, druk op Annuleren om uw route te behouden."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Hier is uw toegangscode. Bewaar hem goed."
		},
		"Password:": {
			"contribute popup": "Wachtwoord:"
		},
		"Thank you!": {
			"contribute popup": "Dank je."
		},
		"Username:": {
			"contribute popup": "Gebruikersnaam:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 maanden Standaard - %{currency} %{pricing} / maand"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 maanden Student - %{currency} %{pricing} / maand"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 maanden Supporter - %{currency} %{pricing} / maand"
		},
		"Tour of Europe": {
			"tab": "Rondreis door Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Geniet elke dag van de beste voorspellingen. Meteo-Parapente kan bestaan dankzij jou!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Krijg gratis toegang tot lokale weertrainingen en gebruikersmeetups."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Word lid van de Meteo-Parapente contribuanten club"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Ontmoet me eens per maand om nieuwe functies en verbeteringen te bespreken."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente kan bestaan dankzij jou!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Mijn doel is een kwaliteitsinstrument aan te bieden dat toegankelijk is voor elke piloot."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Steun voor de ontwikkeling van een kwaliteitsinstrument dat voor alle loodsen toegankelijk is."
		},
		"and to the": {
			"startup terms": "en met het"
		},
		"By using this application, you agree to the": {
			"startup terms": "Door deze toepassing te gebruiken, gaat u akkoord met de"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Als het probleem aanhoudt, neem dan contact op met support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente gebruikt geen tracking cookies"
		},
		"privacy policy": {
			"startup terms": "privacybeleid"
		},
		"terms of use": {
			"startup": "algemene gebruiksvoorwaarden"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Kan de Meteo-Parapente servers niet bereiken. Controleer uw verbinding."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dagen per week zijn gereserveerd voor leden"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Bent u al lid? Klik om uw wachtwoord te resetten"
		},
		"Become a member": {
			"contribute menu": "Lid worden",
			"popup": "Lid worden"
		},
		"Click here to learn the details": {
			"contest": "Klik hier voor de details"
		},
		"I am already a member": {
			"popup": "Ik ben al lid"
		},
		"Learn more": {
			"contest": "Leer meer"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente viert zijn 10-jarig bestaan."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Nog geen lid? Klik hier om een toegangscode te krijgen"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Bij deze gelegenheid organiseren wij een uitzonderlijke wedstrijd"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Er zal één winnaar worden getrokken uit al degenen die tussen september vorig jaar en 30 maart volgend jaar een abonnement hebben gekocht of verlengd."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Te winnen: DE PARAGLIDER VLEUGEL VAN UW KEUZE!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Om %{ date } te zien, logt u in of wordt u lid."
		},
		"Win a paraglider!": {
			"contribute menu": "Win een paraglider!"
		}
	},
	"pl": {
		"(Kitesurf)": {
			"search result": "(Kitesurfing)"
		},
		"(Paragliding)": {
			"search result": "(Paragliding)"
		},
		"1h": {
			"map menu humidity": "1 godz"
		},
		"Add new…": {
			"favorites menu": "Dodaj nowe…"
		},
		"Airspace": {
			"toggle menu": "Przestrzeń powietrzna"
		},
		"All": {
			"map menu humidity": "Wszystko"
		},
		"B. layer": {
			"map menu updrafts": "Warstwa graniczna"
		},
		"B. Layer": {
			"map menu wind": "Warstwa graniczna"
		},
		"Boundary layer": {
			"map menu wind": "Warstwa graniczna"
		},
		"Boundary Layer": {
			"map menu updrafts": "Warstwa graniczna",
			"layer legend A": "Warstwa graniczna",
			"layer legend B": "Warstwa graniczna"
		},
		"Ceiling": {
			"map menu updrafts": "Sufit",
			"layer legend B": "Sufit"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Pułap warstwy granicznej"
		},
		"Change password": {
			"settings menu": "Zmień hasło"
		},
		"Clouds": {
			"map menu humidity": "Chmury"
		},
		"Color blind": {
			"settings menu": "Kolor ciemno"
		},
		"debug": {
			"settings menu": "debugować"
		},
		"Delete": {
			"favorites menu": "Kasować"
		},
		"experimental": {
			"settings menu": "eksperymentalny"
		},
		"Experimental features": {
			"settings menu": "Opcje eksperymentalne"
		},
		"Favorites": {
			"menu title": "Ulubione"
		},
		"Ground": {
			"map menu wind": "Ziemia",
			"map menu temperature": "Ziemia"
		},
		"Help us translate!": {
			"settings menu": "Pomóż nam przetłumaczyć!"
		},
		"High": {
			"map menu humidity": "Wysoki"
		},
		"Humidity": {
			"map menu humidity": "Wilgotność"
		},
		"Interpolation": {
			"toggle menu": "Interpolacja"
		},
		"Language": {
			"settings menu": "Język"
		},
		"Login": {
			"login menu": "Zaloguj Się"
		},
		"Logout": {
			"settings menu": "Wyloguj się"
		},
		"Low": {
			"map menu humidity": "Nieskie"
		},
		"Medium": {
			"map menu humidity": "Średnie"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Przejdź na górę"
		},
		"News": {
			"news menu": "Aktualności"
		},
		"News!": {
			"news menu": "Aktualności!"
		},
		"No data for this place": {
			"windgram view": "Brak danych dla tego miejsca"
		},
		"Open": {
			"favorites menu": "Otwórz"
		},
		"Pressure": {
			"map menu wind": "Ciśnienie",
			"layer legend A": "Ciśnienie"
		},
		"Rain": {
			"map menu humidity": "Deszcz"
		},
		"Rename": {
			"favorites menu": "Zmień nazwę"
		},
		"Reset all settings": {
			"settings menu": "Zresetuj wszystkie ustawienia"
		},
		"Sea level": {
			"map menu wind": "Poziom morza"
		},
		"Set as homepage": {
			"favorites menu": "Ustaw jako stronę domową"
		},
		"Settings": {
			"settings menu": "Ustawienia"
		},
		"Shearing": {
			"map menu updrafts": "Udostępnianie",
			"layer legend B": "Udział"
		},
		"Sounding": {
			"windgram tab": "Sounding"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termika",
			"layer legend A": "Termika"
		},
		"Thickness": {
			"map menu updrafts": "Grubość",
			"layer legend B": "Grubość"
		},
		"Updrafts": {
			"map menu updrafts": "Prądy wstępujące"
		},
		"Velocity": {
			"map menu updrafts": "Prędkość",
			"layer legend B": "Prędkość"
		},
		"Vertical motion": {
			"map menu updrafts": "Ruch pionowy",
			"": "Ruch pionowy"
		},
		"Wind": {
			"map menu wind": "Wiatr",
			"layer legend A": "Wiatr"
		},
		"Wind Shear": {
			"map menu wind": "Udział wiatru",
			"layer legend A": "Udział wiatru"
		},
		"Windgram": {
			"windgram tab": "Windgram"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Bezwymiarowy"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Powierzchnia"
		},
		"Ceiling of BL": {
			"layer legend B": "Wysokość warstwy granicznej"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Zachmurzenie"
		},
		"Low altitude": {
			"layer legend B": "Niska wysokość"
		},
		"High altitude": {
			"layer legend B": "Wysoki pułap"
		},
		"Medium altitude": {
			"layer legend B": "Średnia wysokość"
		},
		"All altitudes": {
			"layer legend B": "Na wszystkich wysokościach"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2 m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Pionowe Ruchu"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Opady"
		},
		"1 hour": {
			"layer legend B": "1 godzina"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Średni na poziomie morza"
		},
		"Enter a name": {
			"new favorite prompt": "Wprowadź nazwę"
		},
		"Enter the new name": {
			"new favorite prompt": "Wprowadź nową nazwę"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Nadpisz ulubione \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Usuń ulubiony \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Czy na pewno chcesz zresetować wszystko?\nWSZYSTKIE USTAWIENIA I ULUBIONE BĘDĄ UTRACONE NA ZAWSZE!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Prognozy pogody | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Pomoc / Kontakt / O nas"
		},
		"Install now": {
			"version check": "Zainstaluj teraz"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Gwałtowne prognozy pogody"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente wymaga aktualizacji."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente jest teraz mobilne!\nPrognozy pogody specjalnie opracowane dla lotów i paralotniarstwa."
		},
		"Mobile app": "Aplikacja mobilna",
		"No internet connexion": "Brak połączenia z Internetem",
		"Community": "Wspólnota",
		"Day selection": "Wybór dnia",
		"knots": "węzły",
		"mph": "mph",
		"Radiation": "Promieniowanie",
		"Sun": "Sun",
		"Update": "Aktualizacja",
		"Wind unit": "Jednostka wiatrowa",
		"An error has occured. Please try again.": {
			"popup": "Wystąpił błąd. Proszę spróbować ponownie."
		},
		"Click here to renew.": {
			"login popup": "Kliknij tutaj, aby odnowić umowę."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kliknij łącze znajdujące się w wiadomości e-mail, aby zmienić swoje hasło."
		},
		"Close": {
			"popup": "Zamknij",
			"general": "Zamknij"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Wiadomości e-mail nie są takie same lub są nieważne"
		},
		"Error! Bad login or password": {
			"login popup": "Błąd! Zły login lub hasło"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Błąd! Twój dostęp wygasł w dniu %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Jeśli jesteś osobą, która wniosła swój wkład, otrzymasz wiadomość e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Ostatni krok..."
		},
		"Passwords must be the same": {
			"password popup": "Hasła muszą być takie same"
		},
		"Please log-in": {
			"login popup": "Zaloguj się"
		},
		"Private device − stay connected": {
			"login popup": "Urządzenie prywatne - pozostań w kontakcie"
		},
		"Read more…": {
			"contribute popup": "Czytaj dalej..."
		},
		"Reset your password": {
			"password popup": "Zresetuj swoje hasło"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Niektórzy operatorzy, tacy jak Orange, GMX i Hotmail, czasami blokują nasze e-maile. Jeśli nie otrzymujesz żadnych wiadomości, skontaktuj się z support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Witaj!"
		},
		"Same as device": {
			"timezone menu": "Tak jak urządzenie"
		},
		"Timezone": {
			"settings menu": "Strefa czasowa"
		},
		"XC Planner": {
			"toggle menu": "Planista XC"
		},
		"Multiplier": {
			"xc planner": "Mnożnik"
		},
		"Points": {
			"xc planner": "Punkty"
		},
		"Duration": {
			"xc planner": "Czas trwania"
		},
		"Speed": {
			"xc planner": "Prędkość"
		},
		"Close flight": {
			"xc planner": "Lot z bliska"
		},
		"Share": {
			"xc planner": "Udostępnij"
		},
		"Download": {
			"xc planner": "Pobierz",
			"general": "Pobierz"
		},
		"Preferences": {
			"xc planner": "Preferencje"
		},
		"Reset": {
			"xc planner": "Resetuj",
			"general": "Resetuj"
		},
		"About": {
			"xc planner": "O stronie"
		},
		"Exit Fullscreen": {
			"toggle menu": "Wyjdź z trybu pełnoekranowego"
		},
		"Fullscreen": {
			"toggle menu": "Fullscreen"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner jest funkcją eksperymentalną.\nJest ona dostępna tylko z komputera, na stronie meteo-parapente.com"
		},
		"Cancel": {
			"general": "Anuluj"
		},
		"Yes": {
			"general": "Tak"
		},
		"No": {
			"general": "Nr"
		},
		"Save": {
			"general": "Zapisz"
		},
		"Continue": {
			"general": "Kontynuuj"
		},
		"Original version": {
			"xc planner": "Wersja oryginalna"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Mocno zhakowane, aby działało w Meteo-Parapente, z autoryzacją Toma. Dziękuję!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Jednostki odległości"
		},
		"Altitude units": {
			"xc planner": "Jednostki wysokości"
		},
		"Coordinates format": {
			"xc planner": "Format współrzędnych"
		},
		"Turnpoint details": {
			"xc planner": "Szczegóły dotyczące punktów zwrotnych"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nazwa trasy"
		},
		"Waypoint prefix": {
			"xc planner": "Prefiks punktu trasy"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Wklej łącze do wiadomości e-mail lub komunikatora"
		},
		"Static image": {
			"xc planner": "Obraz statyczny"
		},
		"Open with XCTrack": {
			"xc planner": "Otwórz za pomocą XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Udostępnij w LocToMe: ustaw jako trasę domyślną"
		},
		"Go to": {
			"general": "Przejdź do"
		},
		"Error! Please try again later": {
			"update modal": "Błąd! Proszę spróbować ponownie później"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Naciśnij przycisk Resetuj, aby trwale zresetować trasę, lub naciśnij przycisk Anuluj, aby zachować trasę."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Oto Twój kod dostępu. Proszę go bezpiecznie przechowywać."
		},
		"Password:": {
			"contribute popup": "Hasło:"
		},
		"Thank you!": {
			"contribute popup": "Dziękuję!"
		},
		"Username:": {
			"contribute popup": "Nazwa użytkownika:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 miesięcy Standard - %{currency} %{pricing} / miesiąc"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 miesięcy Student - %{currency} %{pricing} / miesiąc"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "Kibic 12 miesięcy - %{currency} %{pricing} / miesiąc"
		},
		"Tour of Europe": {
			"tab": "Podróż po Europie"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Ciesz się najlepszymi prognozami każdego dnia. Meteo-Parapente może istnieć dzięki Tobie!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Uzyskaj bezpłatny wstęp na lokalne szkolenia pogodowe i spotkania użytkowników."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Dołącz do klubu współpracowników Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Spotykaj się ze mną raz w miesiącu, aby omówić nowe funkcje i ulepszenia."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente może istnieć dzięki Wam!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Moim celem jest dostarczenie wysokiej jakości narzędzia dostępnego dla każdego pilota."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Wspieranie rozwoju narzędzia jakości dostępnego dla wszystkich pilotów."
		},
		"and to the": {
			"startup terms": "i do"
		},
		"By using this application, you agree to the": {
			"startup terms": "Korzystając z tej aplikacji, użytkownik wyraża zgodę na"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Jeśli problem będzie się powtarzał, skontaktuj się z support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente nie używa plików cookie śledzących."
		},
		"privacy policy": {
			"startup terms": "polityka prywatności"
		},
		"terms of use": {
			"startup": "warunki użytkowania"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nie można połączyć się z serwerami Meteo-Parapente. Sprawdź swoje połączenie."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dni w tygodniu są zarezerwowane dla członków"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Jesteś już użytkownikiem? Kliknij, aby zresetować swoje hasło"
		},
		"Become a member": {
			"contribute menu": "Zostań członkiem",
			"popup": "Zostań członkiem"
		},
		"Click here to learn the details": {
			"contest": "Kliknij tutaj, aby poznać szczegóły"
		},
		"I am already a member": {
			"popup": "Jestem już członkiem"
		},
		"Learn more": {
			"contest": "Dowiedz się więcej"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente obchodzi 10-lecie istnienia."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Nie jesteś jeszcze członkiem? Kliknij, aby otrzymać kod dostępu"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Z tej okazji organizujemy wyjątkowy konkurs"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Jeden zwycięzca zostanie wylosowany spośród wszystkich osób, które zakupiły lub odnowiły prenumeratę w okresie od września ubiegłego roku do 30 marca przyszłego roku."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Do wygrania: WYBRANE PRZEZ CIEBIE SKRZYDŁO PARALOTNI!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Aby zobaczyć %{ date }, zaloguj się lub zostań członkiem."
		},
		"Win a paraglider!": {
			"contribute menu": "Wygraj paralotnię!"
		}
	},
	"pt": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Parapente"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Adicionar novo"
		},
		"Airspace": {
			"toggle menu": "Espaço aéreo"
		},
		"All": {
			"map menu humidity": "Tudo"
		},
		"B. layer": {
			"map menu updrafts": "Camada.B"
		},
		"B. Layer": {
			"map menu wind": "Camada.B"
		},
		"Boundary layer": {
			"map menu wind": "Camada limite"
		},
		"Boundary Layer": {
			"map menu updrafts": "Camada limite",
			"layer legend A": "Camada limite",
			"layer legend B": "Camada limite"
		},
		"Ceiling": {
			"map menu updrafts": "Tecto",
			"layer legend B": "Tecto"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Tecto da camada b."
		},
		"Change password": {
			"settings menu": "Mudar a palavra-chave"
		},
		"Clouds": {
			"map menu humidity": "Nuvens"
		},
		"Color blind": {
			"settings menu": "Daltónico"
		},
		"debug": {
			"settings menu": "depurar"
		},
		"Delete": {
			"favorites menu": "Apagar"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Funcionalidades experimentais"
		},
		"Favorites": {
			"menu title": "Favoritos"
		},
		"Ground": {
			"map menu wind": "Solo",
			"map menu temperature": "Solo"
		},
		"Help us translate!": {
			"settings menu": "Ajude-nos a traduzir!"
		},
		"High": {
			"map menu humidity": "Alto"
		},
		"Humidity": {
			"map menu humidity": "Humidade"
		},
		"Interpolation": {
			"toggle menu": "Interpolação"
		},
		"Language": {
			"settings menu": "Idioma"
		},
		"Login": {
			"login menu": "Entrar"
		},
		"Logout": {
			"settings menu": "Sair"
		},
		"Low": {
			"map menu humidity": "Baixo"
		},
		"Medium": {
			"map menu humidity": "Médio"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Mover para o topo"
		},
		"News": {
			"news menu": "Notícias"
		},
		"News!": {
			"news menu": "Notícias!"
		},
		"No data for this place": {
			"windgram view": "Sem dados para este local"
		},
		"Open": {
			"favorites menu": "Abrir"
		},
		"Pressure": {
			"map menu wind": "Pressão",
			"layer legend A": "Pressão"
		},
		"Rain": {
			"map menu humidity": "Chuva"
		},
		"Rename": {
			"favorites menu": "Renomear"
		},
		"Reset all settings": {
			"settings menu": "Reinicializar todos os parâmetros"
		},
		"Sea level": {
			"map menu wind": "Nível do mar"
		},
		"Set as homepage": {
			"favorites menu": "Definir como página inicial"
		},
		"Settings": {
			"settings menu": "Parâmetros"
		},
		"Shearing": {
			"map menu updrafts": "Corte",
			"layer legend B": "Corte"
		},
		"Sounding": {
			"windgram tab": "Sondagem"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Térmicas",
			"layer legend A": "Térmicas"
		},
		"Thickness": {
			"map menu updrafts": "Espessura",
			"layer legend B": "Espessura"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendentes"
		},
		"Velocity": {
			"map menu updrafts": "Velocidade",
			"layer legend B": "Velocidade"
		},
		"Vertical motion": {
			"map menu updrafts": "Movimento vertical",
			"": "Movimento vertical"
		},
		"Wind": {
			"map menu wind": "Vento",
			"layer legend A": "Vento"
		},
		"Wind Shear": {
			"map menu wind": "Cisalhamento do vento",
			"layer legend A": "Cisalhamento do vento"
		},
		"Windgram": {
			"windgram tab": "Diagrama do vento"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografia"
		},
		"Model": {
			"layer legend B": "Modelo"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "adimensional"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Superfície"
		},
		"Ceiling of BL": {
			"layer legend B": "Tecto de BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Cobertura de nuvens"
		},
		"Low altitude": {
			"layer legend B": "Baixa altitude"
		},
		"High altitude": {
			"layer legend B": "Altitude alta"
		},
		"Medium altitude": {
			"layer legend B": " Altitude média"
		},
		"All altitudes": {
			"layer legend B": "Todas as altitudes"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Movimento vertical"
		},
		"mm/h": {
			"layer unit": "\n mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitações"
		},
		"1 hour": {
			"layer legend B": "1 hora"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Nível médio do mar"
		},
		"Enter a name": {
			"new favorite prompt": "Digite um nome"
		},
		"Enter the new name": {
			"new favorite prompt": "Digite o novo nome"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Reescrever favorito \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Apagar favorito \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Tem certeza que quer reinicializar tudo ?\nTODOS OS SEUS PARÂMETROS E FAVORITOS SERÃO PERMANENTEMENTE APAGADOS!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Previsões meteorológicas | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ajuda / Contacto / Sobre"
		},
		"Install now": {
			"version check": "Instalar agora"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Previsão do tempo"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente requer uma actualização"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente é agora móvel!\nPrevisões meteorológicas especialmente projetadas para vôo em parapente."
		},
		"Mobile app": "Aplicação móvel",
		"No internet connexion": "Sem conexão à internet",
		"Community": "Comunidade",
		"Day selection": "Selecção de dia",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Radiação",
		"Sun": "Sol",
		"Update": "Actualizar",
		"Wind unit": "Unidade do vento",
		"An error has occured. Please try again.": {
			"popup": "Aconteceu um erro. Por favor tente de novo."
		},
		"Click here to renew.": {
			"login popup": "Clique aqui para renovar"
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Clique no atalho no e-mail para alterar a sua palavra-passe."
		},
		"Close": {
			"popup": "Fechar",
			"general": "Fechar"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Emails diferentes ou inválidos"
		},
		"Error! Bad login or password": {
			"login popup": "Erro! nome de utilizador ou palavra-passe errada"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "\n Erro! O seu acesso expirou em %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Se você é um contribuidor irá perceber um e-mail."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Um último passo..."
		},
		"Passwords must be the same": {
			"password popup": "Palavras-passe devem ser as mesmas"
		},
		"Please log-in": {
			"login popup": "Por favor entregar"
		},
		"Private device − stay connected": {
			"login popup": "Dispositivo  privado - permanecer conectado"
		},
		"Read more…": {
			"contribute popup": "Ler mais..."
		},
		"Reset your password": {
			"password popup": "Reinicializar a sua palavra-passe"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Alguns fornecedores tais como a Orange, GMX e Hotmail às vezes bloqueiam os nossos e-mails. Se não receber nada, por favor contacte support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bem-vindo!"
		},
		"Same as device": {
			"timezone menu": "Igual ao dispositivo"
		},
		"Timezone": {
			"settings menu": "Fuso horário"
		},
		"XC Planner": {
			"toggle menu": "XC Planner"
		},
		"Multiplier": {
			"xc planner": "Multiplicador"
		},
		"Points": {
			"xc planner": "Pontos"
		},
		"Duration": {
			"xc planner": "Duracão"
		},
		"Speed": {
			"xc planner": "Velocidade"
		},
		"Close flight": {
			"xc planner": "Fechar vôo"
		},
		"Share": {
			"xc planner": "Partilhar"
		},
		"Download": {
			"xc planner": "Descarregar",
			"general": "Descarregar"
		},
		"Preferences": {
			"xc planner": "Preferências"
		},
		"Reset": {
			"xc planner": "Reinicializar",
			"general": "Reinicializar"
		},
		"About": {
			"xc planner": "Sobre"
		},
		"Exit Fullscreen": {
			"toggle menu": "Sair do ecrã completo"
		},
		"Fullscreen": {
			"toggle menu": "Ecrã completo"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner é uma funcionalidade experimental.\nEla só está disponível num computador, em meteo-parapente.com"
		},
		"Cancel": {
			"general": "Cancelar"
		},
		"Yes": {
			"general": "Sim"
		},
		"No": {
			"general": "Não"
		},
		"Save": {
			"general": "Guardar"
		},
		"Continue": {
			"general": "Continuar"
		},
		"Original version": {
			"xc planner": "Versão original"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Fortemente hackeado para trabalhar em Meteo-Parapente, com autorização do Tom. Obrigado!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Unidades de distância"
		},
		"Altitude units": {
			"xc planner": "Unidades de altitude"
		},
		"Coordinates format": {
			"xc planner": "Formato das coordenadas"
		},
		"Turnpoint details": {
			"xc planner": "Detalhe da baliza"
		},
		"Format": {
			"xc planner": "Formato"
		},
		"Route name": {
			"xc planner": "Nome da rota"
		},
		"Waypoint prefix": {
			"xc planner": "Prefixo da baliza"
		},
		"Lien": {
			"xc planner": "Atalho"
		},
		"Paste link in email or IM": {
			"xc planner": "Cole o atalho no e-mail ou IM"
		},
		"Static image": {
			"xc planner": "Imagem estática"
		},
		"Open with XCTrack": {
			"xc planner": "Abrir com o XCTrsck"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Partilhar com o LocToMe: definir como rota por omissão."
		},
		"Go to": {
			"general": "Ir para"
		},
		"Error! Please try again later": {
			"update modal": "Erro! Tente mais tarde, pf"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Pressione Reiniciar para redefinir sua rota permanentemente, pressione Cancelar para manter sua rota."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Este é o seu código de acesso. Por favor, mantenha-o seguro."
		},
		"Password:": {
			"contribute popup": "Senha:"
		},
		"Thank you!": {
			"contribute popup": "Obrigado!"
		},
		"Username:": {
			"contribute popup": "Utilizador:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Standard － %{currency} %{pricing} / mês"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Estudante－ %{currency} %{pricing} / mês"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 meses Patrocinador － %{currency} %{pricing} / mês"
		},
		"Tour of Europe": {
			"tab": "Volta à Europa"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Disfrute das melhores previsões todos os dias. Meteo-Parapente existe graças a si!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Participe gratis em formações meteo e reuniões entre utilizadores."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Junta-te aos contribuintes do Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Encontro mensal para discutir novas funções e melhorias."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Mete-Parapente existe graças a si!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "O meu objectivo é fornecer uma ferramenta de qualidade acessível a todos os pilotos."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Apoie o desenvolvimento de uma ferramenta de qualidade acessivel a todos os pilotos"
		},
		"and to the": {
			"startup terms": "e para o"
		},
		"By using this application, you agree to the": {
			"startup terms": "Ao utilizar a aplicação, concorda com"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Se o problema persisitir, contacte support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente não usa cookies de rastreio."
		},
		"privacy policy": {
			"startup terms": "politica de privacidade"
		},
		"terms of use": {
			"startup": "regras de utilização"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Impossivel ligar aos servidores Meteo-Parapente. Por favor, verifique a sua ligação."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dias por semana são reservados aos membros"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Já é um membro? Clique para redefinir sua senha"
		},
		"Become a member": {
			"contribute menu": "Torne-se um membro",
			"popup": "Torne-se um membro"
		},
		"Click here to learn the details": {
			"contest": "Clique aqui para saber os detalhes"
		},
		"I am already a member": {
			"popup": "Eu já sou um membro"
		},
		"Learn more": {
			"contest": "Saiba mais"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "O Meteo-Parapente celebra o seu 10º aniversário."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Ainda não é um membro? Clique para obter um código de acesso"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Nesta ocasião, estamos a organizar um concurso excepcional"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Um vencedor será sorteado de todos aqueles que compraram ou renovaram uma assinatura entre setembro passado e 30 de março próximo."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Para ser ganho: A ALA PARAPENTE DA SUA ESCOLHA!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Para ver %{ date }, por favor faça o login ou torne-se membro."
		},
		"Win a paraglider!": {
			"contribute menu": "Ganhe um parapente!"
		}
	},
	"ro": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Zbor cu parapanta"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Adaugă nou... "
		},
		"Airspace": {
			"toggle menu": "Spațiu aerian"
		},
		"All": {
			"map menu humidity": "Tot"
		},
		"B. layer": {
			"map menu updrafts": "Strat convectiv"
		},
		"B. Layer": {
			"map menu wind": "Strat convectiv"
		},
		"Boundary layer": {
			"map menu wind": "Strat convectiv"
		},
		"Boundary Layer": {
			"map menu updrafts": "Strat convectiv",
			"layer legend A": "Strat convectiv",
			"layer legend B": "Strat convectiv"
		},
		"Ceiling": {
			"map menu updrafts": "Plafon",
			"layer legend B": "Plafon"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Plafon strat convectiv"
		},
		"Change password": {
			"settings menu": "Schimbare parolă"
		},
		"Clouds": {
			"map menu humidity": "Nori"
		},
		"Color blind": {
			"settings menu": "Daltonism"
		},
		"debug": {
			"settings menu": "Depanare"
		},
		"Delete": {
			"favorites menu": "Șterge"
		},
		"experimental": {
			"settings menu": "experimental"
		},
		"Experimental features": {
			"settings menu": "Funcții experimentale"
		},
		"Favorites": {
			"menu title": "Preferate"
		},
		"Ground": {
			"map menu wind": "Sol",
			"map menu temperature": "Sol"
		},
		"Help us translate!": {
			"settings menu": "Ajutați-ne să traducem!"
		},
		"High": {
			"map menu humidity": "Înalt"
		},
		"Humidity": {
			"map menu humidity": "Umiditate"
		},
		"Interpolation": {
			"toggle menu": "Interpolare"
		},
		"Language": {
			"settings menu": "Limba"
		},
		"Login": {
			"login menu": "Login"
		},
		"Logout": {
			"settings menu": "Logout"
		},
		"Low": {
			"map menu humidity": "Jos"
		},
		"Medium": {
			"map menu humidity": "Mediu"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapantă"
		},
		"Move to top": {
			"favorites menu": "Intoarce-ți-vă sus"
		},
		"News": {
			"news menu": "Știri"
		},
		"News!": {
			"news menu": "Știri!"
		},
		"No data for this place": {
			"windgram view": "Nu sunt date pt. această locație"
		},
		"Open": {
			"favorites menu": "Deschide"
		},
		"Pressure": {
			"map menu wind": "Presiune",
			"layer legend A": "Presiune"
		},
		"Rain": {
			"map menu humidity": "Ploaie"
		},
		"Rename": {
			"favorites menu": "Redenumiți"
		},
		"Reset all settings": {
			"settings menu": "Resetați toate reglajele"
		},
		"Sea level": {
			"map menu wind": "Nivelul mării"
		},
		"Set as homepage": {
			"favorites menu": "Setați ca Acasă"
		},
		"Settings": {
			"settings menu": "Setări"
		},
		"Shearing": {
			"map menu updrafts": "Forfecare",
			"layer legend B": "Forfecare"
		},
		"Sounding": {
			"windgram tab": "Gradient termic"
		},
		"Temperature": {
			"map menu temperature": "Temperatură",
			"layer legend A": "Temperatură"
		},
		"Thermals": {
			"map menu updrafts": "Ascendențe termice",
			"layer legend A": "Ascendențe termice"
		},
		"Thickness": {
			"map menu updrafts": "Grosime",
			"layer legend B": "Grosime"
		},
		"Updrafts": {
			"map menu updrafts": "Ascendențe"
		},
		"Velocity": {
			"map menu updrafts": "Viteză",
			"layer legend B": "Viteza"
		},
		"Vertical motion": {
			"map menu updrafts": "Mișcare verticală",
			"": "Mișcare verticală "
		},
		"Wind": {
			"map menu wind": "Vânt",
			"layer legend A": "Vânt"
		},
		"Wind Shear": {
			"map menu wind": "Vânt de forfecare",
			"layer legend A": "Vânt de forfecare"
		},
		"Windgram": {
			"windgram tab": "Grafic vânt"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografie"
		},
		"Model": {
			"layer legend B": "Model"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "adimensional"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Suprafață"
		},
		"Ceiling of BL": {
			"layer legend B": "Plafon Strat Conv. "
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Acoperire nori"
		},
		"Low altitude": {
			"layer legend B": "Altitudine joasă"
		},
		"High altitude": {
			"layer legend B": "Altitudine înaltă"
		},
		"Medium altitude": {
			"layer legend B": "Altitudine medie"
		},
		"All altitudes": {
			"layer legend B": "Toate altitudinile"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Mișcare verticală"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Precipitații"
		},
		"1 hour": {
			"layer legend B": "1 oră"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Deasupra Nivelului Mării"
		},
		"Enter a name": {
			"new favorite prompt": "Introduceți un nume"
		},
		"Enter the new name": {
			"new favorite prompt": "Introduceți un nou nume"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Rescrieți preferat \"%{ nume }\"? "
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Ștergeți preferat \"%{ nume }\"? "
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Sunteți sigur ca vreți sa resetați tot?\nTOATE SETĂRILE DUMNEAVOASTRĂ ȘI PREFERATELE VOR FI ȘTERSE PERMANENT! "
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Predicții meteo pentru zbor liber | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Ajutor / Contactați-ne / Despre"
		},
		"Install now": {
			"version check": "Instalați acum"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Predicții Meteo Zbor liber"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente necesită actualizare."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente este acum mobil! Predicții meteo pentru zbor liber. "
		},
		"Mobile app": "Mobile app",
		"No internet connexion": "Fără conexiune la internet",
		"Community": "Comunitate",
		"Day selection": "Selectați ziua",
		"knots": "noduri",
		"mph": "mph",
		"Radiation": "Radiație",
		"Sun": "Soare",
		"Update": "Actualizare",
		"Wind unit": "Unitate vânt",
		"An error has occured. Please try again.": {
			"popup": "A apărut o eroare. Vă rugăm reîncărcați. "
		},
		"Click here to renew.": {
			"login popup": "Click pentru reînnoire. "
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Click per link-ul din e-mail pentru a va schimba parola. "
		},
		"Close": {
			"popup": "Închide",
			"general": "Închideți"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-mailurile nu coincid sau invalide. "
		},
		"Error! Bad login or password": {
			"login popup": "Eroare! Nume utilizator sau parola greșite. "
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Eroare! Accesul dumneavoastră a expirat în %{ expirationDate }. "
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Dacă sunteți contribuitor, o sa primiți un mail. "
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Ultimul pas... "
		},
		"Passwords must be the same": {
			"password popup": "Parola trebuie sa fie aceeași "
		},
		"Please log-in": {
			"login popup": "Va rugam sa va autentificați "
		},
		"Private device − stay connected": {
			"login popup": "Dispozitiv privat - rămâneți conectat"
		},
		"Read more…": {
			"contribute popup": "Citiți mai multe... "
		},
		"Reset your password": {
			"password popup": "Resetați parola"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Câțiva furnizori (gmail, yahoo, etc) câteodată blochează E-mailurile. Dacă nu primiți nimic contactați support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Bine ați venit! "
		},
		"Same as device": {
			"timezone menu": "La fel ca dispozitivul"
		},
		"Timezone": {
			"settings menu": "Fus orar"
		},
		"XC Planner": {
			"toggle menu": "Planificator XC"
		},
		"Multiplier": {
			"xc planner": "Coeficient "
		},
		"Points": {
			"xc planner": "Puncte"
		},
		"Duration": {
			"xc planner": "Durată"
		},
		"Speed": {
			"xc planner": "Viteză "
		},
		"Close flight": {
			"xc planner": "Închideți zbor"
		},
		"Share": {
			"xc planner": "Împărtășiți "
		},
		"Download": {
			"xc planner": "Descărcați ",
			"general": "Descărcați"
		},
		"Preferences": {
			"xc planner": "Preferințe "
		},
		"Reset": {
			"xc planner": "Resetați ",
			"general": "Reset"
		},
		"About": {
			"xc planner": "Despre"
		},
		"Exit Fullscreen": {
			"toggle menu": "Ieșiți din ecran complet"
		},
		"Fullscreen": {
			"toggle menu": "Ecran complet"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planer este o funcție experimentală. Este disponibilă doar pe PC pe meteo-Parapente.com"
		},
		"Cancel": {
			"general": "Anulați"
		},
		"Yes": {
			"general": "Da"
		},
		"No": {
			"general": "Nu"
		},
		"Save": {
			"general": "Salvați"
		},
		"Continue": {
			"general": "Continuați"
		},
		"Original version": {
			"xc planner": "Versiune originală"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!"
		},
		"League": {
			"xc planner": "Ligă"
		},
		"Distance units": {
			"xc planner": "Unități distanță"
		},
		"Altitude units": {
			"xc planner": "Unități altitudine"
		},
		"Coordinates format": {
			"xc planner": "Format coordinate"
		},
		"Turnpoint details": {
			"xc planner": "Detalii punct de trecere"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Nume rută "
		},
		"Waypoint prefix": {
			"xc planner": "Prefix pct trecere"
		},
		"Lien": {
			"xc planner": "Link"
		},
		"Paste link in email or IM": {
			"xc planner": "Lipiți link-ul în email sai IM"
		},
		"Static image": {
			"xc planner": "Imagine statica"
		},
		"Open with XCTrack": {
			"xc planner": "Deschideți cu XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Distribuiti cu LocToMe: setați ca rută implicită"
		},
		"Go to": {
			"general": "Mergeți la"
		},
		"Error! Please try again later": {
			"update modal": "Eroare! Vă rugăm încercați mai târziu. "
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Apăsați Reset pentru a reseta permanent ruta dv., apăsați Anulați ca să păstrați ruta dv. "
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Iată codul de acces. Vă rugăm să îl păstrați în siguranță."
		},
		"Password:": {
			"contribute popup": "Parola:"
		},
		"Thank you!": {
			"contribute popup": "Vă mulțumesc!"
		},
		"Username:": {
			"contribute popup": "Nume de utilizator:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 luni Standard - %{currency} %{pricing} / lună"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 luni Student - %{currency} %{pricing} / lună"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 luni Supporter - %{currency} %{pricing} / lună"
		},
		"Tour of Europe": {
			"tab": "Turul Europei"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Bucurați-vă de cele mai bune prognoze în fiecare zi. Meteo-Parapente poate exista datorită dumneavoastră!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Obțineți acces gratuit la cursuri de formare și întâlniri ale utilizatorilor de vreme locală."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Înscrieți-vă în clubul contribuitorilor Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Întâlniți-vă cu mine o dată pe lună pentru a discuta despre noile caracteristici și îmbunătățiri."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente poate exista datorită vouă!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Scopul meu este de a oferi un instrument de calitate accesibil tuturor piloților."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Sprijinirea dezvoltării unui instrument de calitate accesibil tuturor piloților."
		},
		"and to the": {
			"startup terms": "și la"
		},
		"By using this application, you agree to the": {
			"startup terms": "Prin utilizarea acestei aplicații, sunteți de acord cu"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Dacă problema persistă, contactați support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente nu utilizează cookie-uri de urmărire"
		},
		"privacy policy": {
			"startup terms": "politica de confidențialitate"
		},
		"terms of use": {
			"startup": "termeni de utilizare"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Nu se poate ajunge la serverele Meteo-Parapente. Vă rugăm să vă verificați conexiunea."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 zile pe săptămână sunt rezervate membrilor"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Sunteți deja membru? Faceți clic pentru a vă reseta parola"
		},
		"Become a member": {
			"contribute menu": "Deveniți membru",
			"popup": "Deveniți membru"
		},
		"Click here to learn the details": {
			"contest": "Click aici pentru a afla detalii"
		},
		"I am already a member": {
			"popup": "Sunt deja membru"
		},
		"Learn more": {
			"contest": "Aflați mai multe"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente sărbătorește a 10-a aniversare."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Nu sunteți încă membru? Faceți clic pentru a obține un cod de acces"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Cu această ocazie, organizăm un concurs de excepție"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Se va extrage un câștigător dintre toți cei care au cumpărat sau reînnoit un abonament între septembrie și 30 martie anul viitor."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Pentru a fi câștigat: ARIPA DE PARAPANTĂ LA ALEGERE!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Pentru a vedea %{ date }, vă rugăm să vă conectați sau să deveniți membru."
		},
		"Win a paraglider!": {
			"contribute menu": "Câștigă un parapantă!"
		}
	},
	"ru": {
		"(Kitesurf)": {
			"search result": "(Кайтсерфинг)"
		},
		"(Paragliding)": {
			"search result": "(Парапланеризм)"
		},
		"1h": {
			"map menu humidity": "1ч"
		},
		"Add new…": {
			"favorites menu": "Добавить новый..."
		},
		"Airspace": {
			"toggle menu": "Воздушное пространство"
		},
		"All": {
			"map menu humidity": "Все"
		},
		"B. layer": {
			"map menu updrafts": "Слой"
		},
		"B. Layer": {
			"map menu wind": "Слой"
		},
		"Boundary layer": {
			"map menu wind": "Пограничный слой"
		},
		"Boundary Layer": {
			"map menu updrafts": "Пограничный слой",
			"layer legend A": "Пограничный слой",
			"layer legend B": "Пограничный слой"
		},
		"Ceiling": {
			"map menu updrafts": "Потолок",
			"layer legend B": "Потолок"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Потолок слоя b."
		},
		"Change password": {
			"settings menu": "Сменить пароль"
		},
		"Clouds": {
			"map menu humidity": "Облака"
		},
		"Color blind": {
			"settings menu": "Дальтоник"
		},
		"debug": {
			"settings menu": "отладка"
		},
		"Delete": {
			"favorites menu": "Удалить"
		},
		"experimental": {
			"settings menu": "экспериментальный"
		},
		"Experimental features": {
			"settings menu": "Экспериментальные характеристики"
		},
		"Favorites": {
			"menu title": "Избранное"
		},
		"Ground": {
			"map menu wind": "Земля",
			"map menu temperature": "Земля"
		},
		"Help us translate!": {
			"settings menu": "Помогите с переводом"
		},
		"High": {
			"map menu humidity": "Высокий"
		},
		"Humidity": {
			"map menu humidity": "Влажность"
		},
		"Interpolation": {
			"toggle menu": "Интерполяция"
		},
		"Language": {
			"settings menu": "Язык"
		},
		"Login": {
			"login menu": "Войти"
		},
		"Logout": {
			"settings menu": "Выйти"
		},
		"Low": {
			"map menu humidity": "Низкий"
		},
		"Medium": {
			"map menu humidity": "Средний"
		},
		"Meteo Parapente": {
			"menu title": "Метеопарапенте"
		},
		"Move to top": {
			"favorites menu": "Наверх"
		},
		"News": {
			"news menu": "Новости"
		},
		"News!": {
			"news menu": "Новости!"
		},
		"No data for this place": {
			"windgram view": "Нет данных для этой местности"
		},
		"Open": {
			"favorites menu": "Открыть"
		},
		"Pressure": {
			"map menu wind": "Давление",
			"layer legend A": "Давление"
		},
		"Rain": {
			"map menu humidity": "Дождь"
		},
		"Rename": {
			"favorites menu": "Переименовать"
		},
		"Reset all settings": {
			"settings menu": "Сброс всех настроек"
		},
		"Sea level": {
			"map menu wind": "Уровень моря"
		},
		"Set as homepage": {
			"favorites menu": "Установить в качестве домашней страницы"
		},
		"Settings": {
			"settings menu": "Настройки"
		},
		"Shearing": {
			"map menu updrafts": "Стрижка",
			"layer legend B": "Сдвиг"
		},
		"Sounding": {
			"windgram tab": "Аэрологическая диаграмма"
		},
		"Temperature": {
			"map menu temperature": "Температура",
			"layer legend A": "Температура"
		},
		"Thermals": {
			"map menu updrafts": "Восходящие потоки",
			"layer legend A": "Восходящие потоки"
		},
		"Thickness": {
			"map menu updrafts": "Толщина",
			"layer legend B": "Толщина"
		},
		"Updrafts": {
			"map menu updrafts": "Апдрафт"
		},
		"Velocity": {
			"map menu updrafts": "Скорость",
			"layer legend B": "Скорость"
		},
		"Vertical motion": {
			"map menu updrafts": "Вертикальное движение",
			"": "Вертикальное движение"
		},
		"Wind": {
			"map menu wind": "Ветер",
			"layer legend A": "Ветер"
		},
		"Wind Shear": {
			"map menu wind": "сдвиг ветра",
			"layer legend A": "Сдвиг ветра"
		},
		"Windgram": {
			"windgram tab": "График ветра"
		},
		"m MSL": {
			"layer unit": "м MSL"
		},
		"m AGL": {
			"layer unit": "м AGL"
		},
		"Topography": {
			"layer legend A": "Топография"
		},
		"Model": {
			"layer legend B": "Модель"
		},
		"m/s": {
			"layer unit": "м/с",
			"": "м/с"
		},
		"dimensionless": {
			"layer unit": "безразмерный"
		},
		"km/h": {
			"layer unit": "км/ч",
			"": "км/ч"
		},
		"Surface": {
			"layer legend B": "Поверхность"
		},
		"Ceiling of BL": {
			"layer legend B": "Потолок BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Облачность"
		},
		"Low altitude": {
			"layer legend B": "Малая высота"
		},
		"High altitude": {
			"layer legend B": "Большая высота"
		},
		"Medium altitude": {
			"layer legend B": "Средняя высота"
		},
		"All altitudes": {
			"layer legend B": "Все высоты"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2м AGL"
		},
		"Vertical Motion": {
			"layer legend A": "Вертикальное движение"
		},
		"mm/h": {
			"layer unit": "мм/ч"
		},
		"Precipitations": {
			"layer legend A": "Осадки"
		},
		"1 hour": {
			"layer legend B": "1 час"
		},
		"hPa": {
			"layer unit": "гПа"
		},
		"Mean Sea Level": {
			"layer legend B": "Уровень моря"
		},
		"Enter a name": {
			"new favorite prompt": "Введите имя"
		},
		"Enter the new name": {
			"new favorite prompt": "Введите новое имя"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Перезаписать \"%{ name }\"?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Удалить \"%{ name }\"?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Вы уверены, что хотите сбросить все настройки?\nВСЕ ВАШИ НАСТРОЙКИ И ИЗБРАННОЕ БУДЕТ ПОТЕРЯНО НАВСЕГДА"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Парящие прогнозы погоды | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Помощь / Контакты / О сайте"
		},
		"Install now": {
			"version check": "Установить"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Повышение прогнозов погоды"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente требует обновления."
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente теперь в мобильном!\nПрогнозы парящей погоды, специально разработанные для полетов и парапланеризма."
		},
		"Mobile app": "Мобильное приложение",
		"No internet connexion": "Отсутствие подключения к Интернету",
		"Community": "Сообщество",
		"Day selection": "Выбор дня",
		"knots": "узлы",
		"mph": "mph",
		"Radiation": "Излучение",
		"Sun": "Солнце",
		"Update": "Обновление",
		"Wind unit": "Единица скорости ветра",
		"An error has occured. Please try again.": {
			"popup": "Произошла ошибка. Пожалуйста, попробуйте еще раз."
		},
		"Click here to renew.": {
			"login popup": "Нажмите здесь, чтобы продлить."
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Нажмите на ссылку в письме, чтобы изменить пароль."
		},
		"Close": {
			"popup": "Закрыть",
			"general": "Закрыть"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "Электронные письма не одинаковы и недействительны"
		},
		"Error! Bad login or password": {
			"login popup": "Ошибка! Плохой логин или пароль"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Ошибка! Ваш доступ истек в %{ expirationDate }."
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Если вы являетесь вкладчиком, вы получите электронное письмо."
		},
		"OK": {
			"popup": "OK",
			"general": "OK"
		},
		"One last step...": {
			"password popup": "Последний шаг..."
		},
		"Passwords must be the same": {
			"password popup": "Пароли должны быть одинаковыми"
		},
		"Please log-in": {
			"login popup": "Пожалуйста, войдите в систему"
		},
		"Private device − stay connected": {
			"login popup": "Личное устройство - оставайтесь на связи"
		},
		"Read more…": {
			"contribute popup": "Читать далее..."
		},
		"Reset your password": {
			"password popup": "Сброс пароля"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Некоторые провайдеры, такие как Orange, GMX и Hotmail, иногда блокируют нашу электронную почту. Если вы ничего не получаете, пожалуйста, свяжитесь с support@meteo&#x2011;parapente.com"
		},
		"Welcome!": {
			"login popup": "Добро пожаловать!"
		},
		"Same as device": {
			"timezone menu": "То же, что и устройство"
		},
		"Timezone": {
			"settings menu": "Часовой пояс"
		},
		"XC Planner": {
			"toggle menu": "Планировщик XC"
		},
		"Multiplier": {
			"xc planner": "Множитель"
		},
		"Points": {
			"xc planner": "Баллы"
		},
		"Duration": {
			"xc planner": "Продолжительность"
		},
		"Speed": {
			"xc planner": "Скорость"
		},
		"Close flight": {
			"xc planner": "Близкий полет"
		},
		"Share": {
			"xc planner": "Поделиться"
		},
		"Download": {
			"xc planner": "Скачать",
			"general": "Скачать"
		},
		"Preferences": {
			"xc planner": "Предпочтения"
		},
		"Reset": {
			"xc planner": "Сброс",
			"general": "Сброс"
		},
		"About": {
			"xc planner": "О сайте"
		},
		"Exit Fullscreen": {
			"toggle menu": "Выход из полноэкранного режима"
		},
		"Fullscreen": {
			"toggle menu": "Полный экран"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner - это экспериментальная функция.\nОна доступна только с компьютера, на сайте meteo-parapente.com"
		},
		"Cancel": {
			"general": "Отмена"
		},
		"Yes": {
			"general": "Да"
		},
		"No": {
			"general": "Нет"
		},
		"Save": {
			"general": "Сохранить"
		},
		"Continue": {
			"general": "Продолжить"
		},
		"Original version": {
			"xc planner": "Оригинальная версия"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "Сильно взломан для работы в Meteo-Parapente, с разрешения Тома. Спасибо!"
		},
		"League": {
			"xc planner": "Лига"
		},
		"Distance units": {
			"xc planner": "Единицы измерения расстояния"
		},
		"Altitude units": {
			"xc planner": "Единицы измерения высоты"
		},
		"Coordinates format": {
			"xc planner": "Формат координат"
		},
		"Turnpoint details": {
			"xc planner": "Детали поворотного пункта"
		},
		"Format": {
			"xc planner": "Формат"
		},
		"Route name": {
			"xc planner": "Название маршрута"
		},
		"Waypoint prefix": {
			"xc planner": "Префикс путевой точки"
		},
		"Lien": {
			"xc planner": "Ссылка"
		},
		"Paste link in email or IM": {
			"xc planner": "Вставьте ссылку в сообщение электронной почты или IM"
		},
		"Static image": {
			"xc planner": "Статичное изображение"
		},
		"Open with XCTrack": {
			"xc planner": "Открыть с помощью XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Совместное использование с LocToMe: установить в качестве маршрута по умолчанию"
		},
		"Go to": {
			"general": "Перейти к"
		},
		"Error! Please try again later": {
			"update modal": "Ошибка! Пожалуйста, повторите попытку позже"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Нажмите Сброс, чтобы навсегда сбросить маршрут, нажмите Отмена, чтобы сохранить маршрут."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Здесь находится ваш код доступа. Пожалуйста, храните его в безопасности."
		},
		"Password:": {
			"contribute popup": "Пароль:"
		},
		"Thank you!": {
			"contribute popup": "Спасибо!"
		},
		"Username:": {
			"contribute popup": "Имя пользователя:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 месяцев Стандарт - %{currency} %{pricing} / месяц"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 месяцев Студент - %{currency} %{pricing} / месяц"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 месяцев Сторонник - %{currency} %{pricing} / месяц"
		},
		"Tour of Europe": {
			"tab": "Тур по Европе"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Наслаждайтесь лучшими прогнозами каждый день. Meteo-Parapente может существовать благодаря вам!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Получите бесплатный вход на тренинги по местной погоде и встречи пользователей."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Вступить в клуб вкладчиков Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Встречайтесь со мной раз в месяц для обсуждения новых функций и улучшений."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente может существовать благодаря вам!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Моя цель - предоставить качественный инструмент, доступный каждому пилоту."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Поддержите разработку инструмента качества, доступного каждому пилоту."
		},
		"and to the": {
			"startup terms": "и к"
		},
		"By using this application, you agree to the": {
			"startup terms": "Используя данное приложение, вы соглашаетесь с"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Если проблема сохраняется, обратитесь по адресу support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente не использует отслеживающие файлы cookie"
		},
		"privacy policy": {
			"startup terms": "политика конфиденциальности"
		},
		"terms of use": {
			"startup": "условия использования"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Невозможно связаться с серверами Meteo-Parapente. Пожалуйста, проверьте ваше соединение."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 дня в неделю зарезервированы для членов клуба"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Уже зарегистрированы? Нажмите, чтобы сбросить пароль"
		},
		"Become a member": {
			"contribute menu": "Стать участником",
			"popup": "Стать участником"
		},
		"Click here to learn the details": {
			"contest": "Нажмите здесь, чтобы узнать подробности"
		},
		"I am already a member": {
			"popup": "Я уже являюсь членом клуба"
		},
		"Learn more": {
			"contest": "Узнать больше"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente празднует 10-летний юбилей."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Еще не зарегистрированы? Нажмите, чтобы получить код доступа"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "По этому случаю мы организуем исключительный конкурс"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Один победитель будет выбран из числа тех, кто приобрел или продлил подписку в период с сентября прошлого года по 30 марта следующего года."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Выиграть можно: КРЫЛО ДЛЯ ПАРАПЛАНА НА ВАШ ВЫБОР!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Чтобы увидеть %{ date }, пожалуйста, войдите в систему или станьте участником."
		},
		"Win a paraglider!": {
			"contribute menu": "Выиграйте параплан!"
		}
	},
	"sl": {
		"(Kitesurf)": {
			"search result": "Kitesurf"
		},
		"(Paragliding)": {
			"search result": "Padalstvo"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "Dodaj..."
		},
		"Airspace": {
			"toggle menu": "Zračni prostor"
		},
		"All": {
			"map menu humidity": "Vse"
		},
		"B. layer": {
			"map menu updrafts": "B. plast"
		},
		"B. Layer": {
			"map menu wind": "B. plast"
		},
		"Boundary layer": {
			"map menu wind": "Spodnja plast"
		},
		"Boundary Layer": {
			"map menu updrafts": "Spodnja plast",
			"layer legend A": "Mejna plast",
			"layer legend B": "Spodnja meja"
		},
		"Ceiling": {
			"map menu updrafts": "Strop",
			"layer legend B": "Strop"
		},
		"Ceiling of b. layer": {
			"map menu wind": "Zgornja meja"
		},
		"Change password": {
			"settings menu": "Spremeni geslo"
		},
		"Clouds": {
			"map menu humidity": "Oblaki"
		},
		"Color blind": {
			"settings menu": "Barvno slep"
		},
		"debug": {
			"settings menu": "Hrošč"
		},
		"Delete": {
			"favorites menu": "Izbriši"
		},
		"experimental": {
			"settings menu": "eksperimentalno"
		},
		"Experimental features": {
			"settings menu": "eksperiment. lastnost"
		},
		"Favorites": {
			"menu title": "Priljubljene"
		},
		"Ground": {
			"map menu wind": "Tla",
			"map menu temperature": "Zemlja"
		},
		"Help us translate!": {
			"settings menu": "Pomagaj nam prevajati!"
		},
		"High": {
			"map menu humidity": "Visok"
		},
		"Humidity": {
			"map menu humidity": "Vlaga"
		},
		"Interpolation": {
			"toggle menu": "Inverzija"
		},
		"Language": {
			"settings menu": "Jezik"
		},
		"Login": {
			"login menu": "Vpis"
		},
		"Logout": {
			"settings menu": "Izpis"
		},
		"Low": {
			"map menu humidity": "Nizko"
		},
		"Medium": {
			"map menu humidity": "Srednje"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "Premakni na vrh"
		},
		"News": {
			"news menu": "Novice"
		},
		"News!": {
			"news menu": "Novice!"
		},
		"No data for this place": {
			"windgram view": "Ni podatkov za ta prostor"
		},
		"Open": {
			"favorites menu": "Odpri"
		},
		"Pressure": {
			"map menu wind": "Pritisk",
			"layer legend A": "Tlak"
		},
		"Rain": {
			"map menu humidity": "Dež"
		},
		"Rename": {
			"favorites menu": "Preimenuj"
		},
		"Reset all settings": {
			"settings menu": "Resetiraj natavitve"
		},
		"Sea level": {
			"map menu wind": "Gladina morja"
		},
		"Set as homepage": {
			"favorites menu": "Nastavi kot domačo stran"
		},
		"Settings": {
			"settings menu": "Nastavitve"
		},
		"Shearing": {
			"map menu updrafts": "Deljenje",
			"layer legend B": "Deljenje"
		},
		"Sounding": {
			"windgram tab": "Oglasitev"
		},
		"Temperature": {
			"map menu temperature": "Temperatura",
			"layer legend A": "Temperatura"
		},
		"Thermals": {
			"map menu updrafts": "Termika",
			"layer legend A": "Termika"
		},
		"Thickness": {
			"map menu updrafts": "Debelina",
			"layer legend B": "Debelina"
		},
		"Updrafts": {
			"map menu updrafts": "Posodobitve"
		},
		"Velocity": {
			"map menu updrafts": "Hitrost",
			"layer legend B": "Hitrost"
		},
		"Vertical motion": {
			"map menu updrafts": "Dviganje",
			"": "Navpično gibanje"
		},
		"Wind": {
			"map menu wind": "Veter",
			"layer legend A": "Veter"
		},
		"Wind Shear": {
			"map menu wind": "Rotor",
			"layer legend A": "Rotor"
		},
		"Windgram": {
			"windgram tab": "Prikaz"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "Topografija"
		},
		"Model": {
			"layer legend B": "Shema"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "Dimenziranje"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "Površina"
		},
		"Ceiling of BL": {
			"layer legend B": "Strop od BL"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "Pokritos z oblaki"
		},
		"Low altitude": {
			"layer legend B": "Nizko"
		},
		"High altitude": {
			"layer legend B": "Visoko"
		},
		"Medium altitude": {
			"layer legend B": "Srednja višina"
		},
		"All altitudes": {
			"layer legend B": "Vse višine"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m nad tlemi"
		},
		"Vertical Motion": {
			"layer legend A": "Vertikalno gibanje"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "Padavine"
		},
		"1 hour": {
			"layer legend B": "1 uro"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "Povprečna gladina morja"
		},
		"Enter a name": {
			"new favorite prompt": "Poimenuj"
		},
		"Enter the new name": {
			"new favorite prompt": "Poimenuj z novim imenom"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "Prepiši najljubše ime?"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "Izbriši najljubše ime?"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "Ste prepričani, da želite ponastaviti vse?\nVSE VAŠE NASTAVITVE IN PRILJUBLJENI BODO IZBRANI!"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Hitrejše vremenske napovedi | \nMeteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "Pomoč"
		},
		"Install now": {
			"version check": "Naloži"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "Hitrejše vremenske napovedi"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente zahteva posodobitev"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente je sedaj mobilna!\nHitrejše vremenske napovedi, posebej zasnovane za letenje in jadralno padalstvo."
		},
		"Mobile app": "Mobilna aplikacija",
		"No internet connexion": "Brez internetne povezave",
		"Community": "Skupnost",
		"Day selection": "Izberi dan",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "Sevanje",
		"Sun": "Sonce",
		"Update": "Posodobitev",
		"Wind unit": "Moč vetra",
		"An error has occured. Please try again.": {
			"popup": "Zgodila se je napaka. Poskusite znova."
		},
		"Click here to renew.": {
			"login popup": "Kliknite tukaj za obnovitev"
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "Kliknite povezavo znotraj e-poštnega naslova, da spremenite geslo."
		},
		"Close": {
			"popup": "Zapri",
			"general": "Zapri"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "E-naslov se ne ujema ali je napačn"
		},
		"Error! Bad login or password": {
			"login popup": "Nepravilno ime ali geslo!"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "Napaka! Potekla vam je možnost dostopa. "
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "Če ste uporabnik, boste prejeli e-pošto. "
		},
		"OK": {
			"popup": "OK",
			"general": "V REDU"
		},
		"One last step...": {
			"password popup": "Zadnji korak ..."
		},
		"Passwords must be the same": {
			"password popup": "Gesla morajo biti ista. "
		},
		"Please log-in": {
			"login popup": "Prijavite se"
		},
		"Private device − stay connected": {
			"login popup": "Zasebna naprava-ostanite povezani. "
		},
		"Read more…": {
			"contribute popup": "Preberi več"
		},
		"Reset your password": {
			"password popup": "Obnovi geslo"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "Nekateri ponudniki, kot so Orange, GMX in Hotmail, včasih blokirajo naša e-poštna sporočila. Če ne boste prejeli ničesar, se obrnite na podporo @ meteo & # paramount"
		},
		"Welcome!": {
			"login popup": "Dobrodošli"
		},
		"Same as device": {
			"timezone menu": "Enako kot naprava"
		},
		"Timezone": {
			"settings menu": "Časovni pas"
		},
		"XC Planner": {
			"toggle menu": "Načrtovalec XC"
		},
		"Multiplier": {
			"xc planner": "Multiplikator"
		},
		"Points": {
			"xc planner": "Točke"
		},
		"Duration": {
			"xc planner": "Trajanje"
		},
		"Speed": {
			"xc planner": "Hitrost"
		},
		"Close flight": {
			"xc planner": "Bližnji let"
		},
		"Share": {
			"xc planner": "Delite"
		},
		"Download": {
			"xc planner": "Prenesi",
			"general": "Prenesi"
		},
		"Preferences": {
			"xc planner": "Nastavitve"
		},
		"Reset": {
			"xc planner": "Ponastavitev",
			"general": "Ponastavitev"
		},
		"About": {
			"xc planner": "O"
		},
		"Exit Fullscreen": {
			"toggle menu": "Izhod za celozaslonsko prikazovanje"
		},
		"Fullscreen": {
			"toggle menu": "Celozaslonski zaslon"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "Načrtovalnik XC je eksperimentalna funkcija.\nNa voljo je samo z računalnika na spletni strani meteo-parapente.com."
		},
		"Cancel": {
			"general": "Prekliči"
		},
		"Yes": {
			"general": "Da"
		},
		"No": {
			"general": "Ne"
		},
		"Save": {
			"general": "Shrani"
		},
		"Continue": {
			"general": "Nadaljuj"
		},
		"Original version": {
			"xc planner": "Izvirna različica"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "S Tomovim dovoljenjem je bil močno spremenjen, da deluje v Meteo-Parapente. Hvala!"
		},
		"League": {
			"xc planner": "Liga"
		},
		"Distance units": {
			"xc planner": "Enote razdalje"
		},
		"Altitude units": {
			"xc planner": "Enote nadmorske višine"
		},
		"Coordinates format": {
			"xc planner": "Oblika koordinat"
		},
		"Turnpoint details": {
			"xc planner": "Podrobnosti o točki obrata"
		},
		"Format": {
			"xc planner": "Format"
		},
		"Route name": {
			"xc planner": "Ime poti"
		},
		"Waypoint prefix": {
			"xc planner": "Predpona točke poti"
		},
		"Lien": {
			"xc planner": "Povezava"
		},
		"Paste link in email or IM": {
			"xc planner": "Prilepite povezavo v e-pošto ali IM"
		},
		"Static image": {
			"xc planner": "Statična slika"
		},
		"Open with XCTrack": {
			"xc planner": "Odprite s programom XCTrack"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "Skupna raba z LocToMe: nastavite kot privzeto pot"
		},
		"Go to": {
			"general": "Pojdi na"
		},
		"Error! Please try again later": {
			"update modal": "Napaka! Prosimo, poskusite znova pozneje"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "Pritisnite Ponastavi, če želite trajno ponastaviti svojo pot, pritisnite Prekliči, če želite ohraniti svojo pot."
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "Tukaj je vaša koda za dostop. Prosimo, da jo varno shranite."
		},
		"Password:": {
			"contribute popup": "Geslo:"
		},
		"Thank you!": {
			"contribute popup": "Hvala!"
		},
		"Username:": {
			"contribute popup": "Uporabniško ime:"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesecev Standard - %{currency} %{pricing} / mesec"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesecev Študent - %{currency} %{pricing} / mesec"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12 mesecev Podpornik - %{currency} %{pricing} / mesec"
		},
		"Tour of Europe": {
			"tab": "Turneja po Evropi"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "Vsak dan uživajte v najboljših napovedih. Meteo-Parapente lahko obstaja zaradi vas!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "Pridobite brezplačen vstop na lokalna vremenska usposabljanja in srečanja uporabnikov."
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "Pridružite se klubu sodelavcev Meteo-Parapente"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "Enkrat na mesec se srečamo in se pogovorimo o novih funkcijah in izboljšavah."
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente lahko obstaja po vaši zaslugi!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "Moj cilj je zagotoviti kakovostno orodje, ki bo dostopno vsem pilotom."
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "Podprite razvoj orodja kakovosti, ki bo na voljo vsem pilotom."
		},
		"and to the": {
			"startup terms": "in na"
		},
		"By using this application, you agree to the": {
			"startup terms": "Z uporabo te aplikacije se strinjate z"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "Če se težava nadaljuje, se obrnite na support@meteo-parapente.com."
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente ne uporablja piškotkov za sledenje"
		},
		"privacy policy": {
			"startup terms": "politika zasebnosti"
		},
		"terms of use": {
			"startup": "pogoji uporabe"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "Ni mogoče doseči strežnikov Meteo-Parapente. Preverite povezavo."
		},
		"2 days a week are reserved to members": {
			"private popup": "2 dneva na teden sta rezervirana za člane"
		},
		"Already a member? Click to reset your password": {
			"login popup": "Ste že član? Kliknite za ponastavitev gesla"
		},
		"Become a member": {
			"contribute menu": "Postanite član",
			"popup": "Postanite član"
		},
		"Click here to learn the details": {
			"contest": "Kliknite tukaj in se seznanite s podrobnostmi"
		},
		"I am already a member": {
			"popup": "Že sem član"
		},
		"Learn more": {
			"contest": "Preberite več"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente praznuje 10. obletnico delovanja."
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "Še niste član? Kliknite in pridobite kodo za dostop"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "Ob tej priložnosti organiziramo izjemno tekmovanje"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "Izmed vseh, ki so med lanskim septembrom in 30. marcem kupili ali podaljšali naročnino, bomo izžrebali enega zmagovalca."
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "Za zmago: KRILO JADRALNEGA PADALA PO LASTNI IZBIRI!!!"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "Če si želite ogledati %{ date }, se prijavite ali postanite član."
		},
		"Win a paraglider!": {
			"contribute menu": "Osvojite jadralno padalo!"
		}
	},
	"zh-hk": {
		"(Kitesurf)": {
			"search result": "(風箏滑水)"
		},
		"(Paragliding)": {
			"search result": "(滑翔傘)"
		},
		"1h": {
			"map menu humidity": "1h"
		},
		"Add new…": {
			"favorites menu": "新增..."
		},
		"Airspace": {
			"toggle menu": "空域"
		},
		"All": {
			"map menu humidity": "所有"
		},
		"B. layer": {
			"map menu updrafts": "邊界層"
		},
		"B. Layer": {
			"map menu wind": "邊界層"
		},
		"Boundary layer": {
			"map menu wind": "邊界層"
		},
		"Boundary Layer": {
			"map menu updrafts": "邊界層",
			"layer legend A": "邊界層",
			"layer legend B": "邊界層"
		},
		"Ceiling": {
			"map menu updrafts": "頂部",
			"layer legend B": "頂部"
		},
		"Ceiling of b. layer": {
			"map menu wind": "邊界層頂部"
		},
		"Change password": {
			"settings menu": "更改密碼"
		},
		"Clouds": {
			"map menu humidity": "雲"
		},
		"Color blind": {
			"settings menu": "顏色"
		},
		"debug": {
			"settings menu": "除錯"
		},
		"Delete": {
			"favorites menu": "刪除"
		},
		"experimental": {
			"settings menu": "測試"
		},
		"Experimental features": {
			"settings menu": "測試功能"
		},
		"Favorites": {
			"menu title": "喜愛"
		},
		"Ground": {
			"map menu wind": "地面",
			"map menu temperature": "地面"
		},
		"Help us translate!": {
			"settings menu": "幫助我們翻譯！"
		},
		"High": {
			"map menu humidity": "高"
		},
		"Humidity": {
			"map menu humidity": "濕度"
		},
		"Interpolation": {
			"toggle menu": "插值"
		},
		"Language": {
			"settings menu": "語言"
		},
		"Login": {
			"login menu": "登入"
		},
		"Logout": {
			"settings menu": "登出"
		},
		"Low": {
			"map menu humidity": "低"
		},
		"Medium": {
			"map menu humidity": "中"
		},
		"Meteo Parapente": {
			"menu title": "Meteo Parapente"
		},
		"Move to top": {
			"favorites menu": "移到頂部"
		},
		"News": {
			"news menu": "新聞"
		},
		"News!": {
			"news menu": "新聞！"
		},
		"No data for this place": {
			"windgram view": "這裡沒有數據"
		},
		"Open": {
			"favorites menu": "打開"
		},
		"Pressure": {
			"map menu wind": "壓力",
			"layer legend A": "壓力"
		},
		"Rain": {
			"map menu humidity": "雨"
		},
		"Rename": {
			"favorites menu": "重新命名"
		},
		"Reset all settings": {
			"settings menu": "還原所有設定"
		},
		"Sea level": {
			"map menu wind": "海平面"
		},
		"Set as homepage": {
			"favorites menu": "設為首頁"
		},
		"Settings": {
			"settings menu": "設定"
		},
		"Shearing": {
			"map menu updrafts": "風切變",
			"layer legend B": "風切變"
		},
		"Sounding": {
			"windgram tab": "高空氣象觀測"
		},
		"Temperature": {
			"map menu temperature": "溫度",
			"layer legend A": "溫度"
		},
		"Thermals": {
			"map menu updrafts": "熱氣流",
			"layer legend A": "熱氣流"
		},
		"Thickness": {
			"map menu updrafts": "厚度",
			"layer legend B": "厚度"
		},
		"Updrafts": {
			"map menu updrafts": "更新的草案"
		},
		"Velocity": {
			"map menu updrafts": "速率",
			"layer legend B": "速率"
		},
		"Vertical motion": {
			"map menu updrafts": "垂直運動",
			"": "垂直運動"
		},
		"Wind": {
			"map menu wind": "風",
			"layer legend A": "風"
		},
		"Wind Shear": {
			"map menu wind": "風切變",
			"layer legend A": "風切變"
		},
		"Windgram": {
			"windgram tab": "風向圖"
		},
		"m MSL": {
			"layer unit": "m MSL"
		},
		"m AGL": {
			"layer unit": "m AGL"
		},
		"Topography": {
			"layer legend A": "地形圖"
		},
		"Model": {
			"layer legend B": "模式"
		},
		"m/s": {
			"layer unit": "m/s",
			"": "m/s"
		},
		"dimensionless": {
			"layer unit": "无尺寸"
		},
		"km/h": {
			"layer unit": "km/h",
			"": "km/h"
		},
		"Surface": {
			"layer legend B": "地面"
		},
		"Ceiling of BL": {
			"layer legend B": "邊界層頂部"
		},
		"%": {
			"layer unit": "%"
		},
		"Cloud cover": {
			"layer legend A": "雲覆蓋"
		},
		"Low altitude": {
			"layer legend B": "低"
		},
		"High altitude": {
			"layer legend B": "中"
		},
		"Medium altitude": {
			"layer legend B": "高"
		},
		"All altitudes": {
			"layer legend B": "所有高度"
		},
		"°C": {
			"layer unit": "°C"
		},
		"2m AGL": {
			"layer legend B": "2m AGL"
		},
		"Vertical Motion": {
			"layer legend A": "垂直運動"
		},
		"mm/h": {
			"layer unit": "mm/h"
		},
		"Precipitations": {
			"layer legend A": "降雨"
		},
		"1 hour": {
			"layer legend B": "1小時"
		},
		"hPa": {
			"layer unit": "hPa"
		},
		"Mean Sea Level": {
			"layer legend B": "平均海平面"
		},
		"Enter a name": {
			"new favorite prompt": "輸入"
		},
		"Enter the new name": {
			"new favorite prompt": "输入新的名称"
		},
		"Overwrite favorite \"%{ name }\"?": {
			"updateFavorite": "覆盖最喜欢的\"%{ name }\"？"
		},
		"Delete favorite \"%{ name }\"?": {
			"deleteFavorite": "删除喜爱的\"%{ name }\"？"
		},
		"Are you sure you want to reset everything?\nALL YOUR SETTINGS AND FAVORITES WILL BE LOST FOREVER!": {
			"resetStore": "你确定要重置一切吗？\n你的所有设置和收藏夹都将永远消失"
		},
		"Soaring weather forecasts | Meteo-Parapente.com": {
			"application title": "Soaring weather forecasts | Meteo-Parapente.com"
		},
		"Help / Contact / About": {
			"menu": "幫助/聯絡/關於"
		},
		"Install now": {
			"version check": "立即安裝"
		},
		"Meteo-Parapente Europe RASP": {
			"App Store | Application name": "Meteo-Parapente Europe RASP"
		},
		"Soaring Weather Forecasts": {
			"App Store | Short description": "天氣預測"
		},
		"Meteo-Parapente requires an update.": {
			"version check": "Meteo-Parapente需要更新"
		},
		"Meteo-Parapente is now mobile!\nSoaring Weather Forecasts specially designed for flight and paragliding.": {
			"App Store | Full description": "Meteo-Parapente现在是移动的!\n专为飞行和滑翔伞运动设计的翱翔天气预报。"
		},
		"Mobile app": "流動App",
		"No internet connexion": "沒有網絡",
		"Community": "社群",
		"Day selection": "選擇日子",
		"knots": "knots",
		"mph": "mph",
		"Radiation": "辐射",
		"Sun": "太陽",
		"Update": "更新",
		"Wind unit": "單位(風)",
		"An error has occured. Please try again.": {
			"popup": "发生了一个错误。请再试一次。"
		},
		"Click here to renew.": {
			"login popup": "点击这里更新。"
		},
		"Click on the link inside the email to change your password.": {
			"password popup": "点击邮件内的链接来更改密码。"
		},
		"Close": {
			"popup": "关闭",
			"general": "关闭"
		},
		"Emails are not the same or invalid": {
			"contribute popup": "电子邮件是不一样的或无效的"
		},
		"Error! Bad login or password": {
			"login popup": "错误!登录名或密码错误"
		},
		"Error! Your access has expired on %{ expirationDate }.": {
			"login popup": "错误!您的访问权限已于%{过期日期}过期。"
		},
		"If you are a contributor, you will receive an email.": {
			"password popup": "如果你是贡献者，你会收到一封电子邮件。"
		},
		"OK": {
			"popup": "认可",
			"general": "认可"
		},
		"One last step...": {
			"password popup": "最后一步..."
		},
		"Passwords must be the same": {
			"password popup": "密码必须是相同的"
		},
		"Please log-in": {
			"login popup": "请登录"
		},
		"Private device − stay connected": {
			"login popup": "私人设备--保持连接"
		},
		"Read more…": {
			"contribute popup": "阅读更多..."
		},
		"Reset your password": {
			"password popup": "重置您的密码"
		},
		"Some providers such as Orange, GMX and Hotmail sometimes block our emails. If you do receive nothing, please contact support@meteo&#x2011;parapente.com": {
			"password popup": "一些供应商，如Orange、GMX和Hotmail有时会阻止我们的电子邮件。如果你确实没有收到，请联系support@meteo&#x2011;parapente.com。"
		},
		"Welcome!": {
			"login popup": "欢迎你!"
		},
		"Same as device": {
			"timezone menu": "与设备相同"
		},
		"Timezone": {
			"settings menu": "时区"
		},
		"XC Planner": {
			"toggle menu": "XC规划师"
		},
		"Multiplier": {
			"xc planner": "乘法器"
		},
		"Points": {
			"xc planner": "积分"
		},
		"Duration": {
			"xc planner": "时间"
		},
		"Speed": {
			"xc planner": "速度"
		},
		"Close flight": {
			"xc planner": "近距离飞行"
		},
		"Share": {
			"xc planner": "分享"
		},
		"Download": {
			"xc planner": "下载",
			"general": "下载"
		},
		"Preferences": {
			"xc planner": "首选项"
		},
		"Reset": {
			"xc planner": "复位",
			"general": "复位"
		},
		"About": {
			"xc planner": "关于"
		},
		"Exit Fullscreen": {
			"toggle menu": "退出全屏"
		},
		"Fullscreen": {
			"toggle menu": "全屏"
		},
		"XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com": {
			"xc planner": "XC Planner是一个实验性的功能。\n它只能在电脑上使用，在meteo-parapente.com上使用。"
		},
		"Cancel": {
			"general": "取消"
		},
		"Yes": {
			"general": "是"
		},
		"No": {
			"general": "没有"
		},
		"Save": {
			"general": "拯救"
		},
		"Continue": {
			"general": "继续"
		},
		"Original version": {
			"xc planner": "原始版本"
		},
		"Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!": {
			"xc planner": "在汤姆的授权下，为了在Meteo-Parapente中工作，进行了大量的黑客攻击。谢谢你!"
		},
		"League": {
			"xc planner": "联盟"
		},
		"Distance units": {
			"xc planner": "距离单位"
		},
		"Altitude units": {
			"xc planner": "海拔单位"
		},
		"Coordinates format": {
			"xc planner": "坐标格式"
		},
		"Turnpoint details": {
			"xc planner": "转折点详情"
		},
		"Format": {
			"xc planner": "格式"
		},
		"Route name": {
			"xc planner": "路线名称"
		},
		"Waypoint prefix": {
			"xc planner": "航点前缀"
		},
		"Lien": {
			"xc planner": "链接"
		},
		"Paste link in email or IM": {
			"xc planner": "在电子邮件或即时消息中粘贴链接"
		},
		"Static image": {
			"xc planner": "静态图像"
		},
		"Open with XCTrack": {
			"xc planner": "用XCTrack打开"
		},
		"Share with LocToMe: set as default route": {
			"xc planner": "与LocToMe共享：设置为默认路线"
		},
		"Go to": {
			"general": "转到"
		},
		"Error! Please try again later": {
			"update modal": "错误!请稍后再试"
		},
		"Press Reset to reset your route permanently, press Cancel to keep you route.": {
			"xc planner": "按 \"重设 \"可以永久地重设你的路线，按 \"取消 \"可以保留你的路线。"
		},
		"Here is your access code. Please keep it safely.": {
			"contribute popup": "这是你的访问代码。请安全地保存它。"
		},
		"Password:": {
			"contribute popup": "密码。"
		},
		"Thank you!": {
			"contribute popup": "谢谢你!"
		},
		"Username:": {
			"contribute popup": "用户名。"
		},
		"12 months Standard － %{currency} %{pricing} / month": {
			"contribute popup": "12个月标准 -%{currency}%{pricing}。/月"
		},
		"12 months Student － %{currency} %{pricing} / month": {
			"contribute popup": "12个月学生 -%{currency}%{pricing}。/月"
		},
		"12 months Supporter － %{currency} %{pricing} / month": {
			"contribute popup": "12个月的支持者 -%{currency}%{pricing}。/月"
		},
		"Tour of Europe": {
			"tab": "欧洲之行"
		},
		"Enjoy the best forecasts every day. Meteo-Parapente can exist thanks to you!": {
			"contribute popup": "享受每天的最佳预报。Meteo-Parapente能够存在，要感谢你!"
		},
		"Get free entry to local weather trainings and users meetups.": {
			"contribute popup": "免费参加当地的气象培训和用户见面会。"
		},
		"Join Meteo-Parapente contributors club": {
			"contribute popup": "加入Meteo-Parapente贡献者俱乐部"
		},
		"Meet me once a month to discuss new features and improvements.": {
			"contribute popup": "每月与我见面一次，讨论新的功能和改进。"
		},
		"Meteo-Parapente can exist thanks to you!": {
			"private popup": "Meteo-Parapente能够存在，多亏了你!"
		},
		"My goal is to provide a quality tool accessible to every pilots.": {
			"contribute popup": "我的目标是提供一个每个飞行员都能使用的优质工具。"
		},
		"Support the development of a quality tool accessible to every pilots.": {
			"contribute popup": "支持开发一个每个飞行员都能使用的质量工具。"
		},
		"and to the": {
			"startup terms": "并对"
		},
		"By using this application, you agree to the": {
			"startup terms": "通过使用本应用程序，你同意"
		},
		"If the problem persists, contact support@meteo-parapente.com": {
			"startup": "如果问题仍然存在，请联系 support@meteo-parapente.com"
		},
		"Meteo-Parapente doesn't use tracking cookies": {
			"startup terms": "Meteo-Parapente不使用追踪cookies。"
		},
		"privacy policy": {
			"startup terms": "隐私政策"
		},
		"terms of use": {
			"startup": "使用条款"
		},
		"Unable to reach Meteo-Parapente servers. Please check your connection.": {
			"startup": "无法访问Meteo-Parapente服务器。请检查您的连接。"
		},
		"2 days a week are reserved to members": {
			"private popup": "每周有2天是为会员保留的"
		},
		"Already a member? Click to reset your password": {
			"login popup": "已经是会员了吗？点击重置密码"
		},
		"Become a member": {
			"contribute menu": "成为会员",
			"popup": "成为会员"
		},
		"Click here to learn the details": {
			"contest": "点击这里了解详情"
		},
		"I am already a member": {
			"popup": "我已经是一个会员了"
		},
		"Learn more": {
			"contest": "了解更多"
		},
		"Meteo-Parapente celebrates its 10th anniversary.": {
			"contest": "Meteo-Parapente庆祝其10周年。"
		},
		"Not a member yet? Click to get an access code": {
			"login popup": "还不是会员？点击获取访问代码"
		},
		"On this occasion, we are organizing an exceptional contest": {
			"contest": "值此之际，我们将组织一次特殊的比赛"
		},
		"One winner will be drawn from all those who purchased or renewed a subscription between last September and next March 30.": {
			"contest": "将从所有在去年9月至明年3月30日期间购买或续订的人中抽取一名获奖者。"
		},
		"To be won: THE PARAGLIDER WING OF YOUR CHOICE!!!": {
			"contest": "将会赢得。您所选择的滑翔伞机翼！！。"
		},
		"To see %{ date }, please login or become a member.": {
			"private popup": "要查看%{date}，请登录或成为会员。"
		},
		"Win a paraglider!": {
			"contribute menu": "赢取滑翔伞!"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/translations.json
// module id = 360
// module chunks = 1